export const citiesData = {
    "cities": [
        {
            "abbr": "AL",
            "city": "Alexander City",
            "id": 1,
            "is_region": null,
            "is_state": false,
            "lat": 32.9331,
            "long": -85.9361,
            "name": "Alexander City, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Andalusia",
            "id": 2,
            "is_region": null,
            "is_state": false,
            "lat": 31.3,
            "long": -86.483,
            "name": "Andalusia, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Anniston",
            "id": 3,
            "is_region": null,
            "is_state": false,
            "lat": 33.6611,
            "long": -85.8333,
            "name": "Anniston, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Athens",
            "id": 4,
            "is_region": null,
            "is_state": false,
            "lat": 34.7897,
            "long": -86.9694,
            "name": "Athens, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Atmore",
            "id": 5,
            "is_region": null,
            "is_state": false,
            "lat": 31.0231,
            "long": -87.4919,
            "name": "Atmore, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Auburn",
            "id": 6,
            "is_region": null,
            "is_state": false,
            "lat": 32.5978,
            "long": -85.4808,
            "name": "Auburn, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Bessemer",
            "id": 7,
            "is_region": null,
            "is_state": false,
            "lat": 33.4017,
            "long": -86.9544,
            "name": "Bessemer, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Birmingham",
            "id": 8,
            "is_region": null,
            "is_state": false,
            "lat": 33.6533,
            "long": -86.8089,
            "name": "Birmingham, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Chickasaw",
            "id": 9,
            "is_region": null,
            "is_state": false,
            "lat": 30.7647,
            "long": -88.0836,
            "name": "Chickasaw, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Clanton",
            "id": 10,
            "is_region": null,
            "is_state": false,
            "lat": 32.8397,
            "long": -86.6281,
            "name": "Clanton, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Cullman",
            "id": 11,
            "is_region": null,
            "is_state": false,
            "lat": 34.1775,
            "long": -86.8447,
            "name": "Cullman, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Decatur",
            "id": 12,
            "is_region": null,
            "is_state": false,
            "lat": 34.6058,
            "long": -86.9833,
            "name": "Decatur, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Demopolis",
            "id": 13,
            "is_region": null,
            "is_state": false,
            "lat": 32.5094,
            "long": -87.8372,
            "name": "Demopolis, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Dothan",
            "id": 14,
            "is_region": null,
            "is_state": false,
            "lat": 31.2272,
            "long": -85.4072,
            "name": "Dothan, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Enterprise",
            "id": 15,
            "is_region": null,
            "is_state": false,
            "lat": 31.3275,
            "long": -85.8444,
            "name": "Enterprise, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Eufaula",
            "id": 16,
            "is_region": null,
            "is_state": false,
            "lat": 31.8892,
            "long": -85.1536,
            "name": "Eufaula, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Florence",
            "id": 17,
            "is_region": null,
            "is_state": false,
            "lat": 34.8203,
            "long": -87.6628,
            "name": "Florence, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Fort Payne",
            "id": 18,
            "is_region": null,
            "is_state": false,
            "lat": 34.4536,
            "long": -85.7064,
            "name": "Fort Payne, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Gadsden",
            "id": 19,
            "is_region": null,
            "is_state": false,
            "lat": 34.01,
            "long": -86.0103,
            "name": "Gadsden, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Greenville",
            "id": 20,
            "is_region": null,
            "is_state": false,
            "lat": 31.8311,
            "long": -86.6275,
            "name": "Greenville, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Guntersville",
            "id": 21,
            "is_region": null,
            "is_state": false,
            "lat": 34.3481,
            "long": -86.2944,
            "name": "Guntersville, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Huntsville",
            "id": 22,
            "is_region": null,
            "is_state": false,
            "lat": 34.73,
            "long": -86.585,
            "name": "Huntsville, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Jasper",
            "id": 23,
            "is_region": null,
            "is_state": false,
            "lat": 33.8422,
            "long": -87.2772,
            "name": "Jasper, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Marion",
            "id": 24,
            "is_region": null,
            "is_state": false,
            "lat": 32.6328,
            "long": -87.3172,
            "name": "Marion, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Mobile",
            "id": 25,
            "is_region": null,
            "is_state": false,
            "lat": 30.6944,
            "long": -88.0431,
            "name": "Mobile, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Montgomery",
            "id": 26,
            "is_region": null,
            "is_state": false,
            "lat": 32.3617,
            "long": -86.2792,
            "name": "Montgomery, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Opelika",
            "id": 27,
            "is_region": null,
            "is_state": false,
            "lat": 32.6472,
            "long": -85.3894,
            "name": "Opelika, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Ozark",
            "id": 28,
            "is_region": null,
            "is_state": false,
            "lat": 31.4481,
            "long": -85.6419,
            "name": "Ozark, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Phenix City",
            "id": 29,
            "is_region": null,
            "is_state": false,
            "lat": 32.4708,
            "long": -85.0028,
            "name": "Phenix City, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Prichard",
            "id": 30,
            "is_region": null,
            "is_state": false,
            "lat": 30.7481,
            "long": -88.1003,
            "name": "Prichard, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Scottsboro",
            "id": 31,
            "is_region": null,
            "is_state": false,
            "lat": 34.6514,
            "long": -86.0425,
            "name": "Scottsboro, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Selma",
            "id": 32,
            "is_region": null,
            "is_state": false,
            "lat": 32.4164,
            "long": -87.0247,
            "name": "Selma, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Sheffield",
            "id": 33,
            "is_region": null,
            "is_state": false,
            "lat": 34.7597,
            "long": -87.6947,
            "name": "Sheffield, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Sylacauga",
            "id": 34,
            "is_region": null,
            "is_state": false,
            "lat": 33.1783,
            "long": -86.2511,
            "name": "Sylacauga, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Talladega",
            "id": 35,
            "is_region": null,
            "is_state": false,
            "lat": 33.4347,
            "long": -86.1014,
            "name": "Talladega, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Troy",
            "id": 36,
            "is_region": null,
            "is_state": false,
            "lat": 31.8089,
            "long": -85.97,
            "name": "Troy, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Tuscaloosa",
            "id": 37,
            "is_region": null,
            "is_state": false,
            "lat": 33.2067,
            "long": -87.5347,
            "name": "Tuscaloosa, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Tuscumbia",
            "id": 38,
            "is_region": null,
            "is_state": false,
            "lat": 34.7308,
            "long": -87.7028,
            "name": "Tuscumbia, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AL",
            "city": "Tuskegee",
            "id": 39,
            "is_region": null,
            "is_state": false,
            "lat": 32.4314,
            "long": -85.7067,
            "name": "Tuskegee, AL",
            "region_id": null,
            "state": "Alabama"
        },
        {
            "abbr": "AK",
            "city": "Anchorage",
            "id": 40,
            "is_region": null,
            "is_state": false,
            "lat": 61.217,
            "long": -149.9,
            "name": "Anchorage, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Cordova",
            "id": 41,
            "is_region": null,
            "is_state": false,
            "lat": 60.5436,
            "long": -145.752,
            "name": "Cordova, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Fairbanks",
            "id": 42,
            "is_region": null,
            "is_state": false,
            "lat": 64.8436,
            "long": -147.723,
            "name": "Fairbanks, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Haines",
            "id": 43,
            "is_region": null,
            "is_state": false,
            "lat": 59.2339,
            "long": -135.447,
            "name": "Haines, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Homer",
            "id": 44,
            "is_region": null,
            "is_state": false,
            "lat": 59.6431,
            "long": -151.526,
            "name": "Homer, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Juneau",
            "id": 45,
            "is_region": null,
            "is_state": false,
            "lat": 58.3014,
            "long": -134.422,
            "name": "Juneau, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Ketchikan",
            "id": 46,
            "is_region": null,
            "is_state": false,
            "lat": 55.35,
            "long": -131.673,
            "name": "Ketchikan, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Kodiak",
            "id": 47,
            "is_region": null,
            "is_state": false,
            "lat": 57.7931,
            "long": -152.394,
            "name": "Kodiak, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Kotzebue",
            "id": 48,
            "is_region": null,
            "is_state": false,
            "lat": 66.8972,
            "long": -162.586,
            "name": "Kotzebue, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Nome",
            "id": 49,
            "is_region": null,
            "is_state": false,
            "lat": 64.5039,
            "long": -165.399,
            "name": "Nome, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Palmer",
            "id": 50,
            "is_region": null,
            "is_state": false,
            "lat": 61.6019,
            "long": -149.117,
            "name": "Palmer, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Seward",
            "id": 51,
            "is_region": null,
            "is_state": false,
            "lat": 60.1244,
            "long": -149.433,
            "name": "Seward, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Sitka",
            "id": 52,
            "is_region": null,
            "is_state": false,
            "lat": 57.0516,
            "long": -135.339,
            "name": "Sitka, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Skagway",
            "id": 53,
            "is_region": null,
            "is_state": false,
            "lat": 59.4583,
            "long": -135.314,
            "name": "Skagway, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AK",
            "city": "Valdez",
            "id": 54,
            "is_region": null,
            "is_state": false,
            "lat": 61.1308,
            "long": -146.348,
            "name": "Valdez, AK",
            "region_id": null,
            "state": "Alaska"
        },
        {
            "abbr": "AZ",
            "city": "Ajo",
            "id": 55,
            "is_region": null,
            "is_state": false,
            "lat": 32.3814,
            "long": -112.869,
            "name": "Ajo, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Avondale",
            "id": 56,
            "is_region": null,
            "is_state": false,
            "lat": 33.4336,
            "long": -112.35,
            "name": "Avondale, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Bisbee",
            "id": 57,
            "is_region": null,
            "is_state": false,
            "lat": 31.4183,
            "long": -109.898,
            "name": "Bisbee, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Casa Grande",
            "id": 58,
            "is_region": null,
            "is_state": false,
            "lat": 32.8858,
            "long": -111.744,
            "name": "Casa Grande, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Chandler",
            "id": 59,
            "is_region": null,
            "is_state": false,
            "lat": 33.3,
            "long": -111.833,
            "name": "Chandler, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Clifton",
            "id": 60,
            "is_region": null,
            "is_state": false,
            "lat": 33.0406,
            "long": -109.301,
            "name": "Clifton, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Douglas",
            "id": 61,
            "is_region": null,
            "is_state": false,
            "lat": 31.345,
            "long": -109.541,
            "name": "Douglas, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Flagstaff",
            "id": 62,
            "is_region": null,
            "is_state": false,
            "lat": 35.1992,
            "long": -111.631,
            "name": "Flagstaff, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Florence",
            "id": 63,
            "is_region": null,
            "is_state": false,
            "lat": 33.0386,
            "long": -111.387,
            "name": "Florence, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Gila Bend",
            "id": 64,
            "is_region": null,
            "is_state": false,
            "lat": 32.95,
            "long": -112.725,
            "name": "Gila Bend, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Glendale",
            "id": 65,
            "is_region": null,
            "is_state": false,
            "lat": 33.5386,
            "long": -112.186,
            "name": "Glendale, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Globe",
            "id": 66,
            "is_region": null,
            "is_state": false,
            "lat": 33.3997,
            "long": -110.782,
            "name": "Globe, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Kingman",
            "id": 67,
            "is_region": null,
            "is_state": false,
            "lat": 35.2083,
            "long": -114.026,
            "name": "Kingman, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Lake Havasu City",
            "id": 68,
            "is_region": null,
            "is_state": false,
            "lat": 34.49,
            "long": -114.309,
            "name": "Lake Havasu City, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Mesa",
            "id": 69,
            "is_region": null,
            "is_state": false,
            "lat": 33.415,
            "long": -111.831,
            "name": "Mesa, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Nogales",
            "id": 70,
            "is_region": null,
            "is_state": false,
            "lat": 31.3403,
            "long": -110.934,
            "name": "Nogales, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Oraibi",
            "id": 71,
            "is_region": null,
            "is_state": false,
            "lat": 35.8764,
            "long": -110.64,
            "name": "Oraibi, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Phoenix",
            "id": 72,
            "is_region": null,
            "is_state": false,
            "lat": 33.45,
            "long": -112.067,
            "name": "Phoenix, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Prescott",
            "id": 73,
            "is_region": null,
            "is_state": false,
            "lat": 34.5417,
            "long": -112.469,
            "name": "Prescott, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Scottsdale",
            "id": 74,
            "is_region": null,
            "is_state": false,
            "lat": 33.5,
            "long": -111.933,
            "name": "Scottsdale, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Sierra Vista",
            "id": 75,
            "is_region": null,
            "is_state": false,
            "lat": 31.5456,
            "long": -110.276,
            "name": "Sierra Vista, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Tempe",
            "id": 76,
            "is_region": null,
            "is_state": false,
            "lat": 33.4128,
            "long": -111.943,
            "name": "Tempe, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Tombstone",
            "id": 77,
            "is_region": null,
            "is_state": false,
            "lat": 31.7158,
            "long": -110.065,
            "name": "Tombstone, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Tucson",
            "id": 78,
            "is_region": null,
            "is_state": false,
            "lat": 32.2217,
            "long": -110.926,
            "name": "Tucson, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Walpi",
            "id": 79,
            "is_region": null,
            "is_state": false,
            "lat": 35.8322,
            "long": -110.398,
            "name": "Walpi, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Window Rock",
            "id": 80,
            "is_region": null,
            "is_state": false,
            "lat": 35.6728,
            "long": -109.062,
            "name": "Window Rock, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Winslow",
            "id": 81,
            "is_region": null,
            "is_state": false,
            "lat": 35.0286,
            "long": -110.701,
            "name": "Winslow, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AZ",
            "city": "Yuma",
            "id": 82,
            "is_region": null,
            "is_state": false,
            "lat": 32.6922,
            "long": -114.615,
            "name": "Yuma, AZ",
            "region_id": null,
            "state": "Arizona"
        },
        {
            "abbr": "AR",
            "city": "Arkadelphia",
            "id": 83,
            "is_region": null,
            "is_state": false,
            "lat": 34.1219,
            "long": -93.0661,
            "name": "Arkadelphia, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Arkansas Post",
            "id": 84,
            "is_region": null,
            "is_state": false,
            "lat": 34.0244,
            "long": -91.3436,
            "name": "Arkansas Post, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Batesville",
            "id": 85,
            "is_region": null,
            "is_state": false,
            "lat": 35.7736,
            "long": -91.6414,
            "name": "Batesville, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Benton",
            "id": 86,
            "is_region": null,
            "is_state": false,
            "lat": 34.5708,
            "long": -92.5769,
            "name": "Benton, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Blytheville",
            "id": 87,
            "is_region": null,
            "is_state": false,
            "lat": 35.9308,
            "long": -89.9139,
            "name": "Blytheville, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Camden",
            "id": 88,
            "is_region": null,
            "is_state": false,
            "lat": 33.5708,
            "long": -92.835,
            "name": "Camden, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Conway",
            "id": 89,
            "is_region": null,
            "is_state": false,
            "lat": 35.0872,
            "long": -92.4533,
            "name": "Conway, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Crossett",
            "id": 90,
            "is_region": null,
            "is_state": false,
            "lat": 33.1247,
            "long": -91.9633,
            "name": "Crossett, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "El Dorado",
            "id": 91,
            "is_region": null,
            "is_state": false,
            "lat": 33.2136,
            "long": -92.6625,
            "name": "El Dorado, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Fayetteville",
            "id": 92,
            "is_region": null,
            "is_state": false,
            "lat": 36.0764,
            "long": -94.1608,
            "name": "Fayetteville, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Forrest City",
            "id": 93,
            "is_region": null,
            "is_state": false,
            "lat": 35.01,
            "long": -90.7886,
            "name": "Forrest City, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Fort Smith",
            "id": 94,
            "is_region": null,
            "is_state": false,
            "lat": 35.3686,
            "long": -94.3986,
            "name": "Fort Smith, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Harrison",
            "id": 95,
            "is_region": null,
            "is_state": false,
            "lat": 36.2372,
            "long": -93.1136,
            "name": "Harrison, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Helena",
            "id": 96,
            "is_region": null,
            "is_state": false,
            "lat": 34.5261,
            "long": -90.6014,
            "name": "Helena, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Hope",
            "id": 97,
            "is_region": null,
            "is_state": false,
            "lat": 33.6678,
            "long": -93.59,
            "name": "Hope, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Hot Springs",
            "id": 98,
            "is_region": null,
            "is_state": false,
            "lat": 34.4972,
            "long": -93.0553,
            "name": "Hot Springs, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Jacksonville",
            "id": 99,
            "is_region": null,
            "is_state": false,
            "lat": 34.8703,
            "long": -92.1153,
            "name": "Jacksonville, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Jonesboro",
            "id": 100,
            "is_region": null,
            "is_state": false,
            "lat": 35.8281,
            "long": -90.6942,
            "name": "Jonesboro, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Little Rock",
            "id": 101,
            "is_region": null,
            "is_state": false,
            "lat": 34.7361,
            "long": -92.3311,
            "name": "Little Rock, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Magnolia",
            "id": 102,
            "is_region": null,
            "is_state": false,
            "lat": 33.2742,
            "long": -93.2336,
            "name": "Magnolia, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Morrilton",
            "id": 103,
            "is_region": null,
            "is_state": false,
            "lat": 35.1564,
            "long": -92.7419,
            "name": "Morrilton, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Newport",
            "id": 104,
            "is_region": null,
            "is_state": false,
            "lat": 35.6119,
            "long": -91.2622,
            "name": "Newport, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "North Little Rock",
            "id": 105,
            "is_region": null,
            "is_state": false,
            "lat": 34.7808,
            "long": -92.2569,
            "name": "North Little Rock, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Osceola",
            "id": 106,
            "is_region": null,
            "is_state": false,
            "lat": 35.7022,
            "long": -89.9758,
            "name": "Osceola, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Pine Bluff",
            "id": 107,
            "is_region": null,
            "is_state": false,
            "lat": 34.217,
            "long": -92.017,
            "name": "Pine Bluff, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Rogers",
            "id": 108,
            "is_region": null,
            "is_state": false,
            "lat": 36.3294,
            "long": -94.1414,
            "name": "Rogers, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Searcy",
            "id": 109,
            "is_region": null,
            "is_state": false,
            "lat": 35.2469,
            "long": -91.7336,
            "name": "Searcy, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Stuttgart",
            "id": 110,
            "is_region": null,
            "is_state": false,
            "lat": 34.4969,
            "long": -91.5508,
            "name": "Stuttgart, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "Van Buren",
            "id": 111,
            "is_region": null,
            "is_state": false,
            "lat": 35.4444,
            "long": -94.3467,
            "name": "Van Buren, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "AR",
            "city": "West Memphis",
            "id": 112,
            "is_region": null,
            "is_state": false,
            "lat": 35.1503,
            "long": -90.1789,
            "name": "West Memphis, AR",
            "region_id": null,
            "state": "Arkansas"
        },
        {
            "abbr": "CA",
            "city": "Alameda",
            "id": 113,
            "is_region": null,
            "is_state": false,
            "lat": 37.7561,
            "long": -122.274,
            "name": "Alameda, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Alhambra",
            "id": 114,
            "is_region": null,
            "is_state": false,
            "lat": 34.0819,
            "long": -118.135,
            "name": "Alhambra, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Anaheim",
            "id": 115,
            "is_region": null,
            "is_state": false,
            "lat": 33.8361,
            "long": -117.89,
            "name": "Anaheim, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Antioch",
            "id": 116,
            "is_region": null,
            "is_state": false,
            "lat": 38.005,
            "long": -121.806,
            "name": "Antioch, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Arcadia",
            "id": 117,
            "is_region": null,
            "is_state": false,
            "lat": 34.1328,
            "long": -118.036,
            "name": "Arcadia, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Bakersfield",
            "id": 118,
            "is_region": null,
            "is_state": false,
            "lat": 35.367,
            "long": -119.017,
            "name": "Bakersfield, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Barstow",
            "id": 119,
            "is_region": null,
            "is_state": false,
            "lat": 34.9,
            "long": -117.017,
            "name": "Barstow, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Belmont",
            "id": 120,
            "is_region": null,
            "is_state": false,
            "lat": 37.5181,
            "long": -122.292,
            "name": "Belmont, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Berkeley",
            "id": 121,
            "is_region": null,
            "is_state": false,
            "lat": 37.8717,
            "long": -122.273,
            "name": "Berkeley, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Beverly Hills",
            "id": 122,
            "is_region": null,
            "is_state": false,
            "lat": 34.0731,
            "long": -118.399,
            "name": "Beverly Hills, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Brea",
            "id": 123,
            "is_region": null,
            "is_state": false,
            "lat": 33.9233,
            "long": -117.889,
            "name": "Brea, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Buena Park",
            "id": 124,
            "is_region": null,
            "is_state": false,
            "lat": 33.8561,
            "long": -118.004,
            "name": "Buena Park, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Burbank",
            "id": 125,
            "is_region": null,
            "is_state": false,
            "lat": 34.1803,
            "long": -118.328,
            "name": "Burbank, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Calexico",
            "id": 126,
            "is_region": null,
            "is_state": false,
            "lat": 32.6789,
            "long": -115.499,
            "name": "Calexico, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Calistoga",
            "id": 127,
            "is_region": null,
            "is_state": false,
            "lat": 38.5814,
            "long": -122.583,
            "name": "Calistoga, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Carlsbad",
            "id": 128,
            "is_region": null,
            "is_state": false,
            "lat": 33.1219,
            "long": -117.297,
            "name": "Carlsbad, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Carmel",
            "id": 129,
            "is_region": null,
            "is_state": false,
            "lat": 36.5553,
            "long": -121.923,
            "name": "Carmel, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Chico",
            "id": 130,
            "is_region": null,
            "is_state": false,
            "lat": 39.74,
            "long": -121.836,
            "name": "Chico, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Chula Vista",
            "id": 131,
            "is_region": null,
            "is_state": false,
            "lat": 32.6278,
            "long": -117.048,
            "name": "Chula Vista, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Claremont",
            "id": 132,
            "is_region": null,
            "is_state": false,
            "lat": 34.11,
            "long": -117.72,
            "name": "Claremont, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Compton",
            "id": 133,
            "is_region": null,
            "is_state": false,
            "lat": 33.8967,
            "long": -118.225,
            "name": "Compton, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Concord",
            "id": 134,
            "is_region": null,
            "is_state": false,
            "lat": 37.9781,
            "long": -122.031,
            "name": "Concord, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Corona",
            "id": 135,
            "is_region": null,
            "is_state": false,
            "lat": 33.867,
            "long": -117.567,
            "name": "Corona, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Coronado",
            "id": 136,
            "is_region": null,
            "is_state": false,
            "lat": 32.6781,
            "long": -117.173,
            "name": "Coronado, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Costa Mesa",
            "id": 137,
            "is_region": null,
            "is_state": false,
            "lat": 33.665,
            "long": -117.912,
            "name": "Costa Mesa, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Culver City",
            "id": 138,
            "is_region": null,
            "is_state": false,
            "lat": 34.0078,
            "long": -118.401,
            "name": "Culver City, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Daly City",
            "id": 139,
            "is_region": null,
            "is_state": false,
            "lat": 37.6864,
            "long": -122.468,
            "name": "Daly City, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Davis",
            "id": 140,
            "is_region": null,
            "is_state": false,
            "lat": 38.5539,
            "long": -121.738,
            "name": "Davis, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Downey",
            "id": 141,
            "is_region": null,
            "is_state": false,
            "lat": 33.9381,
            "long": -118.131,
            "name": "Downey, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "El Centro",
            "id": 142,
            "is_region": null,
            "is_state": false,
            "lat": 32.8,
            "long": -115.567,
            "name": "El Centro, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "El Cerrito",
            "id": 143,
            "is_region": null,
            "is_state": false,
            "lat": 37.9158,
            "long": -122.312,
            "name": "El Cerrito, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "El Monte",
            "id": 144,
            "is_region": null,
            "is_state": false,
            "lat": 34.0733,
            "long": -118.027,
            "name": "El Monte, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Escondido",
            "id": 145,
            "is_region": null,
            "is_state": false,
            "lat": 33.1247,
            "long": -117.081,
            "name": "Escondido, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Eureka",
            "id": 146,
            "is_region": null,
            "is_state": false,
            "lat": 40.8019,
            "long": -124.164,
            "name": "Eureka, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Fairfield",
            "id": 147,
            "is_region": null,
            "is_state": false,
            "lat": 38.2578,
            "long": -122.054,
            "name": "Fairfield, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Fontana",
            "id": 148,
            "is_region": null,
            "is_state": false,
            "lat": 34.1,
            "long": -117.467,
            "name": "Fontana, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Fremont",
            "id": 149,
            "is_region": null,
            "is_state": false,
            "lat": 37.5483,
            "long": -121.989,
            "name": "Fremont, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Fresno",
            "id": 150,
            "is_region": null,
            "is_state": false,
            "lat": 36.75,
            "long": -119.767,
            "name": "Fresno, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Fullerton",
            "id": 151,
            "is_region": null,
            "is_state": false,
            "lat": 33.88,
            "long": -117.929,
            "name": "Fullerton, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Garden Grove",
            "id": 152,
            "is_region": null,
            "is_state": false,
            "lat": 33.7789,
            "long": -117.96,
            "name": "Garden Grove, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Glendale",
            "id": 153,
            "is_region": null,
            "is_state": false,
            "lat": 34.1461,
            "long": -118.255,
            "name": "Glendale, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Hayward",
            "id": 154,
            "is_region": null,
            "is_state": false,
            "lat": 37.6688,
            "long": -122.081,
            "name": "Hayward, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Hollywood",
            "id": 155,
            "is_region": null,
            "is_state": false,
            "lat": 34.1,
            "long": -118.333,
            "name": "Hollywood, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Huntington Beach",
            "id": 156,
            "is_region": null,
            "is_state": false,
            "lat": 33.6928,
            "long": -118.0,
            "name": "Huntington Beach, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Indio",
            "id": 157,
            "is_region": null,
            "is_state": false,
            "lat": 33.7206,
            "long": -116.216,
            "name": "Indio, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Inglewood",
            "id": 158,
            "is_region": null,
            "is_state": false,
            "lat": 33.9575,
            "long": -118.346,
            "name": "Inglewood, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Irvine",
            "id": 159,
            "is_region": null,
            "is_state": false,
            "lat": 33.6694,
            "long": -117.823,
            "name": "Irvine, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "La Habra",
            "id": 160,
            "is_region": null,
            "is_state": false,
            "lat": 33.9319,
            "long": -117.946,
            "name": "La Habra, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Laguna Beach",
            "id": 161,
            "is_region": null,
            "is_state": false,
            "lat": 33.5314,
            "long": -117.769,
            "name": "Laguna Beach, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Lancaster",
            "id": 162,
            "is_region": null,
            "is_state": false,
            "lat": 34.683,
            "long": -118.15,
            "name": "Lancaster, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Livermore",
            "id": 163,
            "is_region": null,
            "is_state": false,
            "lat": 37.6819,
            "long": -121.768,
            "name": "Livermore, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Lodi",
            "id": 164,
            "is_region": null,
            "is_state": false,
            "lat": 38.1289,
            "long": -121.281,
            "name": "Lodi, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Lompoc",
            "id": 165,
            "is_region": null,
            "is_state": false,
            "lat": 34.6461,
            "long": -120.46,
            "name": "Lompoc, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Long Beach",
            "id": 166,
            "is_region": null,
            "is_state": false,
            "lat": 33.7683,
            "long": -118.196,
            "name": "Long Beach, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Los Angeles",
            "id": 167,
            "is_region": null,
            "is_state": false,
            "lat": 34.05,
            "long": -118.25,
            "name": "Los Angeles, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Malibu",
            "id": 168,
            "is_region": null,
            "is_state": false,
            "lat": 34.03,
            "long": -118.75,
            "name": "Malibu, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Martinez",
            "id": 169,
            "is_region": null,
            "is_state": false,
            "lat": 38.0194,
            "long": -122.134,
            "name": "Martinez, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Marysville",
            "id": 170,
            "is_region": null,
            "is_state": false,
            "lat": 39.15,
            "long": -121.583,
            "name": "Marysville, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Menlo Park",
            "id": 171,
            "is_region": null,
            "is_state": false,
            "lat": 37.4528,
            "long": -122.183,
            "name": "Menlo Park, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Merced",
            "id": 172,
            "is_region": null,
            "is_state": false,
            "lat": 37.3,
            "long": -120.483,
            "name": "Merced, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Modesto",
            "id": 173,
            "is_region": null,
            "is_state": false,
            "lat": 37.6614,
            "long": -120.994,
            "name": "Modesto, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Monterey",
            "id": 174,
            "is_region": null,
            "is_state": false,
            "lat": 36.6031,
            "long": -121.894,
            "name": "Monterey, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Mountain View",
            "id": 175,
            "is_region": null,
            "is_state": false,
            "lat": 37.3894,
            "long": -122.082,
            "name": "Mountain View, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Needles",
            "id": 176,
            "is_region": null,
            "is_state": false,
            "lat": 34.8481,
            "long": -114.614,
            "name": "Needles, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Newport Beach",
            "id": 177,
            "is_region": null,
            "is_state": false,
            "lat": 33.6167,
            "long": -117.897,
            "name": "Newport Beach, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Norwalk",
            "id": 178,
            "is_region": null,
            "is_state": false,
            "lat": 33.9069,
            "long": -118.083,
            "name": "Norwalk, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Novato",
            "id": 179,
            "is_region": null,
            "is_state": false,
            "lat": 38.1075,
            "long": -122.57,
            "name": "Novato, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Oakland",
            "id": 180,
            "is_region": null,
            "is_state": false,
            "lat": 37.8044,
            "long": -122.271,
            "name": "Oakland, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Oceanside",
            "id": 181,
            "is_region": null,
            "is_state": false,
            "lat": 33.2117,
            "long": -117.326,
            "name": "Oceanside, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Ojai",
            "id": 182,
            "is_region": null,
            "is_state": false,
            "lat": 34.4492,
            "long": -119.247,
            "name": "Ojai, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Ontario",
            "id": 183,
            "is_region": null,
            "is_state": false,
            "lat": 34.0528,
            "long": -117.628,
            "name": "Ontario, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Orange",
            "id": 184,
            "is_region": null,
            "is_state": false,
            "lat": 33.8031,
            "long": -117.832,
            "name": "Orange, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Oroville",
            "id": 185,
            "is_region": null,
            "is_state": false,
            "lat": 39.517,
            "long": -121.55,
            "name": "Oroville, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Oxnard",
            "id": 186,
            "is_region": null,
            "is_state": false,
            "lat": 34.1914,
            "long": -119.183,
            "name": "Oxnard, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Pacific Grove",
            "id": 187,
            "is_region": null,
            "is_state": false,
            "lat": 36.6178,
            "long": -121.917,
            "name": "Pacific Grove, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Palm Springs",
            "id": 188,
            "is_region": null,
            "is_state": false,
            "lat": 33.8303,
            "long": -116.545,
            "name": "Palm Springs, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Palmdale",
            "id": 189,
            "is_region": null,
            "is_state": false,
            "lat": 34.5811,
            "long": -118.101,
            "name": "Palmdale, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Palo Alto",
            "id": 190,
            "is_region": null,
            "is_state": false,
            "lat": 37.4292,
            "long": -122.138,
            "name": "Palo Alto, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Pasadena",
            "id": 191,
            "is_region": null,
            "is_state": false,
            "lat": 34.1561,
            "long": -118.132,
            "name": "Pasadena, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Petaluma",
            "id": 192,
            "is_region": null,
            "is_state": false,
            "lat": 38.2458,
            "long": -122.631,
            "name": "Petaluma, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Pomona",
            "id": 193,
            "is_region": null,
            "is_state": false,
            "lat": 34.0608,
            "long": -117.756,
            "name": "Pomona, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Port Hueneme",
            "id": 194,
            "is_region": null,
            "is_state": false,
            "lat": 34.1603,
            "long": -119.194,
            "name": "Port Hueneme, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Rancho Cucamonga",
            "id": 195,
            "is_region": null,
            "is_state": false,
            "lat": 34.1233,
            "long": -117.579,
            "name": "Rancho Cucamonga, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Red Bluff",
            "id": 196,
            "is_region": null,
            "is_state": false,
            "lat": 40.1767,
            "long": -122.238,
            "name": "Red Bluff, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Redding",
            "id": 197,
            "is_region": null,
            "is_state": false,
            "lat": 40.583,
            "long": -122.367,
            "name": "Redding, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Redlands",
            "id": 198,
            "is_region": null,
            "is_state": false,
            "lat": 34.0547,
            "long": -117.183,
            "name": "Redlands, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Redondo Beach",
            "id": 199,
            "is_region": null,
            "is_state": false,
            "lat": 33.8581,
            "long": -118.379,
            "name": "Redondo Beach, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Redwood City",
            "id": 200,
            "is_region": null,
            "is_state": false,
            "lat": 37.4828,
            "long": -122.236,
            "name": "Redwood City, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Richmond",
            "id": 201,
            "is_region": null,
            "is_state": false,
            "lat": 37.9358,
            "long": -122.348,
            "name": "Richmond, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Riverside",
            "id": 202,
            "is_region": null,
            "is_state": false,
            "lat": 33.9481,
            "long": -117.396,
            "name": "Riverside, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Roseville",
            "id": 203,
            "is_region": null,
            "is_state": false,
            "lat": 38.7525,
            "long": -121.289,
            "name": "Roseville, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Sacramento",
            "id": 204,
            "is_region": null,
            "is_state": false,
            "lat": 38.5556,
            "long": -121.469,
            "name": "Sacramento, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Salinas",
            "id": 205,
            "is_region": null,
            "is_state": false,
            "lat": 36.6778,
            "long": -121.656,
            "name": "Salinas, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Bernardino",
            "id": 206,
            "is_region": null,
            "is_state": false,
            "lat": 34.1,
            "long": -117.3,
            "name": "San Bernardino, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Clemente",
            "id": 207,
            "is_region": null,
            "is_state": false,
            "lat": 33.4378,
            "long": -117.62,
            "name": "San Clemente, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Diego",
            "id": 208,
            "is_region": null,
            "is_state": false,
            "lat": 32.715,
            "long": -117.162,
            "name": "San Diego, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Fernando",
            "id": 209,
            "is_region": null,
            "is_state": false,
            "lat": 34.2872,
            "long": -118.439,
            "name": "San Fernando, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Francisco",
            "id": 210,
            "is_region": null,
            "is_state": false,
            "lat": 37.783,
            "long": -122.417,
            "name": "San Francisco, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Gabriel",
            "id": 211,
            "is_region": null,
            "is_state": false,
            "lat": 34.1028,
            "long": -118.1,
            "name": "San Gabriel, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Jose",
            "id": 212,
            "is_region": null,
            "is_state": false,
            "lat": 37.333,
            "long": -121.9,
            "name": "San Jose, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Juan Capistrano",
            "id": 213,
            "is_region": null,
            "is_state": false,
            "lat": 33.4994,
            "long": -117.662,
            "name": "San Juan Capistrano, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Leandro",
            "id": 214,
            "is_region": null,
            "is_state": false,
            "lat": 37.725,
            "long": -122.156,
            "name": "San Leandro, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Luis Obispo",
            "id": 215,
            "is_region": null,
            "is_state": false,
            "lat": 35.2742,
            "long": -120.663,
            "name": "San Luis Obispo, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Marino",
            "id": 216,
            "is_region": null,
            "is_state": false,
            "lat": 34.1228,
            "long": -118.113,
            "name": "San Marino, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Mateo",
            "id": 217,
            "is_region": null,
            "is_state": false,
            "lat": 37.5542,
            "long": -122.313,
            "name": "San Mateo, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Pedro",
            "id": 218,
            "is_region": null,
            "is_state": false,
            "lat": 33.74,
            "long": -118.29,
            "name": "San Pedro, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Rafael",
            "id": 219,
            "is_region": null,
            "is_state": false,
            "lat": 37.9736,
            "long": -122.531,
            "name": "San Rafael, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "San Simeon",
            "id": 220,
            "is_region": null,
            "is_state": false,
            "lat": 35.6439,
            "long": -121.19,
            "name": "San Simeon, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Santa Ana",
            "id": 221,
            "is_region": null,
            "is_state": false,
            "lat": 33.7408,
            "long": -117.881,
            "name": "Santa Ana, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Santa Barbara",
            "id": 222,
            "is_region": null,
            "is_state": false,
            "lat": 34.417,
            "long": -119.7,
            "name": "Santa Barbara, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Santa Clara",
            "id": 223,
            "is_region": null,
            "is_state": false,
            "lat": 37.3544,
            "long": -121.969,
            "name": "Santa Clara, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Santa Clarita",
            "id": 224,
            "is_region": null,
            "is_state": false,
            "lat": 34.4167,
            "long": -118.506,
            "name": "Santa Clarita, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Santa Cruz",
            "id": 225,
            "is_region": null,
            "is_state": false,
            "lat": 36.9719,
            "long": -122.026,
            "name": "Santa Cruz, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Santa Monica",
            "id": 226,
            "is_region": null,
            "is_state": false,
            "lat": 34.0219,
            "long": -118.481,
            "name": "Santa Monica, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Santa Rosa",
            "id": 227,
            "is_region": null,
            "is_state": false,
            "lat": 38.4486,
            "long": -122.705,
            "name": "Santa Rosa, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Sausalito",
            "id": 228,
            "is_region": null,
            "is_state": false,
            "lat": 37.8592,
            "long": -122.485,
            "name": "Sausalito, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Simi Valley",
            "id": 229,
            "is_region": null,
            "is_state": false,
            "lat": 34.2711,
            "long": -118.739,
            "name": "Simi Valley, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Sonoma",
            "id": 230,
            "is_region": null,
            "is_state": false,
            "lat": 38.2889,
            "long": -122.459,
            "name": "Sonoma, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "South San Francisco",
            "id": 231,
            "is_region": null,
            "is_state": false,
            "lat": 37.6561,
            "long": -122.426,
            "name": "South San Francisco, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Stockton",
            "id": 232,
            "is_region": null,
            "is_state": false,
            "lat": 37.9756,
            "long": -121.301,
            "name": "Stockton, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Sunnyvale",
            "id": 233,
            "is_region": null,
            "is_state": false,
            "lat": 37.3711,
            "long": -122.037,
            "name": "Sunnyvale, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Susanville",
            "id": 234,
            "is_region": null,
            "is_state": false,
            "lat": 40.4164,
            "long": -120.653,
            "name": "Susanville, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Thousand Oaks",
            "id": 235,
            "is_region": null,
            "is_state": false,
            "lat": 34.1894,
            "long": -118.875,
            "name": "Thousand Oaks, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Torrance",
            "id": 236,
            "is_region": null,
            "is_state": false,
            "lat": 33.8347,
            "long": -118.341,
            "name": "Torrance, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Turlock",
            "id": 237,
            "is_region": null,
            "is_state": false,
            "lat": 37.5058,
            "long": -120.849,
            "name": "Turlock, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Ukiah",
            "id": 238,
            "is_region": null,
            "is_state": false,
            "lat": 39.1503,
            "long": -123.208,
            "name": "Ukiah, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Vallejo",
            "id": 239,
            "is_region": null,
            "is_state": false,
            "lat": 38.1131,
            "long": -122.236,
            "name": "Vallejo, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Ventura",
            "id": 240,
            "is_region": null,
            "is_state": false,
            "lat": 34.275,
            "long": -119.228,
            "name": "Ventura, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Victorville",
            "id": 241,
            "is_region": null,
            "is_state": false,
            "lat": 34.5361,
            "long": -117.291,
            "name": "Victorville, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Visalia",
            "id": 242,
            "is_region": null,
            "is_state": false,
            "lat": 36.317,
            "long": -119.3,
            "name": "Visalia, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Walnut Creek",
            "id": 243,
            "is_region": null,
            "is_state": false,
            "lat": 37.9064,
            "long": -122.065,
            "name": "Walnut Creek, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Watts",
            "id": 244,
            "is_region": null,
            "is_state": false,
            "lat": 33.9417,
            "long": -118.242,
            "name": "Watts, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "West Covina",
            "id": 245,
            "is_region": null,
            "is_state": false,
            "lat": 34.0567,
            "long": -117.919,
            "name": "West Covina, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Whittier",
            "id": 246,
            "is_region": null,
            "is_state": false,
            "lat": 33.9656,
            "long": -118.024,
            "name": "Whittier, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Woodland",
            "id": 247,
            "is_region": null,
            "is_state": false,
            "lat": 38.6786,
            "long": -121.773,
            "name": "Woodland, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Yorba Linda",
            "id": 248,
            "is_region": null,
            "is_state": false,
            "lat": 33.8885,
            "long": -117.813,
            "name": "Yorba Linda, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CA",
            "city": "Yuba City",
            "id": 249,
            "is_region": null,
            "is_state": false,
            "lat": 39.1347,
            "long": -121.626,
            "name": "Yuba City, CA",
            "region_id": null,
            "state": "California"
        },
        {
            "abbr": "CO",
            "city": "Alamosa",
            "id": 250,
            "is_region": null,
            "is_state": false,
            "lat": 37.475,
            "long": -105.875,
            "name": "Alamosa, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Aspen",
            "id": 251,
            "is_region": null,
            "is_state": false,
            "lat": 39.1923,
            "long": -106.824,
            "name": "Aspen, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Aurora",
            "id": 252,
            "is_region": null,
            "is_state": false,
            "lat": 39.73,
            "long": -104.83,
            "name": "Aurora, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Boulder",
            "id": 253,
            "is_region": null,
            "is_state": false,
            "lat": 40.015,
            "long": -105.271,
            "name": "Boulder, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Breckenridge",
            "id": 254,
            "is_region": null,
            "is_state": false,
            "lat": 39.4996,
            "long": -106.043,
            "name": "Breckenridge, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Brighton",
            "id": 255,
            "is_region": null,
            "is_state": false,
            "lat": 39.9648,
            "long": -104.797,
            "name": "Brighton, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Canon City",
            "id": 256,
            "is_region": null,
            "is_state": false,
            "lat": 38.4419,
            "long": -105.221,
            "name": "Canon City, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Central City",
            "id": 257,
            "is_region": null,
            "is_state": false,
            "lat": 39.7958,
            "long": -105.515,
            "name": "Central City, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Climax",
            "id": 258,
            "is_region": null,
            "is_state": false,
            "lat": 39.3658,
            "long": -106.186,
            "name": "Climax, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Colorado Springs",
            "id": 259,
            "is_region": null,
            "is_state": false,
            "lat": 38.833,
            "long": -104.817,
            "name": "Colorado Springs, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Cortez",
            "id": 260,
            "is_region": null,
            "is_state": false,
            "lat": 37.3498,
            "long": -108.577,
            "name": "Cortez, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Cripple Creek",
            "id": 261,
            "is_region": null,
            "is_state": false,
            "lat": 38.7461,
            "long": -105.184,
            "name": "Cripple Creek, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Denver",
            "id": 262,
            "is_region": null,
            "is_state": false,
            "lat": 39.7618,
            "long": -104.881,
            "name": "Denver, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Durango",
            "id": 263,
            "is_region": null,
            "is_state": false,
            "lat": 37.2733,
            "long": -107.872,
            "name": "Durango, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Englewood",
            "id": 264,
            "is_region": null,
            "is_state": false,
            "lat": 39.6465,
            "long": -104.994,
            "name": "Englewood, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Estes Park",
            "id": 265,
            "is_region": null,
            "is_state": false,
            "lat": 40.3771,
            "long": -105.526,
            "name": "Estes Park, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Fort Collins",
            "id": 266,
            "is_region": null,
            "is_state": false,
            "lat": 40.5592,
            "long": -105.078,
            "name": "Fort Collins, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Fort Morgan",
            "id": 267,
            "is_region": null,
            "is_state": false,
            "lat": 40.2533,
            "long": -103.799,
            "name": "Fort Morgan, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Georgetown",
            "id": 268,
            "is_region": null,
            "is_state": false,
            "lat": 39.7125,
            "long": -105.696,
            "name": "Georgetown, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Glenwood Springs",
            "id": 269,
            "is_region": null,
            "is_state": false,
            "lat": 39.55,
            "long": -107.317,
            "name": "Glenwood Springs, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Golden",
            "id": 270,
            "is_region": null,
            "is_state": false,
            "lat": 39.7469,
            "long": -105.211,
            "name": "Golden, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Grand Junction",
            "id": 271,
            "is_region": null,
            "is_state": false,
            "lat": 39.067,
            "long": -108.567,
            "name": "Grand Junction, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Greeley",
            "id": 272,
            "is_region": null,
            "is_state": false,
            "lat": 40.4233,
            "long": -104.709,
            "name": "Greeley, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Gunnison",
            "id": 273,
            "is_region": null,
            "is_state": false,
            "lat": 38.5444,
            "long": -106.928,
            "name": "Gunnison, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "La Junta",
            "id": 274,
            "is_region": null,
            "is_state": false,
            "lat": 37.9814,
            "long": -103.548,
            "name": "La Junta, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Leadville",
            "id": 275,
            "is_region": null,
            "is_state": false,
            "lat": 39.25,
            "long": -106.292,
            "name": "Leadville, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Littleton",
            "id": 276,
            "is_region": null,
            "is_state": false,
            "lat": 39.5997,
            "long": -105.011,
            "name": "Littleton, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Longmont",
            "id": 277,
            "is_region": null,
            "is_state": false,
            "lat": 40.1717,
            "long": -105.109,
            "name": "Longmont, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Loveland",
            "id": 278,
            "is_region": null,
            "is_state": false,
            "lat": 40.4047,
            "long": -105.086,
            "name": "Loveland, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Montrose",
            "id": 279,
            "is_region": null,
            "is_state": false,
            "lat": 38.4769,
            "long": -107.866,
            "name": "Montrose, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Ouray",
            "id": 280,
            "is_region": null,
            "is_state": false,
            "lat": 38.0233,
            "long": -107.672,
            "name": "Ouray, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Pagosa Springs",
            "id": 281,
            "is_region": null,
            "is_state": false,
            "lat": 37.2681,
            "long": -107.024,
            "name": "Pagosa Springs, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Pueblo",
            "id": 282,
            "is_region": null,
            "is_state": false,
            "lat": 38.2669,
            "long": -104.62,
            "name": "Pueblo, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Silverton",
            "id": 283,
            "is_region": null,
            "is_state": false,
            "lat": 37.8125,
            "long": -107.663,
            "name": "Silverton, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Steamboat Springs",
            "id": 284,
            "is_region": null,
            "is_state": false,
            "lat": 40.4764,
            "long": -106.827,
            "name": "Steamboat Springs, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Sterling",
            "id": 285,
            "is_region": null,
            "is_state": false,
            "lat": 40.6256,
            "long": -103.212,
            "name": "Sterling, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Telluride",
            "id": 286,
            "is_region": null,
            "is_state": false,
            "lat": 37.9392,
            "long": -107.816,
            "name": "Telluride, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Trinidad",
            "id": 287,
            "is_region": null,
            "is_state": false,
            "lat": 37.1708,
            "long": -104.506,
            "name": "Trinidad, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Vail",
            "id": 288,
            "is_region": null,
            "is_state": false,
            "lat": 39.6417,
            "long": -106.375,
            "name": "Vail, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Walsenburg",
            "id": 289,
            "is_region": null,
            "is_state": false,
            "lat": 37.6267,
            "long": -104.784,
            "name": "Walsenburg, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CO",
            "city": "Westminster",
            "id": 290,
            "is_region": null,
            "is_state": false,
            "lat": 39.8361,
            "long": -105.037,
            "name": "Westminster, CO",
            "region_id": null,
            "state": "Colorado"
        },
        {
            "abbr": "CT",
            "city": "Ansonia",
            "id": 291,
            "is_region": null,
            "is_state": false,
            "lat": 41.3433,
            "long": -73.0686,
            "name": "Ansonia, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Berlin",
            "id": 292,
            "is_region": null,
            "is_state": false,
            "lat": 41.6139,
            "long": -72.7725,
            "name": "Berlin, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Bloomfield",
            "id": 293,
            "is_region": null,
            "is_state": false,
            "lat": 41.85,
            "long": -72.733,
            "name": "Bloomfield, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Branford",
            "id": 294,
            "is_region": null,
            "is_state": false,
            "lat": 41.2778,
            "long": -72.7997,
            "name": "Branford, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Bridgeport",
            "id": 295,
            "is_region": null,
            "is_state": false,
            "lat": 41.1864,
            "long": -73.1956,
            "name": "Bridgeport, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Bristol",
            "id": 296,
            "is_region": null,
            "is_state": false,
            "lat": 41.6811,
            "long": -72.9406,
            "name": "Bristol, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Coventry",
            "id": 297,
            "is_region": null,
            "is_state": false,
            "lat": 41.7844,
            "long": -72.3389,
            "name": "Coventry, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Danbury",
            "id": 298,
            "is_region": null,
            "is_state": false,
            "lat": 41.4022,
            "long": -73.4711,
            "name": "Danbury, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Darien",
            "id": 299,
            "is_region": null,
            "is_state": false,
            "lat": 41.0511,
            "long": -73.4792,
            "name": "Darien, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Derby",
            "id": 300,
            "is_region": null,
            "is_state": false,
            "lat": 41.3267,
            "long": -73.0822,
            "name": "Derby, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "East Hartford",
            "id": 301,
            "is_region": null,
            "is_state": false,
            "lat": 41.7614,
            "long": -72.6153,
            "name": "East Hartford, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "East Haven",
            "id": 302,
            "is_region": null,
            "is_state": false,
            "lat": 41.2956,
            "long": -72.8625,
            "name": "East Haven, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Enfield",
            "id": 303,
            "is_region": null,
            "is_state": false,
            "lat": 41.98,
            "long": -72.55,
            "name": "Enfield, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Fairfield",
            "id": 304,
            "is_region": null,
            "is_state": false,
            "lat": 41.1758,
            "long": -73.2719,
            "name": "Fairfield, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Farmington",
            "id": 305,
            "is_region": null,
            "is_state": false,
            "lat": 41.7278,
            "long": -72.8403,
            "name": "Farmington, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Greenwich",
            "id": 306,
            "is_region": null,
            "is_state": false,
            "lat": 41.0389,
            "long": -73.6136,
            "name": "Greenwich, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Groton",
            "id": 307,
            "is_region": null,
            "is_state": false,
            "lat": 41.3485,
            "long": -72.0775,
            "name": "Groton, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Guilford",
            "id": 308,
            "is_region": null,
            "is_state": false,
            "lat": 41.283,
            "long": -72.683,
            "name": "Guilford, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Hamden",
            "id": 309,
            "is_region": null,
            "is_state": false,
            "lat": 41.3978,
            "long": -72.9217,
            "name": "Hamden, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Hartford",
            "id": 310,
            "is_region": null,
            "is_state": false,
            "lat": 41.7625,
            "long": -72.6742,
            "name": "Hartford, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Lebanon",
            "id": 311,
            "is_region": null,
            "is_state": false,
            "lat": 41.6325,
            "long": -72.24,
            "name": "Lebanon, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Litchfield",
            "id": 312,
            "is_region": null,
            "is_state": false,
            "lat": 41.7472,
            "long": -73.1897,
            "name": "Litchfield, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Manchester",
            "id": 313,
            "is_region": null,
            "is_state": false,
            "lat": 41.7753,
            "long": -72.5242,
            "name": "Manchester, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Mansfield",
            "id": 314,
            "is_region": null,
            "is_state": false,
            "lat": 41.7883,
            "long": -72.2289,
            "name": "Mansfield, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Meriden",
            "id": 315,
            "is_region": null,
            "is_state": false,
            "lat": 41.5367,
            "long": -72.7947,
            "name": "Meriden, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Middletown",
            "id": 316,
            "is_region": null,
            "is_state": false,
            "lat": 41.5622,
            "long": -72.6508,
            "name": "Middletown, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Milford",
            "id": 317,
            "is_region": null,
            "is_state": false,
            "lat": 41.2242,
            "long": -73.0597,
            "name": "Milford, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Mystic",
            "id": 318,
            "is_region": null,
            "is_state": false,
            "lat": 41.3542,
            "long": -71.9664,
            "name": "Mystic, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Naugatuck",
            "id": 319,
            "is_region": null,
            "is_state": false,
            "lat": 41.4897,
            "long": -73.0514,
            "name": "Naugatuck, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "New Britain",
            "id": 320,
            "is_region": null,
            "is_state": false,
            "lat": 41.675,
            "long": -72.7872,
            "name": "New Britain, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "New Haven",
            "id": 321,
            "is_region": null,
            "is_state": false,
            "lat": 41.31,
            "long": -72.9236,
            "name": "New Haven, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "New London",
            "id": 322,
            "is_region": null,
            "is_state": false,
            "lat": 41.3556,
            "long": -72.0994,
            "name": "New London, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "North Haven",
            "id": 323,
            "is_region": null,
            "is_state": false,
            "lat": 41.3817,
            "long": -72.8583,
            "name": "North Haven, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Norwalk",
            "id": 324,
            "is_region": null,
            "is_state": false,
            "lat": 41.0939,
            "long": -73.4197,
            "name": "Norwalk, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Norwich",
            "id": 325,
            "is_region": null,
            "is_state": false,
            "lat": 41.5503,
            "long": -72.0875,
            "name": "Norwich, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Old Saybrook",
            "id": 326,
            "is_region": null,
            "is_state": false,
            "lat": 41.2939,
            "long": -72.3825,
            "name": "Old Saybrook, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Orange",
            "id": 327,
            "is_region": null,
            "is_state": false,
            "lat": 41.2794,
            "long": -73.0253,
            "name": "Orange, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Seymour",
            "id": 328,
            "is_region": null,
            "is_state": false,
            "lat": 41.3842,
            "long": -73.0869,
            "name": "Seymour, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Shelton",
            "id": 329,
            "is_region": null,
            "is_state": false,
            "lat": 41.3042,
            "long": -73.1381,
            "name": "Shelton, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Simsbury",
            "id": 330,
            "is_region": null,
            "is_state": false,
            "lat": 41.8706,
            "long": -72.8253,
            "name": "Simsbury, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Southington",
            "id": 331,
            "is_region": null,
            "is_state": false,
            "lat": 41.605,
            "long": -72.8792,
            "name": "Southington, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Stamford",
            "id": 332,
            "is_region": null,
            "is_state": false,
            "lat": 41.0528,
            "long": -73.5389,
            "name": "Stamford, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Stonington",
            "id": 333,
            "is_region": null,
            "is_state": false,
            "lat": 41.365,
            "long": -71.9067,
            "name": "Stonington, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Stratford",
            "id": 334,
            "is_region": null,
            "is_state": false,
            "lat": 41.2044,
            "long": -73.1297,
            "name": "Stratford, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Torrington",
            "id": 335,
            "is_region": null,
            "is_state": false,
            "lat": 41.8,
            "long": -73.117,
            "name": "Torrington, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Wallingford",
            "id": 336,
            "is_region": null,
            "is_state": false,
            "lat": 41.4564,
            "long": -72.8042,
            "name": "Wallingford, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Waterbury",
            "id": 337,
            "is_region": null,
            "is_state": false,
            "lat": 41.5561,
            "long": -73.0414,
            "name": "Waterbury, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Waterford",
            "id": 338,
            "is_region": null,
            "is_state": false,
            "lat": 41.3497,
            "long": -72.1469,
            "name": "Waterford, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Watertown",
            "id": 339,
            "is_region": null,
            "is_state": false,
            "lat": 41.617,
            "long": -73.117,
            "name": "Watertown, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "West Hartford",
            "id": 340,
            "is_region": null,
            "is_state": false,
            "lat": 41.7678,
            "long": -72.7539,
            "name": "West Hartford, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "West Haven",
            "id": 341,
            "is_region": null,
            "is_state": false,
            "lat": 41.2739,
            "long": -72.9678,
            "name": "West Haven, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Westport",
            "id": 342,
            "is_region": null,
            "is_state": false,
            "lat": 41.1233,
            "long": -73.3469,
            "name": "Westport, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Wethersfield",
            "id": 343,
            "is_region": null,
            "is_state": false,
            "lat": 41.7142,
            "long": -72.6525,
            "name": "Wethersfield, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Willimantic",
            "id": 344,
            "is_region": null,
            "is_state": false,
            "lat": 41.717,
            "long": -72.217,
            "name": "Willimantic, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Windham",
            "id": 345,
            "is_region": null,
            "is_state": false,
            "lat": 41.717,
            "long": -72.167,
            "name": "Windham, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Windsor",
            "id": 346,
            "is_region": null,
            "is_state": false,
            "lat": 41.8528,
            "long": -72.6431,
            "name": "Windsor, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Windsor Locks",
            "id": 347,
            "is_region": null,
            "is_state": false,
            "lat": 41.925,
            "long": -72.6494,
            "name": "Windsor Locks, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "CT",
            "city": "Winsted",
            "id": 348,
            "is_region": null,
            "is_state": false,
            "lat": 41.9225,
            "long": -73.0697,
            "name": "Winsted, CT",
            "region_id": null,
            "state": "Connecticut"
        },
        {
            "abbr": "DE",
            "city": "Dover",
            "id": 349,
            "is_region": null,
            "is_state": false,
            "lat": 39.1581,
            "long": -75.5244,
            "name": "Dover, DE",
            "region_id": null,
            "state": "Delaware"
        },
        {
            "abbr": "DE",
            "city": "Lewes",
            "id": 350,
            "is_region": null,
            "is_state": false,
            "lat": 38.7744,
            "long": -75.1394,
            "name": "Lewes, DE",
            "region_id": null,
            "state": "Delaware"
        },
        {
            "abbr": "DE",
            "city": "Milford",
            "id": 351,
            "is_region": null,
            "is_state": false,
            "lat": 38.9125,
            "long": -75.4281,
            "name": "Milford, DE",
            "region_id": null,
            "state": "Delaware"
        },
        {
            "abbr": "DE",
            "city": "New Castle",
            "id": 352,
            "is_region": null,
            "is_state": false,
            "lat": 39.6619,
            "long": -75.5664,
            "name": "New Castle, DE",
            "region_id": null,
            "state": "Delaware"
        },
        {
            "abbr": "DE",
            "city": "Newark",
            "id": 353,
            "is_region": null,
            "is_state": false,
            "lat": 39.6836,
            "long": -75.7497,
            "name": "Newark, DE",
            "region_id": null,
            "state": "Delaware"
        },
        {
            "abbr": "DE",
            "city": "Smyrna",
            "id": 354,
            "is_region": null,
            "is_state": false,
            "lat": 39.2997,
            "long": -75.6047,
            "name": "Smyrna, DE",
            "region_id": null,
            "state": "Delaware"
        },
        {
            "abbr": "DE",
            "city": "Wilmington",
            "id": 355,
            "is_region": null,
            "is_state": false,
            "lat": 39.7458,
            "long": -75.5467,
            "name": "Wilmington, DE",
            "region_id": null,
            "state": "Delaware"
        },
        {
            "abbr": "FL",
            "city": "Apalachicola",
            "id": 356,
            "is_region": null,
            "is_state": false,
            "lat": 29.7253,
            "long": -84.9925,
            "name": "Apalachicola, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Bartow",
            "id": 357,
            "is_region": null,
            "is_state": false,
            "lat": 27.8925,
            "long": -81.8397,
            "name": "Bartow, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Belle Glade",
            "id": 358,
            "is_region": null,
            "is_state": false,
            "lat": 26.6853,
            "long": -80.6714,
            "name": "Belle Glade, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Boca Raton",
            "id": 359,
            "is_region": null,
            "is_state": false,
            "lat": 26.3686,
            "long": -80.1,
            "name": "Boca Raton, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Bradenton",
            "id": 360,
            "is_region": null,
            "is_state": false,
            "lat": 27.483,
            "long": -82.583,
            "name": "Bradenton, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Cape Coral",
            "id": 361,
            "is_region": null,
            "is_state": false,
            "lat": 26.6397,
            "long": -81.9825,
            "name": "Cape Coral, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Clearwater",
            "id": 362,
            "is_region": null,
            "is_state": false,
            "lat": 27.9736,
            "long": -82.7642,
            "name": "Clearwater, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Cocoa Beach",
            "id": 363,
            "is_region": null,
            "is_state": false,
            "lat": 28.1519,
            "long": -80.595,
            "name": "Cocoa Beach, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Cocoa-Rockledge",
            "id": 364,
            "is_region": null,
            "is_state": false,
            "lat": 28.325,
            "long": -80.7328,
            "name": "Cocoa-Rockledge, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Coral Gables",
            "id": 365,
            "is_region": null,
            "is_state": false,
            "lat": 25.7167,
            "long": -80.2722,
            "name": "Coral Gables, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Daytona Beach",
            "id": 366,
            "is_region": null,
            "is_state": false,
            "lat": 29.19,
            "long": -81.0894,
            "name": "Daytona Beach, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "De Land",
            "id": 367,
            "is_region": null,
            "is_state": false,
            "lat": 29.0225,
            "long": -81.2864,
            "name": "De Land, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Deerfield Beach",
            "id": 368,
            "is_region": null,
            "is_state": false,
            "lat": 26.3181,
            "long": -80.0997,
            "name": "Deerfield Beach, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Delray Beach",
            "id": 369,
            "is_region": null,
            "is_state": false,
            "lat": 26.4592,
            "long": -80.0831,
            "name": "Delray Beach, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Fernandina Beach",
            "id": 370,
            "is_region": null,
            "is_state": false,
            "lat": 30.6694,
            "long": -81.4617,
            "name": "Fernandina Beach, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Fort Lauderdale",
            "id": 371,
            "is_region": null,
            "is_state": false,
            "lat": 26.133,
            "long": -80.15,
            "name": "Fort Lauderdale, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Fort Myers",
            "id": 372,
            "is_region": null,
            "is_state": false,
            "lat": 26.617,
            "long": -81.833,
            "name": "Fort Myers, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Fort Pierce",
            "id": 373,
            "is_region": null,
            "is_state": false,
            "lat": 27.4389,
            "long": -80.3356,
            "name": "Fort Pierce, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Fort Walton Beach",
            "id": 374,
            "is_region": null,
            "is_state": false,
            "lat": 30.4203,
            "long": -86.6167,
            "name": "Fort Walton Beach, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Gainesville",
            "id": 375,
            "is_region": null,
            "is_state": false,
            "lat": 29.652,
            "long": -82.325,
            "name": "Gainesville, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Hallandale Beach",
            "id": 376,
            "is_region": null,
            "is_state": false,
            "lat": 25.9867,
            "long": -80.1461,
            "name": "Hallandale Beach, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Hialeah",
            "id": 377,
            "is_region": null,
            "is_state": false,
            "lat": 25.8606,
            "long": -80.2939,
            "name": "Hialeah, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Hollywood",
            "id": 378,
            "is_region": null,
            "is_state": false,
            "lat": 26.0214,
            "long": -80.175,
            "name": "Hollywood, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Homestead",
            "id": 379,
            "is_region": null,
            "is_state": false,
            "lat": 25.4712,
            "long": -80.4681,
            "name": "Homestead, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Jacksonville",
            "id": 380,
            "is_region": null,
            "is_state": false,
            "lat": 30.3369,
            "long": -81.6614,
            "name": "Jacksonville, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Key West",
            "id": 381,
            "is_region": null,
            "is_state": false,
            "lat": 24.5592,
            "long": -81.784,
            "name": "Key West, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Lake City",
            "id": 382,
            "is_region": null,
            "is_state": false,
            "lat": 30.183,
            "long": -82.633,
            "name": "Lake City, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Lake Wales",
            "id": 383,
            "is_region": null,
            "is_state": false,
            "lat": 27.9047,
            "long": -81.5842,
            "name": "Lake Wales, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Lakeland",
            "id": 384,
            "is_region": null,
            "is_state": false,
            "lat": 28.0411,
            "long": -81.9589,
            "name": "Lakeland, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Largo",
            "id": 385,
            "is_region": null,
            "is_state": false,
            "lat": 27.9094,
            "long": -82.7872,
            "name": "Largo, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Melbourne",
            "id": 386,
            "is_region": null,
            "is_state": false,
            "lat": 28.117,
            "long": -80.633,
            "name": "Melbourne, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Miami",
            "id": 387,
            "is_region": null,
            "is_state": false,
            "lat": 25.7753,
            "long": -80.2089,
            "name": "Miami, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Miami Beach",
            "id": 388,
            "is_region": null,
            "is_state": false,
            "lat": 25.813,
            "long": -80.1341,
            "name": "Miami Beach, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Naples",
            "id": 389,
            "is_region": null,
            "is_state": false,
            "lat": 26.15,
            "long": -81.8,
            "name": "Naples, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "New Smyrna Beach",
            "id": 390,
            "is_region": null,
            "is_state": false,
            "lat": 29.0306,
            "long": -80.9253,
            "name": "New Smyrna Beach, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Ocala",
            "id": 391,
            "is_region": null,
            "is_state": false,
            "lat": 29.1878,
            "long": -82.1306,
            "name": "Ocala, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Orlando",
            "id": 392,
            "is_region": null,
            "is_state": false,
            "lat": 28.54,
            "long": -81.38,
            "name": "Orlando, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Ormond Beach",
            "id": 393,
            "is_region": null,
            "is_state": false,
            "lat": 29.2864,
            "long": -81.075,
            "name": "Ormond Beach, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Palatka",
            "id": 394,
            "is_region": null,
            "is_state": false,
            "lat": 29.6478,
            "long": -81.6514,
            "name": "Palatka, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Palm Bay",
            "id": 395,
            "is_region": null,
            "is_state": false,
            "lat": 27.9979,
            "long": -80.67,
            "name": "Palm Bay, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Palm Beach",
            "id": 396,
            "is_region": null,
            "is_state": false,
            "lat": 26.715,
            "long": -80.0394,
            "name": "Palm Beach, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Panama City",
            "id": 397,
            "is_region": null,
            "is_state": false,
            "lat": 30.1744,
            "long": -85.6644,
            "name": "Panama City, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Pensacola",
            "id": 398,
            "is_region": null,
            "is_state": false,
            "lat": 30.433,
            "long": -87.2,
            "name": "Pensacola, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Pompano Beach",
            "id": 399,
            "is_region": null,
            "is_state": false,
            "lat": 26.2347,
            "long": -80.1256,
            "name": "Pompano Beach, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Saint Augustine",
            "id": 400,
            "is_region": null,
            "is_state": false,
            "lat": 29.8947,
            "long": -81.3144,
            "name": "Saint Augustine, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Saint Petersburg",
            "id": 401,
            "is_region": null,
            "is_state": false,
            "lat": 27.7731,
            "long": -82.64,
            "name": "Saint Petersburg, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Sanford",
            "id": 402,
            "is_region": null,
            "is_state": false,
            "lat": 28.7894,
            "long": -81.2756,
            "name": "Sanford, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Sarasota",
            "id": 403,
            "is_region": null,
            "is_state": false,
            "lat": 27.3372,
            "long": -82.5353,
            "name": "Sarasota, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Sebring",
            "id": 404,
            "is_region": null,
            "is_state": false,
            "lat": 27.4956,
            "long": -81.4444,
            "name": "Sebring, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Tallahassee",
            "id": 405,
            "is_region": null,
            "is_state": false,
            "lat": 30.455,
            "long": -84.2533,
            "name": "Tallahassee, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Tampa",
            "id": 406,
            "is_region": null,
            "is_state": false,
            "lat": 27.9681,
            "long": -82.4764,
            "name": "Tampa, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Tarpon Springs",
            "id": 407,
            "is_region": null,
            "is_state": false,
            "lat": 28.15,
            "long": -82.75,
            "name": "Tarpon Springs, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Titusville",
            "id": 408,
            "is_region": null,
            "is_state": false,
            "lat": 28.5911,
            "long": -80.82,
            "name": "Titusville, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Venice",
            "id": 409,
            "is_region": null,
            "is_state": false,
            "lat": 27.1,
            "long": -82.433,
            "name": "Venice, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "West Palm Beach",
            "id": 410,
            "is_region": null,
            "is_state": false,
            "lat": 26.7097,
            "long": -80.0642,
            "name": "West Palm Beach, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "White Springs",
            "id": 411,
            "is_region": null,
            "is_state": false,
            "lat": 30.3317,
            "long": -82.7561,
            "name": "White Springs, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Winter Haven",
            "id": 412,
            "is_region": null,
            "is_state": false,
            "lat": 28.033,
            "long": -81.717,
            "name": "Winter Haven, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "FL",
            "city": "Winter Park",
            "id": 413,
            "is_region": null,
            "is_state": false,
            "lat": 28.5961,
            "long": -81.3467,
            "name": "Winter Park, FL",
            "region_id": null,
            "state": "Florida"
        },
        {
            "abbr": "GA",
            "city": "Albany",
            "id": 414,
            "is_region": null,
            "is_state": false,
            "lat": 31.5822,
            "long": -84.1656,
            "name": "Albany, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Americus",
            "id": 415,
            "is_region": null,
            "is_state": false,
            "lat": 32.0753,
            "long": -84.2267,
            "name": "Americus, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Andersonville",
            "id": 416,
            "is_region": null,
            "is_state": false,
            "lat": 32.1969,
            "long": -84.1417,
            "name": "Andersonville, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Athens",
            "id": 417,
            "is_region": null,
            "is_state": false,
            "lat": 33.95,
            "long": -83.383,
            "name": "Athens, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Atlanta",
            "id": 418,
            "is_region": null,
            "is_state": false,
            "lat": 33.755,
            "long": -84.39,
            "name": "Atlanta, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Augusta",
            "id": 419,
            "is_region": null,
            "is_state": false,
            "lat": 33.467,
            "long": -81.967,
            "name": "Augusta, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Bainbridge",
            "id": 420,
            "is_region": null,
            "is_state": false,
            "lat": 30.9047,
            "long": -84.5711,
            "name": "Bainbridge, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Blairsville",
            "id": 421,
            "is_region": null,
            "is_state": false,
            "lat": 34.8756,
            "long": -83.9567,
            "name": "Blairsville, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Brunswick",
            "id": 422,
            "is_region": null,
            "is_state": false,
            "lat": 31.1497,
            "long": -81.4914,
            "name": "Brunswick, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Calhoun",
            "id": 423,
            "is_region": null,
            "is_state": false,
            "lat": 34.5,
            "long": -84.9425,
            "name": "Calhoun, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Carrollton",
            "id": 424,
            "is_region": null,
            "is_state": false,
            "lat": 33.5808,
            "long": -85.0767,
            "name": "Carrollton, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Columbus",
            "id": 425,
            "is_region": null,
            "is_state": false,
            "lat": 32.4922,
            "long": -84.9403,
            "name": "Columbus, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Dahlonega",
            "id": 426,
            "is_region": null,
            "is_state": false,
            "lat": 34.533,
            "long": -83.983,
            "name": "Dahlonega, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Dalton",
            "id": 427,
            "is_region": null,
            "is_state": false,
            "lat": 34.7711,
            "long": -84.9717,
            "name": "Dalton, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Darien",
            "id": 428,
            "is_region": null,
            "is_state": false,
            "lat": 31.3711,
            "long": -81.4308,
            "name": "Darien, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Decatur",
            "id": 429,
            "is_region": null,
            "is_state": false,
            "lat": 33.7714,
            "long": -84.2978,
            "name": "Decatur, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Douglas",
            "id": 430,
            "is_region": null,
            "is_state": false,
            "lat": 31.5075,
            "long": -82.8508,
            "name": "Douglas, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "East Point",
            "id": 431,
            "is_region": null,
            "is_state": false,
            "lat": 33.6761,
            "long": -84.4514,
            "name": "East Point, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Fitzgerald",
            "id": 432,
            "is_region": null,
            "is_state": false,
            "lat": 31.7156,
            "long": -83.2564,
            "name": "Fitzgerald, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Fort Valley",
            "id": 433,
            "is_region": null,
            "is_state": false,
            "lat": 32.55,
            "long": -83.883,
            "name": "Fort Valley, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Gainesville",
            "id": 434,
            "is_region": null,
            "is_state": false,
            "lat": 34.3044,
            "long": -83.8339,
            "name": "Gainesville, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "La Grange",
            "id": 435,
            "is_region": null,
            "is_state": false,
            "lat": 33.0367,
            "long": -85.0319,
            "name": "La Grange, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Macon",
            "id": 436,
            "is_region": null,
            "is_state": false,
            "lat": 32.8347,
            "long": -83.6517,
            "name": "Macon, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Marietta",
            "id": 437,
            "is_region": null,
            "is_state": false,
            "lat": 33.9533,
            "long": -84.5406,
            "name": "Marietta, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Milledgeville",
            "id": 438,
            "is_region": null,
            "is_state": false,
            "lat": 33.0878,
            "long": -83.2333,
            "name": "Milledgeville, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Plains",
            "id": 439,
            "is_region": null,
            "is_state": false,
            "lat": 32.0336,
            "long": -84.3933,
            "name": "Plains, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Rome",
            "id": 440,
            "is_region": null,
            "is_state": false,
            "lat": 34.26,
            "long": -85.185,
            "name": "Rome, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Savannah",
            "id": 441,
            "is_region": null,
            "is_state": false,
            "lat": 32.017,
            "long": -81.117,
            "name": "Savannah, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Toccoa",
            "id": 442,
            "is_region": null,
            "is_state": false,
            "lat": 34.5747,
            "long": -83.32,
            "name": "Toccoa, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Valdosta",
            "id": 443,
            "is_region": null,
            "is_state": false,
            "lat": 30.8467,
            "long": -83.2831,
            "name": "Valdosta, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Warm Springs",
            "id": 444,
            "is_region": null,
            "is_state": false,
            "lat": 32.8886,
            "long": -84.68,
            "name": "Warm Springs, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Warner Robins",
            "id": 445,
            "is_region": null,
            "is_state": false,
            "lat": 32.6086,
            "long": -83.6381,
            "name": "Warner Robins, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Washington",
            "id": 446,
            "is_region": null,
            "is_state": false,
            "lat": 33.7368,
            "long": -82.7393,
            "name": "Washington, GA",
            "region_id": 2535,
            "state": "Georgia"
        },
        {
            "abbr": "GA",
            "city": "Waycross",
            "id": 447,
            "is_region": null,
            "is_state": false,
            "lat": 31.2139,
            "long": -82.355,
            "name": "Waycross, GA",
            "region_id": null,
            "state": "Georgia"
        },
        {
            "abbr": "HI",
            "city": "Hanalei",
            "id": 448,
            "is_region": null,
            "is_state": false,
            "lat": 22.2067,
            "long": -159.501,
            "name": "Hanalei, HI",
            "region_id": null,
            "state": "Hawaii"
        },
        {
            "abbr": "HI",
            "city": "Hilo",
            "id": 449,
            "is_region": null,
            "is_state": false,
            "lat": 19.7056,
            "long": -155.086,
            "name": "Hilo, HI",
            "region_id": null,
            "state": "Hawaii"
        },
        {
            "abbr": "HI",
            "city": "Honaunau",
            "id": 450,
            "is_region": null,
            "is_state": false,
            "lat": 19.4269,
            "long": -155.913,
            "name": "Honaunau, HI",
            "region_id": null,
            "state": "Hawaii"
        },
        {
            "abbr": "HI",
            "city": "Honolulu",
            "id": 451,
            "is_region": null,
            "is_state": false,
            "lat": 21.3,
            "long": -157.817,
            "name": "Honolulu, HI",
            "region_id": null,
            "state": "Hawaii"
        },
        {
            "abbr": "HI",
            "city": "Kahului",
            "id": 452,
            "is_region": null,
            "is_state": false,
            "lat": 20.8817,
            "long": -156.467,
            "name": "Kahului, HI",
            "region_id": null,
            "state": "Hawaii"
        },
        {
            "abbr": "HI",
            "city": "Kaneohe",
            "id": 453,
            "is_region": null,
            "is_state": false,
            "lat": 21.4092,
            "long": -157.799,
            "name": "Kaneohe, HI",
            "region_id": null,
            "state": "Hawaii"
        },
        {
            "abbr": "HI",
            "city": "Kapaa",
            "id": 454,
            "is_region": null,
            "is_state": false,
            "lat": 22.0883,
            "long": -159.338,
            "name": "Kapaa, HI",
            "region_id": null,
            "state": "Hawaii"
        },
        {
            "abbr": "HI",
            "city": "Kawaihae",
            "id": 455,
            "is_region": null,
            "is_state": false,
            "lat": 20.0353,
            "long": -155.828,
            "name": "Kawaihae, HI",
            "region_id": null,
            "state": "Hawaii"
        },
        {
            "abbr": "HI",
            "city": "Lahaina",
            "id": 456,
            "is_region": null,
            "is_state": false,
            "lat": 20.8861,
            "long": -156.675,
            "name": "Lahaina, HI",
            "region_id": null,
            "state": "Hawaii"
        },
        {
            "abbr": "HI",
            "city": "Laie",
            "id": 457,
            "is_region": null,
            "is_state": false,
            "lat": 21.6486,
            "long": -157.926,
            "name": "Laie, HI",
            "region_id": null,
            "state": "Hawaii"
        },
        {
            "abbr": "HI",
            "city": "Wahiawa",
            "id": 458,
            "is_region": null,
            "is_state": false,
            "lat": 21.5025,
            "long": -158.023,
            "name": "Wahiawa, HI",
            "region_id": null,
            "state": "Hawaii"
        },
        {
            "abbr": "HI",
            "city": "Wailuku",
            "id": 459,
            "is_region": null,
            "is_state": false,
            "lat": 20.8919,
            "long": -156.502,
            "name": "Wailuku, HI",
            "region_id": null,
            "state": "Hawaii"
        },
        {
            "abbr": "HI",
            "city": "Waimea",
            "id": 460,
            "is_region": null,
            "is_state": false,
            "lat": 20.0203,
            "long": -155.668,
            "name": "Waimea, HI",
            "region_id": null,
            "state": "Hawaii"
        },
        {
            "abbr": "ID",
            "city": "Blackfoot",
            "id": 461,
            "is_region": null,
            "is_state": false,
            "lat": 43.19,
            "long": -112.346,
            "name": "Blackfoot, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Boise",
            "id": 462,
            "is_region": null,
            "is_state": false,
            "lat": 43.617,
            "long": -116.2,
            "name": "Boise, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Bonners Ferry",
            "id": 463,
            "is_region": null,
            "is_state": false,
            "lat": 48.6922,
            "long": -116.317,
            "name": "Bonners Ferry, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Caldwell",
            "id": 464,
            "is_region": null,
            "is_state": false,
            "lat": 43.6583,
            "long": -116.68,
            "name": "Caldwell, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Coeur d’Alene",
            "id": 465,
            "is_region": null,
            "is_state": false,
            "lat": 47.6928,
            "long": -116.78,
            "name": "Coeur d’Alene, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Idaho City",
            "id": 466,
            "is_region": null,
            "is_state": false,
            "lat": 43.8286,
            "long": -115.832,
            "name": "Idaho City, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Idaho Falls",
            "id": 467,
            "is_region": null,
            "is_state": false,
            "lat": 43.5,
            "long": -112.033,
            "name": "Idaho Falls, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Kellogg",
            "id": 468,
            "is_region": null,
            "is_state": false,
            "lat": 47.5383,
            "long": -116.125,
            "name": "Kellogg, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Lewiston",
            "id": 469,
            "is_region": null,
            "is_state": false,
            "lat": 46.41,
            "long": -117.02,
            "name": "Lewiston, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Moscow",
            "id": 470,
            "is_region": null,
            "is_state": false,
            "lat": 46.73,
            "long": -117.0,
            "name": "Moscow, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Nampa",
            "id": 471,
            "is_region": null,
            "is_state": false,
            "lat": 43.5747,
            "long": -116.564,
            "name": "Nampa, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Pocatello",
            "id": 472,
            "is_region": null,
            "is_state": false,
            "lat": 42.8752,
            "long": -112.447,
            "name": "Pocatello, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Priest River",
            "id": 473,
            "is_region": null,
            "is_state": false,
            "lat": 48.1833,
            "long": -116.909,
            "name": "Priest River, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Rexburg",
            "id": 474,
            "is_region": null,
            "is_state": false,
            "lat": 43.817,
            "long": -111.783,
            "name": "Rexburg, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Sun Valley",
            "id": 475,
            "is_region": null,
            "is_state": false,
            "lat": 43.6806,
            "long": -114.343,
            "name": "Sun Valley, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "ID",
            "city": "Twin Falls",
            "id": 476,
            "is_region": null,
            "is_state": false,
            "lat": 42.5556,
            "long": -114.471,
            "name": "Twin Falls, ID",
            "region_id": null,
            "state": "Idaho"
        },
        {
            "abbr": "IL",
            "city": "Alton",
            "id": 477,
            "is_region": null,
            "is_state": false,
            "lat": 38.9006,
            "long": -90.1597,
            "name": "Alton, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Arlington Heights",
            "id": 478,
            "is_region": null,
            "is_state": false,
            "lat": 42.095,
            "long": -87.9808,
            "name": "Arlington Heights, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Arthur",
            "id": 479,
            "is_region": null,
            "is_state": false,
            "lat": 39.7153,
            "long": -88.47,
            "name": "Arthur, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Aurora",
            "id": 480,
            "is_region": null,
            "is_state": false,
            "lat": 41.7639,
            "long": -88.29,
            "name": "Aurora, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Belleville",
            "id": 481,
            "is_region": null,
            "is_state": false,
            "lat": 38.5217,
            "long": -89.9953,
            "name": "Belleville, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Belvidere",
            "id": 482,
            "is_region": null,
            "is_state": false,
            "lat": 42.2547,
            "long": -88.8442,
            "name": "Belvidere, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Bloomington",
            "id": 483,
            "is_region": null,
            "is_state": false,
            "lat": 40.4842,
            "long": -88.9936,
            "name": "Bloomington, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Brookfield",
            "id": 484,
            "is_region": null,
            "is_state": false,
            "lat": 41.8228,
            "long": -87.8475,
            "name": "Brookfield, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Cahokia",
            "id": 485,
            "is_region": null,
            "is_state": false,
            "lat": 38.5619,
            "long": -90.1728,
            "name": "Cahokia, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Cairo",
            "id": 486,
            "is_region": null,
            "is_state": false,
            "lat": 37.0131,
            "long": -89.1803,
            "name": "Cairo, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Calumet City",
            "id": 487,
            "is_region": null,
            "is_state": false,
            "lat": 41.6142,
            "long": -87.5464,
            "name": "Calumet City, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Canton",
            "id": 488,
            "is_region": null,
            "is_state": false,
            "lat": 40.5578,
            "long": -90.0342,
            "name": "Canton, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Carbondale",
            "id": 489,
            "is_region": null,
            "is_state": false,
            "lat": 37.726,
            "long": -89.22,
            "name": "Carbondale, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Carlinville",
            "id": 490,
            "is_region": null,
            "is_state": false,
            "lat": 39.267,
            "long": -89.883,
            "name": "Carlinville, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Carthage",
            "id": 491,
            "is_region": null,
            "is_state": false,
            "lat": 40.4144,
            "long": -91.1333,
            "name": "Carthage, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Centralia",
            "id": 492,
            "is_region": null,
            "is_state": false,
            "lat": 38.5253,
            "long": -89.1325,
            "name": "Centralia, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Champaign",
            "id": 493,
            "is_region": null,
            "is_state": false,
            "lat": 40.115,
            "long": -88.2728,
            "name": "Champaign, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Charleston",
            "id": 494,
            "is_region": null,
            "is_state": false,
            "lat": 39.4847,
            "long": -88.1781,
            "name": "Charleston, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Chester",
            "id": 495,
            "is_region": null,
            "is_state": false,
            "lat": 37.9139,
            "long": -89.8231,
            "name": "Chester, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Chicago",
            "id": 496,
            "is_region": null,
            "is_state": false,
            "lat": 41.8369,
            "long": -87.6847,
            "name": "Chicago, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Chicago Heights",
            "id": 497,
            "is_region": null,
            "is_state": false,
            "lat": 41.5119,
            "long": -87.6403,
            "name": "Chicago Heights, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Cicero",
            "id": 498,
            "is_region": null,
            "is_state": false,
            "lat": 41.8444,
            "long": -87.7592,
            "name": "Cicero, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Collinsville",
            "id": 499,
            "is_region": null,
            "is_state": false,
            "lat": 38.6744,
            "long": -89.9953,
            "name": "Collinsville, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Danville",
            "id": 500,
            "is_region": null,
            "is_state": false,
            "lat": 40.1244,
            "long": -87.63,
            "name": "Danville, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Decatur",
            "id": 501,
            "is_region": null,
            "is_state": false,
            "lat": 39.8414,
            "long": -88.9559,
            "name": "Decatur, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "DeKalb",
            "id": 502,
            "is_region": null,
            "is_state": false,
            "lat": 41.9314,
            "long": -88.7503,
            "name": "DeKalb, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Des Plaines",
            "id": 503,
            "is_region": null,
            "is_state": false,
            "lat": 42.0339,
            "long": -87.8997,
            "name": "Des Plaines, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Dixon",
            "id": 504,
            "is_region": null,
            "is_state": false,
            "lat": 41.8461,
            "long": -89.485,
            "name": "Dixon, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "East Moline",
            "id": 505,
            "is_region": null,
            "is_state": false,
            "lat": 41.5119,
            "long": -90.4353,
            "name": "East Moline, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "East Saint Louis",
            "id": 506,
            "is_region": null,
            "is_state": false,
            "lat": 38.617,
            "long": -90.133,
            "name": "East Saint Louis, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Effingham",
            "id": 507,
            "is_region": null,
            "is_state": false,
            "lat": 39.1208,
            "long": -88.5458,
            "name": "Effingham, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Elgin",
            "id": 508,
            "is_region": null,
            "is_state": false,
            "lat": 42.0383,
            "long": -88.3228,
            "name": "Elgin, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Elmhurst",
            "id": 509,
            "is_region": null,
            "is_state": false,
            "lat": 41.8922,
            "long": -87.9439,
            "name": "Elmhurst, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Evanston",
            "id": 510,
            "is_region": null,
            "is_state": false,
            "lat": 42.0464,
            "long": -87.6947,
            "name": "Evanston, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Freeport",
            "id": 511,
            "is_region": null,
            "is_state": false,
            "lat": 42.2919,
            "long": -89.6303,
            "name": "Freeport, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Galena",
            "id": 512,
            "is_region": null,
            "is_state": false,
            "lat": 42.417,
            "long": -90.433,
            "name": "Galena, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Galesburg",
            "id": 513,
            "is_region": null,
            "is_state": false,
            "lat": 40.9522,
            "long": -90.3686,
            "name": "Galesburg, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Glen Ellyn",
            "id": 514,
            "is_region": null,
            "is_state": false,
            "lat": 41.8711,
            "long": -88.0631,
            "name": "Glen Ellyn, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Glenview",
            "id": 515,
            "is_region": null,
            "is_state": false,
            "lat": 42.0794,
            "long": -87.8156,
            "name": "Glenview, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Granite City",
            "id": 516,
            "is_region": null,
            "is_state": false,
            "lat": 38.7178,
            "long": -90.1294,
            "name": "Granite City, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Harrisburg",
            "id": 517,
            "is_region": null,
            "is_state": false,
            "lat": 37.7339,
            "long": -88.5458,
            "name": "Harrisburg, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Herrin",
            "id": 518,
            "is_region": null,
            "is_state": false,
            "lat": 37.8025,
            "long": -89.0281,
            "name": "Herrin, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Highland Park",
            "id": 519,
            "is_region": null,
            "is_state": false,
            "lat": 42.1825,
            "long": -87.8069,
            "name": "Highland Park, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Jacksonville",
            "id": 520,
            "is_region": null,
            "is_state": false,
            "lat": 39.7319,
            "long": -90.2344,
            "name": "Jacksonville, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Joliet",
            "id": 521,
            "is_region": null,
            "is_state": false,
            "lat": 41.5206,
            "long": -88.1506,
            "name": "Joliet, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Kankakee",
            "id": 522,
            "is_region": null,
            "is_state": false,
            "lat": 41.12,
            "long": -87.8611,
            "name": "Kankakee, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Kaskaskia",
            "id": 523,
            "is_region": null,
            "is_state": false,
            "lat": 37.9214,
            "long": -89.9164,
            "name": "Kaskaskia, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Kewanee",
            "id": 524,
            "is_region": null,
            "is_state": false,
            "lat": 41.233,
            "long": -89.933,
            "name": "Kewanee, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "La Salle",
            "id": 525,
            "is_region": null,
            "is_state": false,
            "lat": 41.3411,
            "long": -89.0908,
            "name": "La Salle, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Lake Forest",
            "id": 526,
            "is_region": null,
            "is_state": false,
            "lat": 42.2347,
            "long": -87.8508,
            "name": "Lake Forest, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Libertyville",
            "id": 527,
            "is_region": null,
            "is_state": false,
            "lat": 42.2842,
            "long": -87.9607,
            "name": "Libertyville, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Lincoln",
            "id": 528,
            "is_region": null,
            "is_state": false,
            "lat": 40.15,
            "long": -89.3675,
            "name": "Lincoln, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Lisle",
            "id": 529,
            "is_region": null,
            "is_state": false,
            "lat": 41.7925,
            "long": -88.0883,
            "name": "Lisle, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Lombard",
            "id": 530,
            "is_region": null,
            "is_state": false,
            "lat": 41.8761,
            "long": -88.015,
            "name": "Lombard, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Macomb",
            "id": 531,
            "is_region": null,
            "is_state": false,
            "lat": 40.4605,
            "long": -90.674,
            "name": "Macomb, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Mattoon",
            "id": 532,
            "is_region": null,
            "is_state": false,
            "lat": 39.4789,
            "long": -88.3731,
            "name": "Mattoon, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Moline",
            "id": 533,
            "is_region": null,
            "is_state": false,
            "lat": 41.4858,
            "long": -90.4997,
            "name": "Moline, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Monmouth",
            "id": 534,
            "is_region": null,
            "is_state": false,
            "lat": 40.9117,
            "long": -90.6444,
            "name": "Monmouth, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Mount Vernon",
            "id": 535,
            "is_region": null,
            "is_state": false,
            "lat": 38.3172,
            "long": -88.9031,
            "name": "Mount Vernon, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Mundelein",
            "id": 536,
            "is_region": null,
            "is_state": false,
            "lat": 42.267,
            "long": -88.0,
            "name": "Mundelein, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Naperville",
            "id": 537,
            "is_region": null,
            "is_state": false,
            "lat": 41.7481,
            "long": -88.1656,
            "name": "Naperville, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Nauvoo",
            "id": 538,
            "is_region": null,
            "is_state": false,
            "lat": 40.55,
            "long": -91.383,
            "name": "Nauvoo, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Normal",
            "id": 539,
            "is_region": null,
            "is_state": false,
            "lat": 40.5122,
            "long": -88.9886,
            "name": "Normal, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "North Chicago",
            "id": 540,
            "is_region": null,
            "is_state": false,
            "lat": 42.3222,
            "long": -87.8544,
            "name": "North Chicago, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Oak Park",
            "id": 541,
            "is_region": null,
            "is_state": false,
            "lat": 41.883,
            "long": -87.8,
            "name": "Oak Park, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Oregon",
            "id": 542,
            "is_region": null,
            "is_state": false,
            "lat": 42.0146,
            "long": -89.3325,
            "name": "Oregon, IL",
            "region_id": 2535,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Ottawa",
            "id": 543,
            "is_region": null,
            "is_state": false,
            "lat": 41.3511,
            "long": -88.8378,
            "name": "Ottawa, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Palatine",
            "id": 544,
            "is_region": null,
            "is_state": false,
            "lat": 42.1169,
            "long": -88.0406,
            "name": "Palatine, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Park Forest",
            "id": 545,
            "is_region": null,
            "is_state": false,
            "lat": 41.492,
            "long": -87.674,
            "name": "Park Forest, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Park Ridge",
            "id": 546,
            "is_region": null,
            "is_state": false,
            "lat": 42.0119,
            "long": -87.8417,
            "name": "Park Ridge, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Pekin",
            "id": 547,
            "is_region": null,
            "is_state": false,
            "lat": 40.5678,
            "long": -89.6369,
            "name": "Pekin, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Peoria",
            "id": 548,
            "is_region": null,
            "is_state": false,
            "lat": 40.7208,
            "long": -89.6094,
            "name": "Peoria, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Petersburg",
            "id": 549,
            "is_region": null,
            "is_state": false,
            "lat": 40.0114,
            "long": -89.8514,
            "name": "Petersburg, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Pontiac",
            "id": 550,
            "is_region": null,
            "is_state": false,
            "lat": 40.88,
            "long": -88.6303,
            "name": "Pontiac, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Quincy",
            "id": 551,
            "is_region": null,
            "is_state": false,
            "lat": 39.9322,
            "long": -91.3886,
            "name": "Quincy, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Rantoul",
            "id": 552,
            "is_region": null,
            "is_state": false,
            "lat": 40.3047,
            "long": -88.1519,
            "name": "Rantoul, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "River Forest",
            "id": 553,
            "is_region": null,
            "is_state": false,
            "lat": 41.8931,
            "long": -87.8175,
            "name": "River Forest, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Rock Island",
            "id": 554,
            "is_region": null,
            "is_state": false,
            "lat": 41.4892,
            "long": -90.5731,
            "name": "Rock Island, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Rockford",
            "id": 555,
            "is_region": null,
            "is_state": false,
            "lat": 42.2594,
            "long": -89.0644,
            "name": "Rockford, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Salem",
            "id": 556,
            "is_region": null,
            "is_state": false,
            "lat": 38.633,
            "long": -88.95,
            "name": "Salem, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Shawneetown",
            "id": 557,
            "is_region": null,
            "is_state": false,
            "lat": 37.7147,
            "long": -88.1833,
            "name": "Shawneetown, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Skokie",
            "id": 558,
            "is_region": null,
            "is_state": false,
            "lat": 42.0333,
            "long": -87.7428,
            "name": "Skokie, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "South Holland",
            "id": 559,
            "is_region": null,
            "is_state": false,
            "lat": 41.6,
            "long": -87.6,
            "name": "South Holland, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Springfield",
            "id": 560,
            "is_region": null,
            "is_state": false,
            "lat": 39.6983,
            "long": -89.6197,
            "name": "Springfield, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Streator",
            "id": 561,
            "is_region": null,
            "is_state": false,
            "lat": 41.1208,
            "long": -88.8339,
            "name": "Streator, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Summit",
            "id": 562,
            "is_region": null,
            "is_state": false,
            "lat": 41.783,
            "long": -87.817,
            "name": "Summit, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Urbana",
            "id": 563,
            "is_region": null,
            "is_state": false,
            "lat": 40.1097,
            "long": -88.2042,
            "name": "Urbana, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Vandalia",
            "id": 564,
            "is_region": null,
            "is_state": false,
            "lat": 38.9681,
            "long": -89.1019,
            "name": "Vandalia, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Virden",
            "id": 565,
            "is_region": null,
            "is_state": false,
            "lat": 39.5,
            "long": -89.767,
            "name": "Virden, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Waukegan",
            "id": 566,
            "is_region": null,
            "is_state": false,
            "lat": 42.3703,
            "long": -87.8711,
            "name": "Waukegan, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Wheaton",
            "id": 567,
            "is_region": null,
            "is_state": false,
            "lat": 41.8561,
            "long": -88.1083,
            "name": "Wheaton, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Wilmette",
            "id": 568,
            "is_region": null,
            "is_state": false,
            "lat": 42.0772,
            "long": -87.7236,
            "name": "Wilmette, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Winnetka",
            "id": 569,
            "is_region": null,
            "is_state": false,
            "lat": 42.1061,
            "long": -87.7378,
            "name": "Winnetka, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Wood River",
            "id": 570,
            "is_region": null,
            "is_state": false,
            "lat": 38.8631,
            "long": -90.0886,
            "name": "Wood River, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IL",
            "city": "Zion",
            "id": 571,
            "is_region": null,
            "is_state": false,
            "lat": 42.4533,
            "long": -87.8403,
            "name": "Zion, IL",
            "region_id": null,
            "state": "Illinois"
        },
        {
            "abbr": "IN",
            "city": "Anderson",
            "id": 572,
            "is_region": null,
            "is_state": false,
            "lat": 40.1,
            "long": -85.6814,
            "name": "Anderson, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Bedford",
            "id": 573,
            "is_region": null,
            "is_state": false,
            "lat": 38.8628,
            "long": -86.4922,
            "name": "Bedford, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Bloomington",
            "id": 574,
            "is_region": null,
            "is_state": false,
            "lat": 39.1622,
            "long": -86.5292,
            "name": "Bloomington, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Columbus",
            "id": 575,
            "is_region": null,
            "is_state": false,
            "lat": 39.2139,
            "long": -85.9111,
            "name": "Columbus, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Connersville",
            "id": 576,
            "is_region": null,
            "is_state": false,
            "lat": 39.6539,
            "long": -85.1378,
            "name": "Connersville, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Corydon",
            "id": 577,
            "is_region": null,
            "is_state": false,
            "lat": 38.2128,
            "long": -86.1253,
            "name": "Corydon, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Crawfordsville",
            "id": 578,
            "is_region": null,
            "is_state": false,
            "lat": 40.0389,
            "long": -86.8967,
            "name": "Crawfordsville, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "East Chicago",
            "id": 579,
            "is_region": null,
            "is_state": false,
            "lat": 41.6389,
            "long": -87.4622,
            "name": "East Chicago, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Elkhart",
            "id": 580,
            "is_region": null,
            "is_state": false,
            "lat": 41.6831,
            "long": -85.9689,
            "name": "Elkhart, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Elwood",
            "id": 581,
            "is_region": null,
            "is_state": false,
            "lat": 40.2742,
            "long": -85.8381,
            "name": "Elwood, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Evansville",
            "id": 582,
            "is_region": null,
            "is_state": false,
            "lat": 37.9772,
            "long": -87.5506,
            "name": "Evansville, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Fort Wayne",
            "id": 583,
            "is_region": null,
            "is_state": false,
            "lat": 41.0804,
            "long": -85.1392,
            "name": "Fort Wayne, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "French Lick",
            "id": 584,
            "is_region": null,
            "is_state": false,
            "lat": 38.5469,
            "long": -86.6189,
            "name": "French Lick, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Gary",
            "id": 585,
            "is_region": null,
            "is_state": false,
            "lat": 41.5956,
            "long": -87.3453,
            "name": "Gary, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Geneva",
            "id": 586,
            "is_region": null,
            "is_state": false,
            "lat": 40.5925,
            "long": -84.96,
            "name": "Geneva, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Goshen",
            "id": 587,
            "is_region": null,
            "is_state": false,
            "lat": 41.5819,
            "long": -85.8367,
            "name": "Goshen, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Greenfield",
            "id": 588,
            "is_region": null,
            "is_state": false,
            "lat": 39.7914,
            "long": -85.7714,
            "name": "Greenfield, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Hammond",
            "id": 589,
            "is_region": null,
            "is_state": false,
            "lat": 41.6111,
            "long": -87.4931,
            "name": "Hammond, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Hobart",
            "id": 590,
            "is_region": null,
            "is_state": false,
            "lat": 41.5286,
            "long": -87.2675,
            "name": "Hobart, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Huntington",
            "id": 591,
            "is_region": null,
            "is_state": false,
            "lat": 40.8819,
            "long": -85.4956,
            "name": "Huntington, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Indianapolis",
            "id": 592,
            "is_region": null,
            "is_state": false,
            "lat": 39.767,
            "long": -86.15,
            "name": "Indianapolis, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Jeffersonville",
            "id": 593,
            "is_region": null,
            "is_state": false,
            "lat": 38.2956,
            "long": -85.7314,
            "name": "Jeffersonville, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Kokomo",
            "id": 594,
            "is_region": null,
            "is_state": false,
            "lat": 40.4822,
            "long": -86.1317,
            "name": "Kokomo, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Lafayette",
            "id": 595,
            "is_region": null,
            "is_state": false,
            "lat": 40.4172,
            "long": -86.8786,
            "name": "Lafayette, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Madison",
            "id": 596,
            "is_region": null,
            "is_state": false,
            "lat": 38.75,
            "long": -85.4,
            "name": "Madison, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Marion",
            "id": 597,
            "is_region": null,
            "is_state": false,
            "lat": 40.5492,
            "long": -85.6647,
            "name": "Marion, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Michigan City",
            "id": 598,
            "is_region": null,
            "is_state": false,
            "lat": 41.7094,
            "long": -86.8869,
            "name": "Michigan City, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Mishawaka",
            "id": 599,
            "is_region": null,
            "is_state": false,
            "lat": 41.6675,
            "long": -86.1714,
            "name": "Mishawaka, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Muncie",
            "id": 600,
            "is_region": null,
            "is_state": false,
            "lat": 40.1933,
            "long": -85.3881,
            "name": "Muncie, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Nappanee",
            "id": 601,
            "is_region": null,
            "is_state": false,
            "lat": 41.4442,
            "long": -85.9994,
            "name": "Nappanee, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Nashville",
            "id": 602,
            "is_region": null,
            "is_state": false,
            "lat": 39.2031,
            "long": -86.2383,
            "name": "Nashville, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "New Albany",
            "id": 603,
            "is_region": null,
            "is_state": false,
            "lat": 38.3019,
            "long": -85.8214,
            "name": "New Albany, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "New Castle",
            "id": 604,
            "is_region": null,
            "is_state": false,
            "lat": 39.9236,
            "long": -85.365,
            "name": "New Castle, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "New Harmony",
            "id": 605,
            "is_region": null,
            "is_state": false,
            "lat": 38.1286,
            "long": -87.9342,
            "name": "New Harmony, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Peru",
            "id": 606,
            "is_region": null,
            "is_state": false,
            "lat": 40.7578,
            "long": -86.0678,
            "name": "Peru, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Plymouth",
            "id": 607,
            "is_region": null,
            "is_state": false,
            "lat": 41.3439,
            "long": -86.3125,
            "name": "Plymouth, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Richmond",
            "id": 608,
            "is_region": null,
            "is_state": false,
            "lat": 39.8303,
            "long": -84.8906,
            "name": "Richmond, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Santa Claus",
            "id": 609,
            "is_region": null,
            "is_state": false,
            "lat": 38.1189,
            "long": -86.9214,
            "name": "Santa Claus, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Shelbyville",
            "id": 610,
            "is_region": null,
            "is_state": false,
            "lat": 39.5219,
            "long": -85.7764,
            "name": "Shelbyville, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "South Bend",
            "id": 611,
            "is_region": null,
            "is_state": false,
            "lat": 41.6725,
            "long": -86.2553,
            "name": "South Bend, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Terre Haute",
            "id": 612,
            "is_region": null,
            "is_state": false,
            "lat": 39.4697,
            "long": -87.3897,
            "name": "Terre Haute, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Valparaiso",
            "id": 613,
            "is_region": null,
            "is_state": false,
            "lat": 41.4761,
            "long": -87.0569,
            "name": "Valparaiso, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Vincennes",
            "id": 614,
            "is_region": null,
            "is_state": false,
            "lat": 38.6783,
            "long": -87.5161,
            "name": "Vincennes, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "Wabash",
            "id": 615,
            "is_region": null,
            "is_state": false,
            "lat": 40.8008,
            "long": -85.8272,
            "name": "Wabash, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IN",
            "city": "West Lafayette",
            "id": 616,
            "is_region": null,
            "is_state": false,
            "lat": 40.4419,
            "long": -86.9125,
            "name": "West Lafayette, IN",
            "region_id": null,
            "state": "Indiana"
        },
        {
            "abbr": "IA",
            "city": "Amana Colonies",
            "id": 617,
            "is_region": null,
            "is_state": false,
            "lat": 41.8002,
            "long": -91.8723,
            "name": "Amana Colonies, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Ames",
            "id": 618,
            "is_region": null,
            "is_state": false,
            "lat": 42.0347,
            "long": -93.62,
            "name": "Ames, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Boone",
            "id": 619,
            "is_region": null,
            "is_state": false,
            "lat": 42.0611,
            "long": -93.8861,
            "name": "Boone, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Burlington",
            "id": 620,
            "is_region": null,
            "is_state": false,
            "lat": 40.8081,
            "long": -91.1158,
            "name": "Burlington, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Cedar Falls",
            "id": 621,
            "is_region": null,
            "is_state": false,
            "lat": 42.5235,
            "long": -92.4464,
            "name": "Cedar Falls, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Cedar Rapids",
            "id": 622,
            "is_region": null,
            "is_state": false,
            "lat": 41.9831,
            "long": -91.6686,
            "name": "Cedar Rapids, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Charles City",
            "id": 623,
            "is_region": null,
            "is_state": false,
            "lat": 43.0664,
            "long": -92.6758,
            "name": "Charles City, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Cherokee",
            "id": 624,
            "is_region": null,
            "is_state": false,
            "lat": 42.75,
            "long": -95.55,
            "name": "Cherokee, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Clinton",
            "id": 625,
            "is_region": null,
            "is_state": false,
            "lat": 41.8469,
            "long": -90.2072,
            "name": "Clinton, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Council Bluffs",
            "id": 626,
            "is_region": null,
            "is_state": false,
            "lat": 41.25,
            "long": -95.867,
            "name": "Council Bluffs, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Davenport",
            "id": 627,
            "is_region": null,
            "is_state": false,
            "lat": 41.5431,
            "long": -90.5908,
            "name": "Davenport, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Des Moines",
            "id": 628,
            "is_region": null,
            "is_state": false,
            "lat": 41.5908,
            "long": -93.6208,
            "name": "Des Moines, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Dubuque",
            "id": 629,
            "is_region": null,
            "is_state": false,
            "lat": 42.5,
            "long": -90.69,
            "name": "Dubuque, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Estherville",
            "id": 630,
            "is_region": null,
            "is_state": false,
            "lat": 43.4044,
            "long": -94.8336,
            "name": "Estherville, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Fairfield",
            "id": 631,
            "is_region": null,
            "is_state": false,
            "lat": 41.0072,
            "long": -91.9658,
            "name": "Fairfield, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Fort Dodge",
            "id": 632,
            "is_region": null,
            "is_state": false,
            "lat": 42.5067,
            "long": -94.1803,
            "name": "Fort Dodge, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Grinnell",
            "id": 633,
            "is_region": null,
            "is_state": false,
            "lat": 41.7436,
            "long": -92.7247,
            "name": "Grinnell, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Indianola",
            "id": 634,
            "is_region": null,
            "is_state": false,
            "lat": 41.3617,
            "long": -93.5631,
            "name": "Indianola, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Iowa City",
            "id": 635,
            "is_region": null,
            "is_state": false,
            "lat": 41.66,
            "long": -91.53,
            "name": "Iowa City, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Keokuk",
            "id": 636,
            "is_region": null,
            "is_state": false,
            "lat": 40.3972,
            "long": -91.385,
            "name": "Keokuk, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Mason City",
            "id": 637,
            "is_region": null,
            "is_state": false,
            "lat": 43.1486,
            "long": -93.2019,
            "name": "Mason City, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Mount Pleasant",
            "id": 638,
            "is_region": null,
            "is_state": false,
            "lat": 40.9669,
            "long": -91.5511,
            "name": "Mount Pleasant, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Muscatine",
            "id": 639,
            "is_region": null,
            "is_state": false,
            "lat": 41.4239,
            "long": -91.0561,
            "name": "Muscatine, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Newton",
            "id": 640,
            "is_region": null,
            "is_state": false,
            "lat": 41.6986,
            "long": -93.0469,
            "name": "Newton, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Oskaloosa",
            "id": 641,
            "is_region": null,
            "is_state": false,
            "lat": 41.2939,
            "long": -92.6444,
            "name": "Oskaloosa, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Ottumwa",
            "id": 642,
            "is_region": null,
            "is_state": false,
            "lat": 41.0131,
            "long": -92.4147,
            "name": "Ottumwa, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Sioux City",
            "id": 643,
            "is_region": null,
            "is_state": false,
            "lat": 42.4981,
            "long": -96.3956,
            "name": "Sioux City, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Waterloo",
            "id": 644,
            "is_region": null,
            "is_state": false,
            "lat": 42.4925,
            "long": -92.3461,
            "name": "Waterloo, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "Webster City",
            "id": 645,
            "is_region": null,
            "is_state": false,
            "lat": 42.4664,
            "long": -93.8206,
            "name": "Webster City, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "IA",
            "city": "West Des Moines",
            "id": 646,
            "is_region": null,
            "is_state": false,
            "lat": 41.575,
            "long": -93.7092,
            "name": "West Des Moines, IA",
            "region_id": null,
            "state": "Iowa"
        },
        {
            "abbr": "KS",
            "city": "Abilene",
            "id": 647,
            "is_region": null,
            "is_state": false,
            "lat": 38.9172,
            "long": -97.2139,
            "name": "Abilene, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Arkansas City",
            "id": 648,
            "is_region": null,
            "is_state": false,
            "lat": 37.0653,
            "long": -97.0397,
            "name": "Arkansas City, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Atchison",
            "id": 649,
            "is_region": null,
            "is_state": false,
            "lat": 39.5625,
            "long": -95.1283,
            "name": "Atchison, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Chanute",
            "id": 650,
            "is_region": null,
            "is_state": false,
            "lat": 37.6769,
            "long": -95.4564,
            "name": "Chanute, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Coffeyville",
            "id": 651,
            "is_region": null,
            "is_state": false,
            "lat": 37.0378,
            "long": -95.6264,
            "name": "Coffeyville, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Council Grove",
            "id": 652,
            "is_region": null,
            "is_state": false,
            "lat": 38.6606,
            "long": -96.4897,
            "name": "Council Grove, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Dodge City",
            "id": 653,
            "is_region": null,
            "is_state": false,
            "lat": 37.7597,
            "long": -100.018,
            "name": "Dodge City, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Emporia",
            "id": 654,
            "is_region": null,
            "is_state": false,
            "lat": 38.4039,
            "long": -96.1817,
            "name": "Emporia, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Fort Scott",
            "id": 655,
            "is_region": null,
            "is_state": false,
            "lat": 37.8353,
            "long": -94.7019,
            "name": "Fort Scott, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Garden City",
            "id": 656,
            "is_region": null,
            "is_state": false,
            "lat": 37.9753,
            "long": -100.864,
            "name": "Garden City, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Great Bend",
            "id": 657,
            "is_region": null,
            "is_state": false,
            "lat": 38.3644,
            "long": -98.7647,
            "name": "Great Bend, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Hays",
            "id": 658,
            "is_region": null,
            "is_state": false,
            "lat": 38.8794,
            "long": -99.3222,
            "name": "Hays, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Hutchinson",
            "id": 659,
            "is_region": null,
            "is_state": false,
            "lat": 38.0608,
            "long": -97.9297,
            "name": "Hutchinson, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Independence",
            "id": 660,
            "is_region": null,
            "is_state": false,
            "lat": 37.2242,
            "long": -95.7083,
            "name": "Independence, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Junction City",
            "id": 661,
            "is_region": null,
            "is_state": false,
            "lat": 39.0275,
            "long": -96.8403,
            "name": "Junction City, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Kansas City",
            "id": 662,
            "is_region": null,
            "is_state": false,
            "lat": 39.1067,
            "long": -94.6764,
            "name": "Kansas City, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Lawrence",
            "id": 663,
            "is_region": null,
            "is_state": false,
            "lat": 38.9717,
            "long": -95.2353,
            "name": "Lawrence, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Leavenworth",
            "id": 664,
            "is_region": null,
            "is_state": false,
            "lat": 39.3111,
            "long": -94.9225,
            "name": "Leavenworth, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Liberal",
            "id": 665,
            "is_region": null,
            "is_state": false,
            "lat": 37.0433,
            "long": -100.928,
            "name": "Liberal, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Manhattan",
            "id": 666,
            "is_region": null,
            "is_state": false,
            "lat": 39.1917,
            "long": -96.5917,
            "name": "Manhattan, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "McPherson",
            "id": 667,
            "is_region": null,
            "is_state": false,
            "lat": 38.3719,
            "long": -97.6622,
            "name": "McPherson, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Medicine Lodge",
            "id": 668,
            "is_region": null,
            "is_state": false,
            "lat": 37.2844,
            "long": -98.5811,
            "name": "Medicine Lodge, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Newton",
            "id": 669,
            "is_region": null,
            "is_state": false,
            "lat": 38.0467,
            "long": -97.345,
            "name": "Newton, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Olathe",
            "id": 670,
            "is_region": null,
            "is_state": false,
            "lat": 38.8814,
            "long": -94.8192,
            "name": "Olathe, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Osawatomie",
            "id": 671,
            "is_region": null,
            "is_state": false,
            "lat": 38.5017,
            "long": -94.9508,
            "name": "Osawatomie, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Ottawa",
            "id": 672,
            "is_region": null,
            "is_state": false,
            "lat": 38.6119,
            "long": -95.2664,
            "name": "Ottawa, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Overland Park",
            "id": 673,
            "is_region": null,
            "is_state": false,
            "lat": 38.9822,
            "long": -94.6708,
            "name": "Overland Park, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Pittsburg",
            "id": 674,
            "is_region": null,
            "is_state": false,
            "lat": 37.4108,
            "long": -94.705,
            "name": "Pittsburg, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Salina",
            "id": 675,
            "is_region": null,
            "is_state": false,
            "lat": 38.8403,
            "long": -97.6114,
            "name": "Salina, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Shawnee",
            "id": 676,
            "is_region": null,
            "is_state": false,
            "lat": 39.0128,
            "long": -94.7658,
            "name": "Shawnee, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Smith Center",
            "id": 677,
            "is_region": null,
            "is_state": false,
            "lat": 39.7786,
            "long": -98.7853,
            "name": "Smith Center, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Topeka",
            "id": 678,
            "is_region": null,
            "is_state": false,
            "lat": 39.0558,
            "long": -95.6894,
            "name": "Topeka, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KS",
            "city": "Wichita",
            "id": 679,
            "is_region": null,
            "is_state": false,
            "lat": 37.6889,
            "long": -97.3361,
            "name": "Wichita, KS",
            "region_id": null,
            "state": "Kansas"
        },
        {
            "abbr": "KY",
            "city": "Ashland",
            "id": 680,
            "is_region": null,
            "is_state": false,
            "lat": 38.4639,
            "long": -82.6417,
            "name": "Ashland, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Barbourville",
            "id": 681,
            "is_region": null,
            "is_state": false,
            "lat": 36.8611,
            "long": -83.8794,
            "name": "Barbourville, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Bardstown",
            "id": 682,
            "is_region": null,
            "is_state": false,
            "lat": 37.8156,
            "long": -85.4631,
            "name": "Bardstown, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Berea",
            "id": 683,
            "is_region": null,
            "is_state": false,
            "lat": 37.5769,
            "long": -84.2936,
            "name": "Berea, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Boonesborough",
            "id": 684,
            "is_region": null,
            "is_state": false,
            "lat": 37.9083,
            "long": -84.2719,
            "name": "Boonesborough, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Bowling Green",
            "id": 685,
            "is_region": null,
            "is_state": false,
            "lat": 36.9817,
            "long": -86.4444,
            "name": "Bowling Green, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Campbellsville",
            "id": 686,
            "is_region": null,
            "is_state": false,
            "lat": 37.3458,
            "long": -85.3456,
            "name": "Campbellsville, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Covington",
            "id": 687,
            "is_region": null,
            "is_state": false,
            "lat": 39.065,
            "long": -84.5097,
            "name": "Covington, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Danville",
            "id": 688,
            "is_region": null,
            "is_state": false,
            "lat": 37.6456,
            "long": -84.7697,
            "name": "Danville, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Elizabethtown",
            "id": 689,
            "is_region": null,
            "is_state": false,
            "lat": 37.7,
            "long": -85.867,
            "name": "Elizabethtown, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Frankfort",
            "id": 690,
            "is_region": null,
            "is_state": false,
            "lat": 38.2,
            "long": -84.867,
            "name": "Frankfort, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Harlan",
            "id": 691,
            "is_region": null,
            "is_state": false,
            "lat": 36.8414,
            "long": -83.32,
            "name": "Harlan, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Harrodsburg",
            "id": 692,
            "is_region": null,
            "is_state": false,
            "lat": 37.7639,
            "long": -84.8461,
            "name": "Harrodsburg, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Hazard",
            "id": 693,
            "is_region": null,
            "is_state": false,
            "lat": 37.2486,
            "long": -83.195,
            "name": "Hazard, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Henderson",
            "id": 694,
            "is_region": null,
            "is_state": false,
            "lat": 37.8356,
            "long": -87.5808,
            "name": "Henderson, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Hodgenville",
            "id": 695,
            "is_region": null,
            "is_state": false,
            "lat": 37.5711,
            "long": -85.7386,
            "name": "Hodgenville, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Hopkinsville",
            "id": 696,
            "is_region": null,
            "is_state": false,
            "lat": 36.8547,
            "long": -87.4889,
            "name": "Hopkinsville, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Lexington",
            "id": 697,
            "is_region": null,
            "is_state": false,
            "lat": 38.0297,
            "long": -84.4947,
            "name": "Lexington, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Louisville",
            "id": 698,
            "is_region": null,
            "is_state": false,
            "lat": 38.2253,
            "long": -85.7417,
            "name": "Louisville, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Mayfield",
            "id": 699,
            "is_region": null,
            "is_state": false,
            "lat": 36.7378,
            "long": -88.64,
            "name": "Mayfield, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Maysville",
            "id": 700,
            "is_region": null,
            "is_state": false,
            "lat": 38.6439,
            "long": -83.7758,
            "name": "Maysville, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Middlesboro",
            "id": 701,
            "is_region": null,
            "is_state": false,
            "lat": 36.6103,
            "long": -83.7233,
            "name": "Middlesboro, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Newport",
            "id": 702,
            "is_region": null,
            "is_state": false,
            "lat": 39.0886,
            "long": -84.4903,
            "name": "Newport, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Owensboro",
            "id": 703,
            "is_region": null,
            "is_state": false,
            "lat": 37.7578,
            "long": -87.1183,
            "name": "Owensboro, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Paducah",
            "id": 704,
            "is_region": null,
            "is_state": false,
            "lat": 37.0722,
            "long": -88.6275,
            "name": "Paducah, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Paris",
            "id": 705,
            "is_region": null,
            "is_state": false,
            "lat": 38.2064,
            "long": -84.2578,
            "name": "Paris, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "KY",
            "city": "Richmond",
            "id": 706,
            "is_region": null,
            "is_state": false,
            "lat": 37.7447,
            "long": -84.2936,
            "name": "Richmond, KY",
            "region_id": null,
            "state": "Kentucky"
        },
        {
            "abbr": "LA",
            "city": "Abbeville",
            "id": 707,
            "is_region": null,
            "is_state": false,
            "lat": 29.9725,
            "long": -92.1292,
            "name": "Abbeville, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Alexandria",
            "id": 708,
            "is_region": null,
            "is_state": false,
            "lat": 31.2928,
            "long": -92.4592,
            "name": "Alexandria, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Bastrop",
            "id": 709,
            "is_region": null,
            "is_state": false,
            "lat": 32.7778,
            "long": -91.915,
            "name": "Bastrop, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Baton Rouge",
            "id": 710,
            "is_region": null,
            "is_state": false,
            "lat": 30.4486,
            "long": -91.1258,
            "name": "Baton Rouge, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Bogalusa",
            "id": 711,
            "is_region": null,
            "is_state": false,
            "lat": 30.7806,
            "long": -89.8639,
            "name": "Bogalusa, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Bossier City",
            "id": 712,
            "is_region": null,
            "is_state": false,
            "lat": 32.5178,
            "long": -93.6914,
            "name": "Bossier City, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Gretna",
            "id": 713,
            "is_region": null,
            "is_state": false,
            "lat": 29.9164,
            "long": -90.0542,
            "name": "Gretna, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Houma",
            "id": 714,
            "is_region": null,
            "is_state": false,
            "lat": 29.5875,
            "long": -90.7161,
            "name": "Houma, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Lafayette",
            "id": 715,
            "is_region": null,
            "is_state": false,
            "lat": 30.217,
            "long": -92.033,
            "name": "Lafayette, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Lake Charles",
            "id": 716,
            "is_region": null,
            "is_state": false,
            "lat": 30.2147,
            "long": -93.2086,
            "name": "Lake Charles, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Monroe",
            "id": 717,
            "is_region": null,
            "is_state": false,
            "lat": 32.5094,
            "long": -92.1183,
            "name": "Monroe, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Morgan City",
            "id": 718,
            "is_region": null,
            "is_state": false,
            "lat": 29.7008,
            "long": -91.1972,
            "name": "Morgan City, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Natchitoches",
            "id": 719,
            "is_region": null,
            "is_state": false,
            "lat": 31.6931,
            "long": -93.095,
            "name": "Natchitoches, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "New Iberia",
            "id": 720,
            "is_region": null,
            "is_state": false,
            "lat": 30.0036,
            "long": -91.8183,
            "name": "New Iberia, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "New Orleans",
            "id": 721,
            "is_region": null,
            "is_state": false,
            "lat": 29.95,
            "long": -90.08,
            "name": "New Orleans, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Opelousas",
            "id": 722,
            "is_region": null,
            "is_state": false,
            "lat": 30.5281,
            "long": -92.0844,
            "name": "Opelousas, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Ruston",
            "id": 723,
            "is_region": null,
            "is_state": false,
            "lat": 32.5297,
            "long": -92.6406,
            "name": "Ruston, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Saint Martinville",
            "id": 724,
            "is_region": null,
            "is_state": false,
            "lat": 30.125,
            "long": -91.8306,
            "name": "Saint Martinville, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Shreveport",
            "id": 725,
            "is_region": null,
            "is_state": false,
            "lat": 32.5147,
            "long": -93.7472,
            "name": "Shreveport, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "LA",
            "city": "Thibodaux",
            "id": 726,
            "is_region": null,
            "is_state": false,
            "lat": 29.7922,
            "long": -90.82,
            "name": "Thibodaux, LA",
            "region_id": null,
            "state": "Louisiana"
        },
        {
            "abbr": "ME",
            "city": "Auburn",
            "id": 727,
            "is_region": null,
            "is_state": false,
            "lat": 44.083,
            "long": -70.233,
            "name": "Auburn, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Augusta",
            "id": 728,
            "is_region": null,
            "is_state": false,
            "lat": 44.3106,
            "long": -69.78,
            "name": "Augusta, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Bangor",
            "id": 729,
            "is_region": null,
            "is_state": false,
            "lat": 44.8,
            "long": -68.8,
            "name": "Bangor, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Bar Harbor",
            "id": 730,
            "is_region": null,
            "is_state": false,
            "lat": 44.3858,
            "long": -68.2094,
            "name": "Bar Harbor, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Bath",
            "id": 731,
            "is_region": null,
            "is_state": false,
            "lat": 43.9164,
            "long": -69.8225,
            "name": "Bath, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Belfast",
            "id": 732,
            "is_region": null,
            "is_state": false,
            "lat": 44.4258,
            "long": -69.0117,
            "name": "Belfast, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Biddeford",
            "id": 733,
            "is_region": null,
            "is_state": false,
            "lat": 43.4742,
            "long": -70.4461,
            "name": "Biddeford, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Boothbay Harbor",
            "id": 734,
            "is_region": null,
            "is_state": false,
            "lat": 43.8523,
            "long": -69.6281,
            "name": "Boothbay Harbor, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Brunswick",
            "id": 735,
            "is_region": null,
            "is_state": false,
            "lat": 43.9108,
            "long": -69.9631,
            "name": "Brunswick, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Calais",
            "id": 736,
            "is_region": null,
            "is_state": false,
            "lat": 45.1661,
            "long": -67.2425,
            "name": "Calais, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Caribou",
            "id": 737,
            "is_region": null,
            "is_state": false,
            "lat": 46.8636,
            "long": -67.9981,
            "name": "Caribou, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Castine",
            "id": 738,
            "is_region": null,
            "is_state": false,
            "lat": 44.4058,
            "long": -68.8069,
            "name": "Castine, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Eastport",
            "id": 739,
            "is_region": null,
            "is_state": false,
            "lat": 44.9136,
            "long": -67.0039,
            "name": "Eastport, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Ellsworth",
            "id": 740,
            "is_region": null,
            "is_state": false,
            "lat": 44.5722,
            "long": -68.4761,
            "name": "Ellsworth, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Farmington",
            "id": 741,
            "is_region": null,
            "is_state": false,
            "lat": 44.669,
            "long": -70.1464,
            "name": "Farmington, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Fort Kent",
            "id": 742,
            "is_region": null,
            "is_state": false,
            "lat": 47.2419,
            "long": -68.5722,
            "name": "Fort Kent, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Gardiner",
            "id": 743,
            "is_region": null,
            "is_state": false,
            "lat": 44.2292,
            "long": -69.7736,
            "name": "Gardiner, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Houlton",
            "id": 744,
            "is_region": null,
            "is_state": false,
            "lat": 46.1256,
            "long": -67.8397,
            "name": "Houlton, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Kennebunkport",
            "id": 745,
            "is_region": null,
            "is_state": false,
            "lat": 43.3808,
            "long": -70.4519,
            "name": "Kennebunkport, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Kittery",
            "id": 746,
            "is_region": null,
            "is_state": false,
            "lat": 43.0931,
            "long": -70.7281,
            "name": "Kittery, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Lewiston",
            "id": 747,
            "is_region": null,
            "is_state": false,
            "lat": 44.0975,
            "long": -70.1925,
            "name": "Lewiston, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Lubec",
            "id": 748,
            "is_region": null,
            "is_state": false,
            "lat": 44.8408,
            "long": -67.0156,
            "name": "Lubec, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Machias",
            "id": 749,
            "is_region": null,
            "is_state": false,
            "lat": 44.683,
            "long": -67.467,
            "name": "Machias, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Orono",
            "id": 750,
            "is_region": null,
            "is_state": false,
            "lat": 44.883,
            "long": -68.672,
            "name": "Orono, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Portland",
            "id": 751,
            "is_region": null,
            "is_state": false,
            "lat": 43.667,
            "long": -70.267,
            "name": "Portland, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Presque Isle",
            "id": 752,
            "is_region": null,
            "is_state": false,
            "lat": 46.6794,
            "long": -68.0022,
            "name": "Presque Isle, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Rockland",
            "id": 753,
            "is_region": null,
            "is_state": false,
            "lat": 44.1094,
            "long": -69.1147,
            "name": "Rockland, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Rumford",
            "id": 754,
            "is_region": null,
            "is_state": false,
            "lat": 44.55,
            "long": -70.55,
            "name": "Rumford, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Saco",
            "id": 755,
            "is_region": null,
            "is_state": false,
            "lat": 43.5106,
            "long": -70.445,
            "name": "Saco, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Scarborough",
            "id": 756,
            "is_region": null,
            "is_state": false,
            "lat": 43.5833,
            "long": -70.3528,
            "name": "Scarborough, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "Waterville",
            "id": 757,
            "is_region": null,
            "is_state": false,
            "lat": 44.5519,
            "long": -69.6458,
            "name": "Waterville, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "ME",
            "city": "York",
            "id": 758,
            "is_region": null,
            "is_state": false,
            "lat": 43.1633,
            "long": -70.6486,
            "name": "York, ME",
            "region_id": null,
            "state": "Maine"
        },
        {
            "abbr": "MD",
            "city": "Aberdeen",
            "id": 759,
            "is_region": null,
            "is_state": false,
            "lat": 39.5103,
            "long": -76.1692,
            "name": "Aberdeen, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Annapolis",
            "id": 760,
            "is_region": null,
            "is_state": false,
            "lat": 38.9731,
            "long": -76.5011,
            "name": "Annapolis, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Baltimore",
            "id": 761,
            "is_region": null,
            "is_state": false,
            "lat": 39.283,
            "long": -76.617,
            "name": "Baltimore, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Bethesda-Chevy Chase",
            "id": 762,
            "is_region": null,
            "is_state": false,
            "lat": 38.9711,
            "long": -77.0764,
            "name": "Bethesda-Chevy Chase, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Bowie",
            "id": 763,
            "is_region": null,
            "is_state": false,
            "lat": 38.9647,
            "long": -76.7444,
            "name": "Bowie, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Cambridge",
            "id": 764,
            "is_region": null,
            "is_state": false,
            "lat": 38.5664,
            "long": -76.0769,
            "name": "Cambridge, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Catonsville",
            "id": 765,
            "is_region": null,
            "is_state": false,
            "lat": 39.2739,
            "long": -76.7381,
            "name": "Catonsville, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "College Park",
            "id": 766,
            "is_region": null,
            "is_state": false,
            "lat": 38.9967,
            "long": -76.9275,
            "name": "College Park, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Columbia",
            "id": 767,
            "is_region": null,
            "is_state": false,
            "lat": 39.2036,
            "long": -76.8569,
            "name": "Columbia, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Cumberland",
            "id": 768,
            "is_region": null,
            "is_state": false,
            "lat": 39.6478,
            "long": -78.7628,
            "name": "Cumberland, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Easton",
            "id": 769,
            "is_region": null,
            "is_state": false,
            "lat": 38.7717,
            "long": -76.0706,
            "name": "Easton, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Elkton",
            "id": 770,
            "is_region": null,
            "is_state": false,
            "lat": 39.61,
            "long": -75.8258,
            "name": "Elkton, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Emmitsburg",
            "id": 771,
            "is_region": null,
            "is_state": false,
            "lat": 39.7047,
            "long": -77.3253,
            "name": "Emmitsburg, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Frederick",
            "id": 772,
            "is_region": null,
            "is_state": false,
            "lat": 39.4139,
            "long": -77.4111,
            "name": "Frederick, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Greenbelt",
            "id": 773,
            "is_region": null,
            "is_state": false,
            "lat": 39.0006,
            "long": -76.8883,
            "name": "Greenbelt, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Hagerstown",
            "id": 774,
            "is_region": null,
            "is_state": false,
            "lat": 39.6428,
            "long": -77.72,
            "name": "Hagerstown, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Hyattsville",
            "id": 775,
            "is_region": null,
            "is_state": false,
            "lat": 38.9569,
            "long": -76.9514,
            "name": "Hyattsville, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Laurel",
            "id": 776,
            "is_region": null,
            "is_state": false,
            "lat": 39.0958,
            "long": -76.8597,
            "name": "Laurel, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Oakland",
            "id": 777,
            "is_region": null,
            "is_state": false,
            "lat": 39.4106,
            "long": -79.4044,
            "name": "Oakland, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Ocean City",
            "id": 778,
            "is_region": null,
            "is_state": false,
            "lat": 38.3914,
            "long": -75.0697,
            "name": "Ocean City, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Rockville",
            "id": 779,
            "is_region": null,
            "is_state": false,
            "lat": 39.0836,
            "long": -77.1483,
            "name": "Rockville, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Saint Marys City",
            "id": 780,
            "is_region": null,
            "is_state": false,
            "lat": 38.1892,
            "long": -76.4322,
            "name": "Saint Marys City, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Salisbury",
            "id": 781,
            "is_region": null,
            "is_state": false,
            "lat": 38.3658,
            "long": -75.5933,
            "name": "Salisbury, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Silver Spring",
            "id": 782,
            "is_region": null,
            "is_state": false,
            "lat": 39.0042,
            "long": -77.0189,
            "name": "Silver Spring, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Takoma Park",
            "id": 783,
            "is_region": null,
            "is_state": false,
            "lat": 38.98,
            "long": -77.0022,
            "name": "Takoma Park, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Towson",
            "id": 784,
            "is_region": null,
            "is_state": false,
            "lat": 39.3931,
            "long": -76.6094,
            "name": "Towson, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MD",
            "city": "Westminster",
            "id": 785,
            "is_region": null,
            "is_state": false,
            "lat": 39.5767,
            "long": -77.0,
            "name": "Westminster, MD",
            "region_id": null,
            "state": "Maryland"
        },
        {
            "abbr": "MA",
            "city": "Abington",
            "id": 786,
            "is_region": null,
            "is_state": false,
            "lat": 42.1047,
            "long": -70.9458,
            "name": "Abington, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Adams",
            "id": 787,
            "is_region": null,
            "is_state": false,
            "lat": 42.6242,
            "long": -73.1181,
            "name": "Adams, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Amesbury",
            "id": 788,
            "is_region": null,
            "is_state": false,
            "lat": 42.8583,
            "long": -70.9306,
            "name": "Amesbury, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Amherst",
            "id": 789,
            "is_region": null,
            "is_state": false,
            "lat": 42.383,
            "long": -72.517,
            "name": "Amherst, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Andover",
            "id": 790,
            "is_region": null,
            "is_state": false,
            "lat": 42.6583,
            "long": -71.1375,
            "name": "Andover, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Arlington",
            "id": 791,
            "is_region": null,
            "is_state": false,
            "lat": 42.4153,
            "long": -71.1569,
            "name": "Arlington, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Athol",
            "id": 792,
            "is_region": null,
            "is_state": false,
            "lat": 42.5958,
            "long": -72.2272,
            "name": "Athol, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Attleboro",
            "id": 793,
            "is_region": null,
            "is_state": false,
            "lat": 41.933,
            "long": -71.3,
            "name": "Attleboro, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Barnstable",
            "id": 794,
            "is_region": null,
            "is_state": false,
            "lat": 41.7,
            "long": -70.3,
            "name": "Barnstable, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Bedford",
            "id": 795,
            "is_region": null,
            "is_state": false,
            "lat": 42.4906,
            "long": -71.2767,
            "name": "Bedford, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Beverly",
            "id": 796,
            "is_region": null,
            "is_state": false,
            "lat": 42.558,
            "long": -70.88,
            "name": "Beverly, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Boston",
            "id": 797,
            "is_region": null,
            "is_state": false,
            "lat": 42.3581,
            "long": -71.0636,
            "name": "Boston, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Bourne",
            "id": 798,
            "is_region": null,
            "is_state": false,
            "lat": 41.7411,
            "long": -70.5994,
            "name": "Bourne, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Braintree",
            "id": 799,
            "is_region": null,
            "is_state": false,
            "lat": 42.206,
            "long": -71.005,
            "name": "Braintree, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Brockton",
            "id": 800,
            "is_region": null,
            "is_state": false,
            "lat": 42.0833,
            "long": -71.0189,
            "name": "Brockton, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Brookline",
            "id": 801,
            "is_region": null,
            "is_state": false,
            "lat": 42.3317,
            "long": -71.1217,
            "name": "Brookline, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Cambridge",
            "id": 802,
            "is_region": null,
            "is_state": false,
            "lat": 42.3736,
            "long": -71.1106,
            "name": "Cambridge, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Canton",
            "id": 803,
            "is_region": null,
            "is_state": false,
            "lat": 42.1583,
            "long": -71.1453,
            "name": "Canton, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Charlestown",
            "id": 804,
            "is_region": null,
            "is_state": false,
            "lat": 42.3753,
            "long": -71.0644,
            "name": "Charlestown, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Chelmsford",
            "id": 805,
            "is_region": null,
            "is_state": false,
            "lat": 42.5997,
            "long": -71.3678,
            "name": "Chelmsford, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Chelsea",
            "id": 806,
            "is_region": null,
            "is_state": false,
            "lat": 42.3917,
            "long": -71.0333,
            "name": "Chelsea, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Chicopee",
            "id": 807,
            "is_region": null,
            "is_state": false,
            "lat": 42.1486,
            "long": -72.6083,
            "name": "Chicopee, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Clinton",
            "id": 808,
            "is_region": null,
            "is_state": false,
            "lat": 42.4167,
            "long": -71.6833,
            "name": "Clinton, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Cohasset",
            "id": 809,
            "is_region": null,
            "is_state": false,
            "lat": 42.2417,
            "long": -70.8042,
            "name": "Cohasset, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Concord",
            "id": 810,
            "is_region": null,
            "is_state": false,
            "lat": 42.4603,
            "long": -71.3494,
            "name": "Concord, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Danvers",
            "id": 811,
            "is_region": null,
            "is_state": false,
            "lat": 42.575,
            "long": -70.9306,
            "name": "Danvers, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Dartmouth",
            "id": 812,
            "is_region": null,
            "is_state": false,
            "lat": 41.6144,
            "long": -70.9697,
            "name": "Dartmouth, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Dedham",
            "id": 813,
            "is_region": null,
            "is_state": false,
            "lat": 42.2417,
            "long": -71.1667,
            "name": "Dedham, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Dennis",
            "id": 814,
            "is_region": null,
            "is_state": false,
            "lat": 41.7353,
            "long": -70.1944,
            "name": "Dennis, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Duxbury",
            "id": 815,
            "is_region": null,
            "is_state": false,
            "lat": 42.0417,
            "long": -70.6728,
            "name": "Duxbury, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Eastham",
            "id": 816,
            "is_region": null,
            "is_state": false,
            "lat": 41.83,
            "long": -69.9744,
            "name": "Eastham, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Edgartown",
            "id": 817,
            "is_region": null,
            "is_state": false,
            "lat": 41.3889,
            "long": -70.5139,
            "name": "Edgartown, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Everett",
            "id": 818,
            "is_region": null,
            "is_state": false,
            "lat": 42.4083,
            "long": -71.0542,
            "name": "Everett, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Fairhaven",
            "id": 819,
            "is_region": null,
            "is_state": false,
            "lat": 41.6375,
            "long": -70.9042,
            "name": "Fairhaven, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Fall River",
            "id": 820,
            "is_region": null,
            "is_state": false,
            "lat": 41.7014,
            "long": -71.1556,
            "name": "Fall River, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Falmouth",
            "id": 821,
            "is_region": null,
            "is_state": false,
            "lat": 41.5514,
            "long": -70.6153,
            "name": "Falmouth, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Fitchburg",
            "id": 822,
            "is_region": null,
            "is_state": false,
            "lat": 42.5833,
            "long": -71.8028,
            "name": "Fitchburg, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Framingham",
            "id": 823,
            "is_region": null,
            "is_state": false,
            "lat": 42.2792,
            "long": -71.4167,
            "name": "Framingham, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Gloucester",
            "id": 824,
            "is_region": null,
            "is_state": false,
            "lat": 42.6158,
            "long": -70.6625,
            "name": "Gloucester, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Great Barrington",
            "id": 825,
            "is_region": null,
            "is_state": false,
            "lat": 42.1958,
            "long": -73.3625,
            "name": "Great Barrington, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Greenfield",
            "id": 826,
            "is_region": null,
            "is_state": false,
            "lat": 42.5875,
            "long": -72.6,
            "name": "Greenfield, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Groton",
            "id": 827,
            "is_region": null,
            "is_state": false,
            "lat": 42.6111,
            "long": -71.575,
            "name": "Groton, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Harwich",
            "id": 828,
            "is_region": null,
            "is_state": false,
            "lat": 41.6861,
            "long": -70.0764,
            "name": "Harwich, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Haverhill",
            "id": 829,
            "is_region": null,
            "is_state": false,
            "lat": 42.783,
            "long": -71.083,
            "name": "Haverhill, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Hingham",
            "id": 830,
            "is_region": null,
            "is_state": false,
            "lat": 42.233,
            "long": -70.883,
            "name": "Hingham, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Holyoke",
            "id": 831,
            "is_region": null,
            "is_state": false,
            "lat": 42.2042,
            "long": -72.6167,
            "name": "Holyoke, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Hyannis",
            "id": 832,
            "is_region": null,
            "is_state": false,
            "lat": 41.6528,
            "long": -70.2833,
            "name": "Hyannis, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Ipswich",
            "id": 833,
            "is_region": null,
            "is_state": false,
            "lat": 42.6792,
            "long": -70.8417,
            "name": "Ipswich, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Lawrence",
            "id": 834,
            "is_region": null,
            "is_state": false,
            "lat": 42.7069,
            "long": -71.1636,
            "name": "Lawrence, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Lenox",
            "id": 835,
            "is_region": null,
            "is_state": false,
            "lat": 42.3564,
            "long": -73.2853,
            "name": "Lenox, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Leominster",
            "id": 836,
            "is_region": null,
            "is_state": false,
            "lat": 42.525,
            "long": -71.7603,
            "name": "Leominster, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Lexington",
            "id": 837,
            "is_region": null,
            "is_state": false,
            "lat": 42.4472,
            "long": -71.225,
            "name": "Lexington, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Lowell",
            "id": 838,
            "is_region": null,
            "is_state": false,
            "lat": 42.6394,
            "long": -71.3147,
            "name": "Lowell, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Ludlow",
            "id": 839,
            "is_region": null,
            "is_state": false,
            "lat": 42.16,
            "long": -72.4764,
            "name": "Ludlow, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Lynn",
            "id": 840,
            "is_region": null,
            "is_state": false,
            "lat": 42.467,
            "long": -70.95,
            "name": "Lynn, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Malden",
            "id": 841,
            "is_region": null,
            "is_state": false,
            "lat": 42.425,
            "long": -71.0667,
            "name": "Malden, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Marblehead",
            "id": 842,
            "is_region": null,
            "is_state": false,
            "lat": 42.5,
            "long": -70.8583,
            "name": "Marblehead, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Marlborough",
            "id": 843,
            "is_region": null,
            "is_state": false,
            "lat": 42.3458,
            "long": -71.5528,
            "name": "Marlborough, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Medford",
            "id": 844,
            "is_region": null,
            "is_state": false,
            "lat": 42.4183,
            "long": -71.1067,
            "name": "Medford, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Milton",
            "id": 845,
            "is_region": null,
            "is_state": false,
            "lat": 42.25,
            "long": -71.0667,
            "name": "Milton, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Nahant",
            "id": 846,
            "is_region": null,
            "is_state": false,
            "lat": 42.4264,
            "long": -70.9194,
            "name": "Nahant, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Natick",
            "id": 847,
            "is_region": null,
            "is_state": false,
            "lat": 42.2833,
            "long": -71.35,
            "name": "Natick, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "New Bedford",
            "id": 848,
            "is_region": null,
            "is_state": false,
            "lat": 41.6361,
            "long": -70.9347,
            "name": "New Bedford, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Newburyport",
            "id": 849,
            "is_region": null,
            "is_state": false,
            "lat": 42.8125,
            "long": -70.8778,
            "name": "Newburyport, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Newton",
            "id": 850,
            "is_region": null,
            "is_state": false,
            "lat": 42.3369,
            "long": -71.2097,
            "name": "Newton, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "North Adams",
            "id": 851,
            "is_region": null,
            "is_state": false,
            "lat": 42.7,
            "long": -73.117,
            "name": "North Adams, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Northampton",
            "id": 852,
            "is_region": null,
            "is_state": false,
            "lat": 42.333,
            "long": -72.65,
            "name": "Northampton, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Norton",
            "id": 853,
            "is_region": null,
            "is_state": false,
            "lat": 41.9667,
            "long": -71.1875,
            "name": "Norton, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Norwood",
            "id": 854,
            "is_region": null,
            "is_state": false,
            "lat": 42.1944,
            "long": -71.2,
            "name": "Norwood, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Peabody",
            "id": 855,
            "is_region": null,
            "is_state": false,
            "lat": 42.5278,
            "long": -70.9292,
            "name": "Peabody, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Pittsfield",
            "id": 856,
            "is_region": null,
            "is_state": false,
            "lat": 42.45,
            "long": -73.25,
            "name": "Pittsfield, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Plymouth",
            "id": 857,
            "is_region": null,
            "is_state": false,
            "lat": 41.9583,
            "long": -70.6678,
            "name": "Plymouth, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Provincetown",
            "id": 858,
            "is_region": null,
            "is_state": false,
            "lat": 42.058,
            "long": -70.179,
            "name": "Provincetown, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Quincy",
            "id": 859,
            "is_region": null,
            "is_state": false,
            "lat": 42.25,
            "long": -71.0,
            "name": "Quincy, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Randolph",
            "id": 860,
            "is_region": null,
            "is_state": false,
            "lat": 42.1625,
            "long": -71.0417,
            "name": "Randolph, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Revere",
            "id": 861,
            "is_region": null,
            "is_state": false,
            "lat": 42.4083,
            "long": -71.0125,
            "name": "Revere, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Salem",
            "id": 862,
            "is_region": null,
            "is_state": false,
            "lat": 42.5194,
            "long": -70.8972,
            "name": "Salem, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Sandwich",
            "id": 863,
            "is_region": null,
            "is_state": false,
            "lat": 41.7589,
            "long": -70.4944,
            "name": "Sandwich, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Saugus",
            "id": 864,
            "is_region": null,
            "is_state": false,
            "lat": 42.4647,
            "long": -71.0106,
            "name": "Saugus, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Somerville",
            "id": 865,
            "is_region": null,
            "is_state": false,
            "lat": 42.3875,
            "long": -71.1,
            "name": "Somerville, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "South Hadley",
            "id": 866,
            "is_region": null,
            "is_state": false,
            "lat": 42.2583,
            "long": -72.575,
            "name": "South Hadley, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Springfield",
            "id": 867,
            "is_region": null,
            "is_state": false,
            "lat": 42.1014,
            "long": -72.5903,
            "name": "Springfield, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Stockbridge",
            "id": 868,
            "is_region": null,
            "is_state": false,
            "lat": 42.2875,
            "long": -73.3208,
            "name": "Stockbridge, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Stoughton",
            "id": 869,
            "is_region": null,
            "is_state": false,
            "lat": 42.125,
            "long": -71.1028,
            "name": "Stoughton, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Sturbridge",
            "id": 870,
            "is_region": null,
            "is_state": false,
            "lat": 42.1083,
            "long": -72.0792,
            "name": "Sturbridge, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Sudbury",
            "id": 871,
            "is_region": null,
            "is_state": false,
            "lat": 42.383,
            "long": -71.417,
            "name": "Sudbury, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Taunton",
            "id": 872,
            "is_region": null,
            "is_state": false,
            "lat": 41.9,
            "long": -71.0903,
            "name": "Taunton, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Tewksbury",
            "id": 873,
            "is_region": null,
            "is_state": false,
            "lat": 42.6106,
            "long": -71.2347,
            "name": "Tewksbury, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Truro",
            "id": 874,
            "is_region": null,
            "is_state": false,
            "lat": 41.9933,
            "long": -70.0503,
            "name": "Truro, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Watertown",
            "id": 875,
            "is_region": null,
            "is_state": false,
            "lat": 42.3708,
            "long": -71.1833,
            "name": "Watertown, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Webster",
            "id": 876,
            "is_region": null,
            "is_state": false,
            "lat": 42.05,
            "long": -71.8806,
            "name": "Webster, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Wellesley",
            "id": 877,
            "is_region": null,
            "is_state": false,
            "lat": 42.2964,
            "long": -71.2931,
            "name": "Wellesley, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Wellfleet",
            "id": 878,
            "is_region": null,
            "is_state": false,
            "lat": 41.9375,
            "long": -70.0333,
            "name": "Wellfleet, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "West Bridgewater",
            "id": 879,
            "is_region": null,
            "is_state": false,
            "lat": 42.0189,
            "long": -71.0083,
            "name": "West Bridgewater, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "West Springfield",
            "id": 880,
            "is_region": null,
            "is_state": false,
            "lat": 42.1069,
            "long": -72.6208,
            "name": "West Springfield, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Westfield",
            "id": 881,
            "is_region": null,
            "is_state": false,
            "lat": 42.125,
            "long": -72.75,
            "name": "Westfield, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Weymouth",
            "id": 882,
            "is_region": null,
            "is_state": false,
            "lat": 42.2208,
            "long": -70.9403,
            "name": "Weymouth, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Whitman",
            "id": 883,
            "is_region": null,
            "is_state": false,
            "lat": 42.0806,
            "long": -70.9361,
            "name": "Whitman, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Williamstown",
            "id": 884,
            "is_region": null,
            "is_state": false,
            "lat": 42.7119,
            "long": -73.2042,
            "name": "Williamstown, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Woburn",
            "id": 885,
            "is_region": null,
            "is_state": false,
            "lat": 42.4792,
            "long": -71.1528,
            "name": "Woburn, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Woods Hole",
            "id": 886,
            "is_region": null,
            "is_state": false,
            "lat": 41.5267,
            "long": -70.6631,
            "name": "Woods Hole, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MA",
            "city": "Worcester",
            "id": 887,
            "is_region": null,
            "is_state": false,
            "lat": 42.267,
            "long": -71.8,
            "name": "Worcester, MA",
            "region_id": null,
            "state": "Massachusetts"
        },
        {
            "abbr": "MI",
            "city": "Adrian",
            "id": 888,
            "is_region": null,
            "is_state": false,
            "lat": 41.8964,
            "long": -84.0378,
            "name": "Adrian, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Alma",
            "id": 889,
            "is_region": null,
            "is_state": false,
            "lat": 43.3783,
            "long": -84.6594,
            "name": "Alma, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Ann Arbor",
            "id": 890,
            "is_region": null,
            "is_state": false,
            "lat": 42.2814,
            "long": -83.7483,
            "name": "Ann Arbor, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Battle Creek",
            "id": 891,
            "is_region": null,
            "is_state": false,
            "lat": 42.3122,
            "long": -85.2042,
            "name": "Battle Creek, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Bay City",
            "id": 892,
            "is_region": null,
            "is_state": false,
            "lat": 43.5951,
            "long": -83.8886,
            "name": "Bay City, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Benton Harbor",
            "id": 893,
            "is_region": null,
            "is_state": false,
            "lat": 42.1167,
            "long": -86.4542,
            "name": "Benton Harbor, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Bloomfield Hills",
            "id": 894,
            "is_region": null,
            "is_state": false,
            "lat": 42.5836,
            "long": -83.2456,
            "name": "Bloomfield Hills, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Cadillac",
            "id": 895,
            "is_region": null,
            "is_state": false,
            "lat": 44.25,
            "long": -85.4,
            "name": "Cadillac, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Charlevoix",
            "id": 896,
            "is_region": null,
            "is_state": false,
            "lat": 45.3181,
            "long": -85.2583,
            "name": "Charlevoix, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Cheboygan",
            "id": 897,
            "is_region": null,
            "is_state": false,
            "lat": 45.6469,
            "long": -84.4744,
            "name": "Cheboygan, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Dearborn",
            "id": 898,
            "is_region": null,
            "is_state": false,
            "lat": 42.3144,
            "long": -83.2133,
            "name": "Dearborn, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Detroit",
            "id": 899,
            "is_region": null,
            "is_state": false,
            "lat": 42.3314,
            "long": -83.0458,
            "name": "Detroit, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "East Lansing",
            "id": 900,
            "is_region": null,
            "is_state": false,
            "lat": 42.7347,
            "long": -84.4806,
            "name": "East Lansing, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Eastpointe",
            "id": 901,
            "is_region": null,
            "is_state": false,
            "lat": 42.4661,
            "long": -82.9464,
            "name": "Eastpointe, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Ecorse",
            "id": 902,
            "is_region": null,
            "is_state": false,
            "lat": 42.2506,
            "long": -83.1483,
            "name": "Ecorse, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Escanaba",
            "id": 903,
            "is_region": null,
            "is_state": false,
            "lat": 45.7453,
            "long": -87.0644,
            "name": "Escanaba, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Flint",
            "id": 904,
            "is_region": null,
            "is_state": false,
            "lat": 43.01,
            "long": -83.69,
            "name": "Flint, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Grand Haven",
            "id": 905,
            "is_region": null,
            "is_state": false,
            "lat": 43.0631,
            "long": -86.2283,
            "name": "Grand Haven, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Grand Rapids",
            "id": 906,
            "is_region": null,
            "is_state": false,
            "lat": 42.9611,
            "long": -85.6556,
            "name": "Grand Rapids, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Grayling",
            "id": 907,
            "is_region": null,
            "is_state": false,
            "lat": 44.6631,
            "long": -84.7108,
            "name": "Grayling, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Grosse Pointe",
            "id": 908,
            "is_region": null,
            "is_state": false,
            "lat": 42.383,
            "long": -82.917,
            "name": "Grosse Pointe, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Hancock",
            "id": 909,
            "is_region": null,
            "is_state": false,
            "lat": 47.1303,
            "long": -88.5964,
            "name": "Hancock, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Highland Park",
            "id": 910,
            "is_region": null,
            "is_state": false,
            "lat": 42.4036,
            "long": -83.1017,
            "name": "Highland Park, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Holland",
            "id": 911,
            "is_region": null,
            "is_state": false,
            "lat": 42.783,
            "long": -86.1,
            "name": "Holland, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Houghton",
            "id": 912,
            "is_region": null,
            "is_state": false,
            "lat": 47.1172,
            "long": -88.5625,
            "name": "Houghton, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Interlochen",
            "id": 913,
            "is_region": null,
            "is_state": false,
            "lat": 44.6453,
            "long": -85.7672,
            "name": "Interlochen, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Iron Mountain",
            "id": 914,
            "is_region": null,
            "is_state": false,
            "lat": 45.8225,
            "long": -88.0642,
            "name": "Iron Mountain, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Ironwood",
            "id": 915,
            "is_region": null,
            "is_state": false,
            "lat": 46.4558,
            "long": -90.1594,
            "name": "Ironwood, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Ishpeming",
            "id": 916,
            "is_region": null,
            "is_state": false,
            "lat": 46.4925,
            "long": -87.6675,
            "name": "Ishpeming, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Jackson",
            "id": 917,
            "is_region": null,
            "is_state": false,
            "lat": 42.2442,
            "long": -84.4072,
            "name": "Jackson, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Kalamazoo",
            "id": 918,
            "is_region": null,
            "is_state": false,
            "lat": 42.29,
            "long": -85.5858,
            "name": "Kalamazoo, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Lansing",
            "id": 919,
            "is_region": null,
            "is_state": false,
            "lat": 42.7336,
            "long": -84.5467,
            "name": "Lansing, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Livonia",
            "id": 920,
            "is_region": null,
            "is_state": false,
            "lat": 42.3972,
            "long": -83.3736,
            "name": "Livonia, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Ludington",
            "id": 921,
            "is_region": null,
            "is_state": false,
            "lat": 43.9569,
            "long": -86.4444,
            "name": "Ludington, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Mackinaw City",
            "id": 922,
            "is_region": null,
            "is_state": false,
            "lat": 45.7839,
            "long": -84.7278,
            "name": "Mackinaw City, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Manistee",
            "id": 923,
            "is_region": null,
            "is_state": false,
            "lat": 44.2436,
            "long": -86.3214,
            "name": "Manistee, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Marquette",
            "id": 924,
            "is_region": null,
            "is_state": false,
            "lat": 46.5464,
            "long": -87.4067,
            "name": "Marquette, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Menominee",
            "id": 925,
            "is_region": null,
            "is_state": false,
            "lat": 45.1078,
            "long": -87.6142,
            "name": "Menominee, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Midland",
            "id": 926,
            "is_region": null,
            "is_state": false,
            "lat": 43.6156,
            "long": -84.2472,
            "name": "Midland, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Monroe",
            "id": 927,
            "is_region": null,
            "is_state": false,
            "lat": 41.9164,
            "long": -83.3978,
            "name": "Monroe, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Mount Clemens",
            "id": 928,
            "is_region": null,
            "is_state": false,
            "lat": 42.5967,
            "long": -82.8803,
            "name": "Mount Clemens, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Mount Pleasant",
            "id": 929,
            "is_region": null,
            "is_state": false,
            "lat": 43.5978,
            "long": -84.7675,
            "name": "Mount Pleasant, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Muskegon",
            "id": 930,
            "is_region": null,
            "is_state": false,
            "lat": 43.2342,
            "long": -86.2483,
            "name": "Muskegon, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Niles",
            "id": 931,
            "is_region": null,
            "is_state": false,
            "lat": 41.83,
            "long": -86.2542,
            "name": "Niles, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Petoskey",
            "id": 932,
            "is_region": null,
            "is_state": false,
            "lat": 45.3733,
            "long": -84.9553,
            "name": "Petoskey, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Pontiac",
            "id": 933,
            "is_region": null,
            "is_state": false,
            "lat": 42.6461,
            "long": -83.2925,
            "name": "Pontiac, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Port Huron",
            "id": 934,
            "is_region": null,
            "is_state": false,
            "lat": 42.9803,
            "long": -82.4375,
            "name": "Port Huron, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Royal Oak",
            "id": 935,
            "is_region": null,
            "is_state": false,
            "lat": 42.4889,
            "long": -83.1428,
            "name": "Royal Oak, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Saginaw",
            "id": 936,
            "is_region": null,
            "is_state": false,
            "lat": 43.4178,
            "long": -83.9644,
            "name": "Saginaw, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Saint Ignace",
            "id": 937,
            "is_region": null,
            "is_state": false,
            "lat": 45.8658,
            "long": -84.7258,
            "name": "Saint Ignace, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Saint Joseph",
            "id": 938,
            "is_region": null,
            "is_state": false,
            "lat": 42.0981,
            "long": -86.4842,
            "name": "Saint Joseph, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Sault Sainte Marie",
            "id": 939,
            "is_region": null,
            "is_state": false,
            "lat": 46.4969,
            "long": -84.3456,
            "name": "Sault Sainte Marie, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Traverse City",
            "id": 940,
            "is_region": null,
            "is_state": false,
            "lat": 44.7681,
            "long": -85.6222,
            "name": "Traverse City, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Trenton",
            "id": 941,
            "is_region": null,
            "is_state": false,
            "lat": 42.1394,
            "long": -83.1783,
            "name": "Trenton, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Warren",
            "id": 942,
            "is_region": null,
            "is_state": false,
            "lat": 42.4919,
            "long": -83.0239,
            "name": "Warren, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Wyandotte",
            "id": 943,
            "is_region": null,
            "is_state": false,
            "lat": 42.2086,
            "long": -83.1625,
            "name": "Wyandotte, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MI",
            "city": "Ypsilanti",
            "id": 944,
            "is_region": null,
            "is_state": false,
            "lat": 42.2428,
            "long": -83.6183,
            "name": "Ypsilanti, MI",
            "region_id": null,
            "state": "Michigan"
        },
        {
            "abbr": "MN",
            "city": "Albert Lea",
            "id": 945,
            "is_region": null,
            "is_state": false,
            "lat": 43.6479,
            "long": -93.3688,
            "name": "Albert Lea, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Alexandria",
            "id": 946,
            "is_region": null,
            "is_state": false,
            "lat": 45.8852,
            "long": -95.3772,
            "name": "Alexandria, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Austin",
            "id": 947,
            "is_region": null,
            "is_state": false,
            "lat": 43.667,
            "long": -92.967,
            "name": "Austin, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Bemidji",
            "id": 948,
            "is_region": null,
            "is_state": false,
            "lat": 47.4736,
            "long": -94.8803,
            "name": "Bemidji, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Bloomington",
            "id": 949,
            "is_region": null,
            "is_state": false,
            "lat": 44.8336,
            "long": -93.31,
            "name": "Bloomington, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Brainerd",
            "id": 950,
            "is_region": null,
            "is_state": false,
            "lat": 46.3581,
            "long": -94.2008,
            "name": "Brainerd, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Crookston",
            "id": 951,
            "is_region": null,
            "is_state": false,
            "lat": 47.7739,
            "long": -96.6078,
            "name": "Crookston, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Duluth",
            "id": 952,
            "is_region": null,
            "is_state": false,
            "lat": 46.7869,
            "long": -92.0982,
            "name": "Duluth, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Ely",
            "id": 953,
            "is_region": null,
            "is_state": false,
            "lat": 47.9022,
            "long": -91.8558,
            "name": "Ely, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Eveleth",
            "id": 954,
            "is_region": null,
            "is_state": false,
            "lat": 47.4628,
            "long": -92.5403,
            "name": "Eveleth, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Faribault",
            "id": 955,
            "is_region": null,
            "is_state": false,
            "lat": 44.2906,
            "long": -93.2683,
            "name": "Faribault, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Fergus Falls",
            "id": 956,
            "is_region": null,
            "is_state": false,
            "lat": 46.2842,
            "long": -96.1567,
            "name": "Fergus Falls, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Hastings",
            "id": 957,
            "is_region": null,
            "is_state": false,
            "lat": 44.733,
            "long": -92.85,
            "name": "Hastings, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Hibbing",
            "id": 958,
            "is_region": null,
            "is_state": false,
            "lat": 47.4172,
            "long": -92.9383,
            "name": "Hibbing, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "International Falls",
            "id": 959,
            "is_region": null,
            "is_state": false,
            "lat": 48.5917,
            "long": -93.4053,
            "name": "International Falls, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Little Falls",
            "id": 960,
            "is_region": null,
            "is_state": false,
            "lat": 45.9775,
            "long": -94.3642,
            "name": "Little Falls, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Mankato",
            "id": 961,
            "is_region": null,
            "is_state": false,
            "lat": 44.167,
            "long": -94.0,
            "name": "Mankato, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Minneapolis",
            "id": 962,
            "is_region": null,
            "is_state": false,
            "lat": 44.983,
            "long": -93.267,
            "name": "Minneapolis, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Moorhead",
            "id": 963,
            "is_region": null,
            "is_state": false,
            "lat": 46.8739,
            "long": -96.7672,
            "name": "Moorhead, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "New Ulm",
            "id": 964,
            "is_region": null,
            "is_state": false,
            "lat": 44.3119,
            "long": -94.4631,
            "name": "New Ulm, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Northfield",
            "id": 965,
            "is_region": null,
            "is_state": false,
            "lat": 44.4583,
            "long": -93.1611,
            "name": "Northfield, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Owatonna",
            "id": 966,
            "is_region": null,
            "is_state": false,
            "lat": 44.0872,
            "long": -93.2244,
            "name": "Owatonna, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Pipestone",
            "id": 967,
            "is_region": null,
            "is_state": false,
            "lat": 43.9978,
            "long": -96.3172,
            "name": "Pipestone, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Red Wing",
            "id": 968,
            "is_region": null,
            "is_state": false,
            "lat": 44.567,
            "long": -92.533,
            "name": "Red Wing, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Rochester",
            "id": 969,
            "is_region": null,
            "is_state": false,
            "lat": 44.0234,
            "long": -92.463,
            "name": "Rochester, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Saint Cloud",
            "id": 970,
            "is_region": null,
            "is_state": false,
            "lat": 45.55,
            "long": -94.167,
            "name": "Saint Cloud, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Saint Paul",
            "id": 971,
            "is_region": null,
            "is_state": false,
            "lat": 44.9442,
            "long": -93.0936,
            "name": "Saint Paul, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Sauk Centre",
            "id": 972,
            "is_region": null,
            "is_state": false,
            "lat": 45.7364,
            "long": -94.9542,
            "name": "Sauk Centre, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "South Saint Paul",
            "id": 973,
            "is_region": null,
            "is_state": false,
            "lat": 44.8881,
            "long": -93.0456,
            "name": "South Saint Paul, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Stillwater",
            "id": 974,
            "is_region": null,
            "is_state": false,
            "lat": 45.05,
            "long": -92.817,
            "name": "Stillwater, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Virginia",
            "id": 975,
            "is_region": null,
            "is_state": false,
            "lat": 47.5172,
            "long": -92.5414,
            "name": "Virginia, MN",
            "region_id": 2537,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Willmar",
            "id": 976,
            "is_region": null,
            "is_state": false,
            "lat": 45.1197,
            "long": -95.0481,
            "name": "Willmar, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MN",
            "city": "Winona",
            "id": 977,
            "is_region": null,
            "is_state": false,
            "lat": 44.05,
            "long": -91.633,
            "name": "Winona, MN",
            "region_id": null,
            "state": "Minnesota"
        },
        {
            "abbr": "MS",
            "city": "Bay Saint Louis",
            "id": 978,
            "is_region": null,
            "is_state": false,
            "lat": 30.3147,
            "long": -89.3442,
            "name": "Bay Saint Louis, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Biloxi",
            "id": 979,
            "is_region": null,
            "is_state": false,
            "lat": 30.4119,
            "long": -88.9278,
            "name": "Biloxi, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Canton",
            "id": 980,
            "is_region": null,
            "is_state": false,
            "lat": 32.6119,
            "long": -90.0317,
            "name": "Canton, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Clarksdale",
            "id": 981,
            "is_region": null,
            "is_state": false,
            "lat": 34.2,
            "long": -90.567,
            "name": "Clarksdale, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Columbia",
            "id": 982,
            "is_region": null,
            "is_state": false,
            "lat": 31.2567,
            "long": -89.8289,
            "name": "Columbia, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Columbus",
            "id": 983,
            "is_region": null,
            "is_state": false,
            "lat": 33.5017,
            "long": -88.415,
            "name": "Columbus, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Corinth",
            "id": 984,
            "is_region": null,
            "is_state": false,
            "lat": 34.9372,
            "long": -88.5153,
            "name": "Corinth, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Greenville",
            "id": 985,
            "is_region": null,
            "is_state": false,
            "lat": 33.3986,
            "long": -91.0483,
            "name": "Greenville, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Greenwood",
            "id": 986,
            "is_region": null,
            "is_state": false,
            "lat": 33.5186,
            "long": -90.1839,
            "name": "Greenwood, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Grenada",
            "id": 987,
            "is_region": null,
            "is_state": false,
            "lat": 33.775,
            "long": -89.8089,
            "name": "Grenada, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Gulfport",
            "id": 988,
            "is_region": null,
            "is_state": false,
            "lat": 30.4017,
            "long": -89.0761,
            "name": "Gulfport, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Hattiesburg",
            "id": 989,
            "is_region": null,
            "is_state": false,
            "lat": 31.3158,
            "long": -89.3086,
            "name": "Hattiesburg, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Holly Springs",
            "id": 990,
            "is_region": null,
            "is_state": false,
            "lat": 34.7733,
            "long": -89.4464,
            "name": "Holly Springs, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Jackson",
            "id": 991,
            "is_region": null,
            "is_state": false,
            "lat": 32.2989,
            "long": -90.1847,
            "name": "Jackson, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Laurel",
            "id": 992,
            "is_region": null,
            "is_state": false,
            "lat": 31.6975,
            "long": -89.1394,
            "name": "Laurel, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Meridian",
            "id": 993,
            "is_region": null,
            "is_state": false,
            "lat": 32.3747,
            "long": -88.7042,
            "name": "Meridian, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Natchez",
            "id": 994,
            "is_region": null,
            "is_state": false,
            "lat": 31.5544,
            "long": -91.3875,
            "name": "Natchez, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Ocean Springs",
            "id": 995,
            "is_region": null,
            "is_state": false,
            "lat": 30.41,
            "long": -88.7975,
            "name": "Ocean Springs, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Oxford",
            "id": 996,
            "is_region": null,
            "is_state": false,
            "lat": 34.3597,
            "long": -89.5261,
            "name": "Oxford, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Pascagoula",
            "id": 997,
            "is_region": null,
            "is_state": false,
            "lat": 30.3636,
            "long": -88.5419,
            "name": "Pascagoula, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Pass Christian",
            "id": 998,
            "is_region": null,
            "is_state": false,
            "lat": 30.3244,
            "long": -89.2472,
            "name": "Pass Christian, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Philadelphia",
            "id": 999,
            "is_region": null,
            "is_state": false,
            "lat": 32.7742,
            "long": -89.1128,
            "name": "Philadelphia, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Port Gibson",
            "id": 1000,
            "is_region": null,
            "is_state": false,
            "lat": 31.9561,
            "long": -90.9831,
            "name": "Port Gibson, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Starkville",
            "id": 1001,
            "is_region": null,
            "is_state": false,
            "lat": 33.4625,
            "long": -88.82,
            "name": "Starkville, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Tupelo",
            "id": 1002,
            "is_region": null,
            "is_state": false,
            "lat": 34.2597,
            "long": -88.7258,
            "name": "Tupelo, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Vicksburg",
            "id": 1003,
            "is_region": null,
            "is_state": false,
            "lat": 32.3361,
            "long": -90.8753,
            "name": "Vicksburg, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "West Point",
            "id": 1004,
            "is_region": null,
            "is_state": false,
            "lat": 33.6061,
            "long": -88.6525,
            "name": "West Point, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MS",
            "city": "Yazoo City",
            "id": 1005,
            "is_region": null,
            "is_state": false,
            "lat": 32.8564,
            "long": -90.4075,
            "name": "Yazoo City, MS",
            "region_id": null,
            "state": "Mississippi"
        },
        {
            "abbr": "MO",
            "city": "Boonville",
            "id": 1006,
            "is_region": null,
            "is_state": false,
            "lat": 38.965,
            "long": -92.7417,
            "name": "Boonville, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Branson",
            "id": 1007,
            "is_region": null,
            "is_state": false,
            "lat": 36.6378,
            "long": -93.255,
            "name": "Branson, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Cape Girardeau",
            "id": 1008,
            "is_region": null,
            "is_state": false,
            "lat": 37.3092,
            "long": -89.5464,
            "name": "Cape Girardeau, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Carthage",
            "id": 1009,
            "is_region": null,
            "is_state": false,
            "lat": 37.1678,
            "long": -94.315,
            "name": "Carthage, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Chillicothe",
            "id": 1010,
            "is_region": null,
            "is_state": false,
            "lat": 39.7931,
            "long": -93.5519,
            "name": "Chillicothe, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Clayton",
            "id": 1011,
            "is_region": null,
            "is_state": false,
            "lat": 38.6453,
            "long": -90.3319,
            "name": "Clayton, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Columbia",
            "id": 1012,
            "is_region": null,
            "is_state": false,
            "lat": 38.9514,
            "long": -92.3283,
            "name": "Columbia, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Excelsior Springs",
            "id": 1013,
            "is_region": null,
            "is_state": false,
            "lat": 39.3414,
            "long": -94.2308,
            "name": "Excelsior Springs, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Ferguson",
            "id": 1014,
            "is_region": null,
            "is_state": false,
            "lat": 38.7442,
            "long": -90.3053,
            "name": "Ferguson, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Florissant",
            "id": 1015,
            "is_region": null,
            "is_state": false,
            "lat": 38.7978,
            "long": -90.3256,
            "name": "Florissant, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Fulton",
            "id": 1016,
            "is_region": null,
            "is_state": false,
            "lat": 38.8508,
            "long": -91.9481,
            "name": "Fulton, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Hannibal",
            "id": 1017,
            "is_region": null,
            "is_state": false,
            "lat": 39.7042,
            "long": -91.3775,
            "name": "Hannibal, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Independence",
            "id": 1018,
            "is_region": null,
            "is_state": false,
            "lat": 39.0797,
            "long": -94.4067,
            "name": "Independence, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Jefferson City",
            "id": 1019,
            "is_region": null,
            "is_state": false,
            "lat": 38.5767,
            "long": -92.1736,
            "name": "Jefferson City, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Joplin",
            "id": 1020,
            "is_region": null,
            "is_state": false,
            "lat": 37.0842,
            "long": -94.5131,
            "name": "Joplin, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Kansas City",
            "id": 1021,
            "is_region": null,
            "is_state": false,
            "lat": 39.0997,
            "long": -94.5783,
            "name": "Kansas City, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Kirksville",
            "id": 1022,
            "is_region": null,
            "is_state": false,
            "lat": 40.1947,
            "long": -92.5833,
            "name": "Kirksville, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Lamar",
            "id": 1023,
            "is_region": null,
            "is_state": false,
            "lat": 37.4936,
            "long": -94.2722,
            "name": "Lamar, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Lebanon",
            "id": 1024,
            "is_region": null,
            "is_state": false,
            "lat": 37.6783,
            "long": -92.6617,
            "name": "Lebanon, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Lexington",
            "id": 1025,
            "is_region": null,
            "is_state": false,
            "lat": 39.1831,
            "long": -93.875,
            "name": "Lexington, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Maryville",
            "id": 1026,
            "is_region": null,
            "is_state": false,
            "lat": 40.3453,
            "long": -94.8711,
            "name": "Maryville, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Mexico",
            "id": 1027,
            "is_region": null,
            "is_state": false,
            "lat": 39.1658,
            "long": -91.8847,
            "name": "Mexico, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Monett",
            "id": 1028,
            "is_region": null,
            "is_state": false,
            "lat": 36.9236,
            "long": -93.9222,
            "name": "Monett, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Neosho",
            "id": 1029,
            "is_region": null,
            "is_state": false,
            "lat": 36.8556,
            "long": -94.3764,
            "name": "Neosho, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "New Madrid",
            "id": 1030,
            "is_region": null,
            "is_state": false,
            "lat": 36.5878,
            "long": -89.5358,
            "name": "New Madrid, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Rolla",
            "id": 1031,
            "is_region": null,
            "is_state": false,
            "lat": 37.9489,
            "long": -91.7631,
            "name": "Rolla, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Saint Charles",
            "id": 1032,
            "is_region": null,
            "is_state": false,
            "lat": 38.7887,
            "long": -90.5118,
            "name": "Saint Charles, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Saint Joseph",
            "id": 1033,
            "is_region": null,
            "is_state": false,
            "lat": 39.7581,
            "long": -94.8367,
            "name": "Saint Joseph, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Saint Louis",
            "id": 1034,
            "is_region": null,
            "is_state": false,
            "lat": 38.6272,
            "long": -90.1978,
            "name": "Saint Louis, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Sainte Genevieve",
            "id": 1035,
            "is_region": null,
            "is_state": false,
            "lat": 37.9769,
            "long": -90.0486,
            "name": "Sainte Genevieve, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Salem",
            "id": 1036,
            "is_region": null,
            "is_state": false,
            "lat": 37.6414,
            "long": -91.5389,
            "name": "Salem, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Sedalia",
            "id": 1037,
            "is_region": null,
            "is_state": false,
            "lat": 38.7031,
            "long": -93.2311,
            "name": "Sedalia, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Springfield",
            "id": 1038,
            "is_region": null,
            "is_state": false,
            "lat": 37.2153,
            "long": -93.2983,
            "name": "Springfield, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "Warrensburg",
            "id": 1039,
            "is_region": null,
            "is_state": false,
            "lat": 38.7631,
            "long": -93.735,
            "name": "Warrensburg, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MO",
            "city": "West Plains",
            "id": 1040,
            "is_region": null,
            "is_state": false,
            "lat": 36.7372,
            "long": -91.865,
            "name": "West Plains, MO",
            "region_id": null,
            "state": "Missouri"
        },
        {
            "abbr": "MT",
            "city": "Anaconda",
            "id": 1041,
            "is_region": null,
            "is_state": false,
            "lat": 46.133,
            "long": -112.933,
            "name": "Anaconda, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Billings",
            "id": 1042,
            "is_region": null,
            "is_state": false,
            "lat": 45.7867,
            "long": -108.537,
            "name": "Billings, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Bozeman",
            "id": 1043,
            "is_region": null,
            "is_state": false,
            "lat": 45.6778,
            "long": -111.047,
            "name": "Bozeman, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Butte",
            "id": 1044,
            "is_region": null,
            "is_state": false,
            "lat": 45.9989,
            "long": -112.524,
            "name": "Butte, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Dillon",
            "id": 1045,
            "is_region": null,
            "is_state": false,
            "lat": 45.2158,
            "long": -112.634,
            "name": "Dillon, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Fort Benton",
            "id": 1046,
            "is_region": null,
            "is_state": false,
            "lat": 47.8194,
            "long": -110.67,
            "name": "Fort Benton, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Glendive",
            "id": 1047,
            "is_region": null,
            "is_state": false,
            "lat": 47.1086,
            "long": -104.711,
            "name": "Glendive, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Great Falls",
            "id": 1048,
            "is_region": null,
            "is_state": false,
            "lat": 47.5036,
            "long": -111.286,
            "name": "Great Falls, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Havre",
            "id": 1049,
            "is_region": null,
            "is_state": false,
            "lat": 48.55,
            "long": -109.683,
            "name": "Havre, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Helena",
            "id": 1050,
            "is_region": null,
            "is_state": false,
            "lat": 46.5958,
            "long": -112.027,
            "name": "Helena, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Kalispell",
            "id": 1051,
            "is_region": null,
            "is_state": false,
            "lat": 48.1978,
            "long": -114.316,
            "name": "Kalispell, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Lewistown",
            "id": 1052,
            "is_region": null,
            "is_state": false,
            "lat": 47.0647,
            "long": -109.43,
            "name": "Lewistown, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Livingston",
            "id": 1053,
            "is_region": null,
            "is_state": false,
            "lat": 45.6589,
            "long": -110.564,
            "name": "Livingston, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Miles City",
            "id": 1054,
            "is_region": null,
            "is_state": false,
            "lat": 46.4083,
            "long": -105.84,
            "name": "Miles City, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Missoula",
            "id": 1055,
            "is_region": null,
            "is_state": false,
            "lat": 46.8625,
            "long": -114.012,
            "name": "Missoula, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "MT",
            "city": "Virginia City",
            "id": 1056,
            "is_region": null,
            "is_state": false,
            "lat": 45.2942,
            "long": -111.941,
            "name": "Virginia City, MT",
            "region_id": null,
            "state": "Montana"
        },
        {
            "abbr": "NE",
            "city": "Beatrice",
            "id": 1057,
            "is_region": null,
            "is_state": false,
            "lat": 40.2683,
            "long": -96.7431,
            "name": "Beatrice, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Bellevue",
            "id": 1058,
            "is_region": null,
            "is_state": false,
            "lat": 41.1586,
            "long": -95.9342,
            "name": "Bellevue, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Boys Town",
            "id": 1059,
            "is_region": null,
            "is_state": false,
            "lat": 41.2614,
            "long": -96.1303,
            "name": "Boys Town, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Chadron",
            "id": 1060,
            "is_region": null,
            "is_state": false,
            "lat": 42.8275,
            "long": -103.003,
            "name": "Chadron, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Columbus",
            "id": 1061,
            "is_region": null,
            "is_state": false,
            "lat": 41.4328,
            "long": -97.3586,
            "name": "Columbus, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Fremont",
            "id": 1062,
            "is_region": null,
            "is_state": false,
            "lat": 41.4397,
            "long": -96.49,
            "name": "Fremont, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Grand Island",
            "id": 1063,
            "is_region": null,
            "is_state": false,
            "lat": 40.9222,
            "long": -98.3581,
            "name": "Grand Island, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Hastings",
            "id": 1064,
            "is_region": null,
            "is_state": false,
            "lat": 40.5892,
            "long": -98.3917,
            "name": "Hastings, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Kearney",
            "id": 1065,
            "is_region": null,
            "is_state": false,
            "lat": 40.7008,
            "long": -99.0811,
            "name": "Kearney, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Lincoln",
            "id": 1066,
            "is_region": null,
            "is_state": false,
            "lat": 40.8089,
            "long": -96.6803,
            "name": "Lincoln, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "McCook",
            "id": 1067,
            "is_region": null,
            "is_state": false,
            "lat": 40.2053,
            "long": -100.626,
            "name": "McCook, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Minden",
            "id": 1068,
            "is_region": null,
            "is_state": false,
            "lat": 40.4981,
            "long": -98.9511,
            "name": "Minden, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Nebraska City",
            "id": 1069,
            "is_region": null,
            "is_state": false,
            "lat": 40.6761,
            "long": -95.8597,
            "name": "Nebraska City, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Norfolk",
            "id": 1070,
            "is_region": null,
            "is_state": false,
            "lat": 42.0283,
            "long": -97.4336,
            "name": "Norfolk, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "North Platte",
            "id": 1071,
            "is_region": null,
            "is_state": false,
            "lat": 41.136,
            "long": -100.763,
            "name": "North Platte, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Omaha",
            "id": 1072,
            "is_region": null,
            "is_state": false,
            "lat": 41.25,
            "long": -96.0,
            "name": "Omaha, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Plattsmouth",
            "id": 1073,
            "is_region": null,
            "is_state": false,
            "lat": 41.0086,
            "long": -95.8917,
            "name": "Plattsmouth, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Red Cloud",
            "id": 1074,
            "is_region": null,
            "is_state": false,
            "lat": 40.0883,
            "long": -98.5228,
            "name": "Red Cloud, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NE",
            "city": "Sidney",
            "id": 1075,
            "is_region": null,
            "is_state": false,
            "lat": 41.1394,
            "long": -102.978,
            "name": "Sidney, NE",
            "region_id": null,
            "state": "Nebraska"
        },
        {
            "abbr": "NV",
            "city": "Boulder City",
            "id": 1076,
            "is_region": null,
            "is_state": false,
            "lat": 35.9786,
            "long": -114.832,
            "name": "Boulder City, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NV",
            "city": "Carson City",
            "id": 1077,
            "is_region": null,
            "is_state": false,
            "lat": 39.1608,
            "long": -119.754,
            "name": "Carson City, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NV",
            "city": "Elko",
            "id": 1078,
            "is_region": null,
            "is_state": false,
            "lat": 40.833,
            "long": -115.767,
            "name": "Elko, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NV",
            "city": "Ely",
            "id": 1079,
            "is_region": null,
            "is_state": false,
            "lat": 39.2533,
            "long": -114.877,
            "name": "Ely, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NV",
            "city": "Fallon",
            "id": 1080,
            "is_region": null,
            "is_state": false,
            "lat": 39.4728,
            "long": -118.779,
            "name": "Fallon, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NV",
            "city": "Genoa",
            "id": 1081,
            "is_region": null,
            "is_state": false,
            "lat": 39.0044,
            "long": -119.847,
            "name": "Genoa, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NV",
            "city": "Goldfield",
            "id": 1082,
            "is_region": null,
            "is_state": false,
            "lat": 37.7086,
            "long": -117.236,
            "name": "Goldfield, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NV",
            "city": "Henderson",
            "id": 1083,
            "is_region": null,
            "is_state": false,
            "lat": 36.033,
            "long": -114.983,
            "name": "Henderson, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NV",
            "city": "Las Vegas",
            "id": 1084,
            "is_region": null,
            "is_state": false,
            "lat": 36.175,
            "long": -115.136,
            "name": "Las Vegas, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NV",
            "city": "North Las Vegas",
            "id": 1085,
            "is_region": null,
            "is_state": false,
            "lat": 36.2286,
            "long": -115.147,
            "name": "North Las Vegas, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NV",
            "city": "Reno",
            "id": 1086,
            "is_region": null,
            "is_state": false,
            "lat": 39.5272,
            "long": -119.822,
            "name": "Reno, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NV",
            "city": "Sparks",
            "id": 1087,
            "is_region": null,
            "is_state": false,
            "lat": 39.5544,
            "long": -119.736,
            "name": "Sparks, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NV",
            "city": "Virginia City",
            "id": 1088,
            "is_region": null,
            "is_state": false,
            "lat": 39.3103,
            "long": -119.649,
            "name": "Virginia City, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NV",
            "city": "Winnemucca",
            "id": 1089,
            "is_region": null,
            "is_state": false,
            "lat": 40.9683,
            "long": -117.727,
            "name": "Winnemucca, NV",
            "region_id": null,
            "state": "Nevada"
        },
        {
            "abbr": "NH",
            "city": "Berlin",
            "id": 1090,
            "is_region": null,
            "is_state": false,
            "lat": 44.4686,
            "long": -71.1839,
            "name": "Berlin, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Claremont",
            "id": 1091,
            "is_region": null,
            "is_state": false,
            "lat": 43.3722,
            "long": -72.3375,
            "name": "Claremont, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Concord",
            "id": 1092,
            "is_region": null,
            "is_state": false,
            "lat": 43.2067,
            "long": -71.5381,
            "name": "Concord, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Derry",
            "id": 1093,
            "is_region": null,
            "is_state": false,
            "lat": 42.8806,
            "long": -71.3272,
            "name": "Derry, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Dover",
            "id": 1094,
            "is_region": null,
            "is_state": false,
            "lat": 43.1947,
            "long": -70.875,
            "name": "Dover, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Durham",
            "id": 1095,
            "is_region": null,
            "is_state": false,
            "lat": 43.1339,
            "long": -70.9264,
            "name": "Durham, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Exeter",
            "id": 1096,
            "is_region": null,
            "is_state": false,
            "lat": 42.9814,
            "long": -70.9478,
            "name": "Exeter, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Franklin",
            "id": 1097,
            "is_region": null,
            "is_state": false,
            "lat": 43.4442,
            "long": -71.6475,
            "name": "Franklin, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Hanover",
            "id": 1098,
            "is_region": null,
            "is_state": false,
            "lat": 43.7022,
            "long": -72.2894,
            "name": "Hanover, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Hillsborough",
            "id": 1099,
            "is_region": null,
            "is_state": false,
            "lat": 43.1147,
            "long": -71.895,
            "name": "Hillsborough, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Keene",
            "id": 1100,
            "is_region": null,
            "is_state": false,
            "lat": 42.9336,
            "long": -72.2781,
            "name": "Keene, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Laconia",
            "id": 1101,
            "is_region": null,
            "is_state": false,
            "lat": 43.5275,
            "long": -71.4703,
            "name": "Laconia, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Lebanon",
            "id": 1102,
            "is_region": null,
            "is_state": false,
            "lat": 43.6422,
            "long": -72.2517,
            "name": "Lebanon, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Manchester",
            "id": 1103,
            "is_region": null,
            "is_state": false,
            "lat": 42.9908,
            "long": -71.4636,
            "name": "Manchester, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Nashua",
            "id": 1104,
            "is_region": null,
            "is_state": false,
            "lat": 42.7575,
            "long": -71.4644,
            "name": "Nashua, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Peterborough",
            "id": 1105,
            "is_region": null,
            "is_state": false,
            "lat": 42.8706,
            "long": -71.9517,
            "name": "Peterborough, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Plymouth",
            "id": 1106,
            "is_region": null,
            "is_state": false,
            "lat": 43.7575,
            "long": -71.6886,
            "name": "Plymouth, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Portsmouth",
            "id": 1107,
            "is_region": null,
            "is_state": false,
            "lat": 43.0756,
            "long": -70.7606,
            "name": "Portsmouth, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Rochester",
            "id": 1108,
            "is_region": null,
            "is_state": false,
            "lat": 43.3019,
            "long": -70.9731,
            "name": "Rochester, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Salem",
            "id": 1109,
            "is_region": null,
            "is_state": false,
            "lat": 42.7883,
            "long": -71.2008,
            "name": "Salem, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NH",
            "city": "Somersworth",
            "id": 1110,
            "is_region": null,
            "is_state": false,
            "lat": 43.2625,
            "long": -70.8642,
            "name": "Somersworth, NH",
            "region_id": null,
            "state": "New Hampshire"
        },
        {
            "abbr": "NJ",
            "city": "Asbury Park",
            "id": 1111,
            "is_region": null,
            "is_state": false,
            "lat": 40.2229,
            "long": -74.0102,
            "name": "Asbury Park, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Atlantic City",
            "id": 1112,
            "is_region": null,
            "is_state": false,
            "lat": 39.3773,
            "long": -74.4511,
            "name": "Atlantic City, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Bayonne",
            "id": 1113,
            "is_region": null,
            "is_state": false,
            "lat": 40.6624,
            "long": -74.1102,
            "name": "Bayonne, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Bloomfield",
            "id": 1114,
            "is_region": null,
            "is_state": false,
            "lat": 40.8091,
            "long": -74.1872,
            "name": "Bloomfield, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Bordentown",
            "id": 1115,
            "is_region": null,
            "is_state": false,
            "lat": 40.1498,
            "long": -74.7076,
            "name": "Bordentown, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Bound Brook",
            "id": 1116,
            "is_region": null,
            "is_state": false,
            "lat": 40.5677,
            "long": -74.5372,
            "name": "Bound Brook, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Bridgeton",
            "id": 1117,
            "is_region": null,
            "is_state": false,
            "lat": 39.4275,
            "long": -75.228,
            "name": "Bridgeton, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Burlington",
            "id": 1118,
            "is_region": null,
            "is_state": false,
            "lat": 40.071,
            "long": -74.864,
            "name": "Burlington, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Caldwell",
            "id": 1119,
            "is_region": null,
            "is_state": false,
            "lat": 40.8392,
            "long": -74.277,
            "name": "Caldwell, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Camden",
            "id": 1120,
            "is_region": null,
            "is_state": false,
            "lat": 39.94,
            "long": -75.105,
            "name": "Camden, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Cape May",
            "id": 1121,
            "is_region": null,
            "is_state": false,
            "lat": 38.9392,
            "long": -74.9036,
            "name": "Cape May, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Clifton",
            "id": 1122,
            "is_region": null,
            "is_state": false,
            "lat": 40.8621,
            "long": -74.1604,
            "name": "Clifton, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Cranford",
            "id": 1123,
            "is_region": null,
            "is_state": false,
            "lat": 40.6564,
            "long": -74.3048,
            "name": "Cranford, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "East Orange",
            "id": 1124,
            "is_region": null,
            "is_state": false,
            "lat": 40.7651,
            "long": -74.2119,
            "name": "East Orange, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Edison",
            "id": 1125,
            "is_region": null,
            "is_state": false,
            "lat": 40.504,
            "long": -74.3494,
            "name": "Edison, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Elizabeth",
            "id": 1126,
            "is_region": null,
            "is_state": false,
            "lat": 40.6663,
            "long": -74.1935,
            "name": "Elizabeth, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Englewood",
            "id": 1127,
            "is_region": null,
            "is_state": false,
            "lat": 40.8912,
            "long": -73.9725,
            "name": "Englewood, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Fort Lee",
            "id": 1128,
            "is_region": null,
            "is_state": false,
            "lat": 40.851,
            "long": -73.971,
            "name": "Fort Lee, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Glassboro",
            "id": 1129,
            "is_region": null,
            "is_state": false,
            "lat": 39.7001,
            "long": -75.1114,
            "name": "Glassboro, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Hackensack",
            "id": 1130,
            "is_region": null,
            "is_state": false,
            "lat": 40.8894,
            "long": -74.0457,
            "name": "Hackensack, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Haddonfield",
            "id": 1131,
            "is_region": null,
            "is_state": false,
            "lat": 39.8954,
            "long": -75.0343,
            "name": "Haddonfield, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Hoboken",
            "id": 1132,
            "is_region": null,
            "is_state": false,
            "lat": 40.75,
            "long": -74.03,
            "name": "Hoboken, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Irvington",
            "id": 1133,
            "is_region": null,
            "is_state": false,
            "lat": 40.7239,
            "long": -74.2325,
            "name": "Irvington, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Jersey City",
            "id": 1134,
            "is_region": null,
            "is_state": false,
            "lat": 40.714,
            "long": -74.071,
            "name": "Jersey City, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Lakehurst",
            "id": 1135,
            "is_region": null,
            "is_state": false,
            "lat": 40.0131,
            "long": -74.3204,
            "name": "Lakehurst, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Lakewood",
            "id": 1136,
            "is_region": null,
            "is_state": false,
            "lat": 40.077,
            "long": -74.2004,
            "name": "Lakewood, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Long Beach",
            "id": 1137,
            "is_region": null,
            "is_state": false,
            "lat": 39.6016,
            "long": -74.2264,
            "name": "Long Beach, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Long Branch",
            "id": 1138,
            "is_region": null,
            "is_state": false,
            "lat": 40.2954,
            "long": -73.9899,
            "name": "Long Branch, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Madison",
            "id": 1139,
            "is_region": null,
            "is_state": false,
            "lat": 40.758,
            "long": -74.4178,
            "name": "Madison, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Menlo Park",
            "id": 1140,
            "is_region": null,
            "is_state": false,
            "lat": 40.565,
            "long": -74.3375,
            "name": "Menlo Park, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Millburn",
            "id": 1141,
            "is_region": null,
            "is_state": false,
            "lat": 40.7416,
            "long": -74.3213,
            "name": "Millburn, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Millville",
            "id": 1142,
            "is_region": null,
            "is_state": false,
            "lat": 39.3901,
            "long": -75.0548,
            "name": "Millville, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Montclair",
            "id": 1143,
            "is_region": null,
            "is_state": false,
            "lat": 40.8244,
            "long": -74.2123,
            "name": "Montclair, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Morristown",
            "id": 1144,
            "is_region": null,
            "is_state": false,
            "lat": 40.7966,
            "long": -74.4773,
            "name": "Morristown, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Mount Holly",
            "id": 1145,
            "is_region": null,
            "is_state": false,
            "lat": 39.9953,
            "long": -74.7865,
            "name": "Mount Holly, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "New Brunswick",
            "id": 1146,
            "is_region": null,
            "is_state": false,
            "lat": 40.4867,
            "long": -74.4444,
            "name": "New Brunswick, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "New Milford",
            "id": 1147,
            "is_region": null,
            "is_state": false,
            "lat": 40.9342,
            "long": -74.0195,
            "name": "New Milford, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Newark",
            "id": 1148,
            "is_region": null,
            "is_state": false,
            "lat": 40.72,
            "long": -74.17,
            "name": "Newark, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Ocean City",
            "id": 1149,
            "is_region": null,
            "is_state": false,
            "lat": 39.2636,
            "long": -74.6046,
            "name": "Ocean City, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Orange",
            "id": 1150,
            "is_region": null,
            "is_state": false,
            "lat": 40.768,
            "long": -74.2357,
            "name": "Orange, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Parsippany-Troy Hills",
            "id": 1151,
            "is_region": null,
            "is_state": false,
            "lat": 40.8596,
            "long": -74.4233,
            "name": "Parsippany-Troy Hills, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Passaic",
            "id": 1152,
            "is_region": null,
            "is_state": false,
            "lat": 40.8564,
            "long": -74.1269,
            "name": "Passaic, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Paterson",
            "id": 1153,
            "is_region": null,
            "is_state": false,
            "lat": 40.9147,
            "long": -74.1628,
            "name": "Paterson, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Perth Amboy",
            "id": 1154,
            "is_region": null,
            "is_state": false,
            "lat": 40.5202,
            "long": -74.2713,
            "name": "Perth Amboy, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Plainfield",
            "id": 1155,
            "is_region": null,
            "is_state": false,
            "lat": 40.6154,
            "long": -74.4158,
            "name": "Plainfield, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Princeton",
            "id": 1156,
            "is_region": null,
            "is_state": false,
            "lat": 40.3571,
            "long": -74.6702,
            "name": "Princeton, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Ridgewood",
            "id": 1157,
            "is_region": null,
            "is_state": false,
            "lat": 40.9816,
            "long": -74.1135,
            "name": "Ridgewood, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Roselle",
            "id": 1158,
            "is_region": null,
            "is_state": false,
            "lat": 40.6522,
            "long": -74.2602,
            "name": "Roselle, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Rutherford",
            "id": 1159,
            "is_region": null,
            "is_state": false,
            "lat": 40.8203,
            "long": -74.106,
            "name": "Rutherford, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Salem",
            "id": 1160,
            "is_region": null,
            "is_state": false,
            "lat": 39.5682,
            "long": -75.4725,
            "name": "Salem, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Somerville",
            "id": 1161,
            "is_region": null,
            "is_state": false,
            "lat": 40.5698,
            "long": -74.6077,
            "name": "Somerville, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "South Orange Village",
            "id": 1162,
            "is_region": null,
            "is_state": false,
            "lat": 40.7488,
            "long": -74.2615,
            "name": "South Orange Village, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Totowa",
            "id": 1163,
            "is_region": null,
            "is_state": false,
            "lat": 40.9033,
            "long": -74.2214,
            "name": "Totowa, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Trenton",
            "id": 1164,
            "is_region": null,
            "is_state": false,
            "lat": 40.2237,
            "long": -74.764,
            "name": "Trenton, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Union",
            "id": 1165,
            "is_region": null,
            "is_state": false,
            "lat": 40.6953,
            "long": -74.2691,
            "name": "Union, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Union City",
            "id": 1166,
            "is_region": null,
            "is_state": false,
            "lat": 40.7675,
            "long": -74.0323,
            "name": "Union City, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Vineland",
            "id": 1167,
            "is_region": null,
            "is_state": false,
            "lat": 39.465,
            "long": -74.9971,
            "name": "Vineland, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Wayne",
            "id": 1168,
            "is_region": null,
            "is_state": false,
            "lat": 40.9459,
            "long": -74.2451,
            "name": "Wayne, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Weehawken",
            "id": 1169,
            "is_region": null,
            "is_state": false,
            "lat": 40.7689,
            "long": -74.0154,
            "name": "Weehawken, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "West New York",
            "id": 1170,
            "is_region": null,
            "is_state": false,
            "lat": 40.786,
            "long": -74.0095,
            "name": "West New York, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "West Orange",
            "id": 1171,
            "is_region": null,
            "is_state": false,
            "lat": 40.7858,
            "long": -74.2651,
            "name": "West Orange, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Willingboro",
            "id": 1172,
            "is_region": null,
            "is_state": false,
            "lat": 40.028,
            "long": -74.887,
            "name": "Willingboro, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NJ",
            "city": "Woodbridge",
            "id": 1173,
            "is_region": null,
            "is_state": false,
            "lat": 40.5608,
            "long": -74.2926,
            "name": "Woodbridge, NJ",
            "region_id": null,
            "state": "New Jersey"
        },
        {
            "abbr": "NM",
            "city": "Acoma",
            "id": 1174,
            "is_region": null,
            "is_state": false,
            "lat": 34.8964,
            "long": -107.582,
            "name": "Acoma, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Alamogordo",
            "id": 1175,
            "is_region": null,
            "is_state": false,
            "lat": 32.9003,
            "long": -105.961,
            "name": "Alamogordo, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Albuquerque",
            "id": 1176,
            "is_region": null,
            "is_state": false,
            "lat": 35.1108,
            "long": -106.61,
            "name": "Albuquerque, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Artesia",
            "id": 1177,
            "is_region": null,
            "is_state": false,
            "lat": 32.8428,
            "long": -104.412,
            "name": "Artesia, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Belen",
            "id": 1178,
            "is_region": null,
            "is_state": false,
            "lat": 34.6656,
            "long": -106.776,
            "name": "Belen, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Carlsbad",
            "id": 1179,
            "is_region": null,
            "is_state": false,
            "lat": 32.4119,
            "long": -104.236,
            "name": "Carlsbad, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Clovis",
            "id": 1180,
            "is_region": null,
            "is_state": false,
            "lat": 34.4125,
            "long": -103.205,
            "name": "Clovis, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Deming",
            "id": 1181,
            "is_region": null,
            "is_state": false,
            "lat": 32.2611,
            "long": -107.756,
            "name": "Deming, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Farmington",
            "id": 1182,
            "is_region": null,
            "is_state": false,
            "lat": 36.7517,
            "long": -108.19,
            "name": "Farmington, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Gallup",
            "id": 1183,
            "is_region": null,
            "is_state": false,
            "lat": 35.5236,
            "long": -108.734,
            "name": "Gallup, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Grants",
            "id": 1184,
            "is_region": null,
            "is_state": false,
            "lat": 35.1553,
            "long": -107.842,
            "name": "Grants, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Hobbs",
            "id": 1185,
            "is_region": null,
            "is_state": false,
            "lat": 32.7122,
            "long": -103.141,
            "name": "Hobbs, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Las Cruces",
            "id": 1186,
            "is_region": null,
            "is_state": false,
            "lat": 32.3144,
            "long": -106.779,
            "name": "Las Cruces, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Las Vegas",
            "id": 1187,
            "is_region": null,
            "is_state": false,
            "lat": 35.5969,
            "long": -105.223,
            "name": "Las Vegas, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Los Alamos",
            "id": 1188,
            "is_region": null,
            "is_state": false,
            "lat": 35.8911,
            "long": -106.298,
            "name": "Los Alamos, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Lovington",
            "id": 1189,
            "is_region": null,
            "is_state": false,
            "lat": 32.9464,
            "long": -103.354,
            "name": "Lovington, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Portales",
            "id": 1190,
            "is_region": null,
            "is_state": false,
            "lat": 34.1822,
            "long": -103.339,
            "name": "Portales, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Raton",
            "id": 1191,
            "is_region": null,
            "is_state": false,
            "lat": 36.8969,
            "long": -104.44,
            "name": "Raton, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Roswell",
            "id": 1192,
            "is_region": null,
            "is_state": false,
            "lat": 33.3872,
            "long": -104.528,
            "name": "Roswell, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Santa Fe",
            "id": 1193,
            "is_region": null,
            "is_state": false,
            "lat": 35.6672,
            "long": -105.964,
            "name": "Santa Fe, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Shiprock",
            "id": 1194,
            "is_region": null,
            "is_state": false,
            "lat": 36.7928,
            "long": -108.687,
            "name": "Shiprock, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Silver City",
            "id": 1195,
            "is_region": null,
            "is_state": false,
            "lat": 32.7781,
            "long": -108.274,
            "name": "Silver City, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Socorro",
            "id": 1196,
            "is_region": null,
            "is_state": false,
            "lat": 34.0617,
            "long": -106.899,
            "name": "Socorro, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Taos",
            "id": 1197,
            "is_region": null,
            "is_state": false,
            "lat": 36.3939,
            "long": -105.577,
            "name": "Taos, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Truth or Consequences",
            "id": 1198,
            "is_region": null,
            "is_state": false,
            "lat": 33.1336,
            "long": -107.253,
            "name": "Truth or Consequences, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NM",
            "city": "Tucumcari",
            "id": 1199,
            "is_region": null,
            "is_state": false,
            "lat": 35.1694,
            "long": -103.726,
            "name": "Tucumcari, NM",
            "region_id": null,
            "state": "New Mexico"
        },
        {
            "abbr": "NY",
            "city": "Albany",
            "id": 1200,
            "is_region": null,
            "is_state": false,
            "lat": 42.6525,
            "long": -73.7572,
            "name": "Albany, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Amsterdam",
            "id": 1201,
            "is_region": null,
            "is_state": false,
            "lat": 42.95,
            "long": -74.183,
            "name": "Amsterdam, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Auburn",
            "id": 1202,
            "is_region": null,
            "is_state": false,
            "lat": 42.933,
            "long": -76.567,
            "name": "Auburn, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Babylon",
            "id": 1203,
            "is_region": null,
            "is_state": false,
            "lat": 40.6944,
            "long": -73.3294,
            "name": "Babylon, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Batavia",
            "id": 1204,
            "is_region": null,
            "is_state": false,
            "lat": 42.9986,
            "long": -78.1842,
            "name": "Batavia, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Beacon",
            "id": 1205,
            "is_region": null,
            "is_state": false,
            "lat": 41.5042,
            "long": -73.9656,
            "name": "Beacon, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Bedford",
            "id": 1206,
            "is_region": null,
            "is_state": false,
            "lat": 41.2258,
            "long": -73.665,
            "name": "Bedford, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Binghamton",
            "id": 1207,
            "is_region": null,
            "is_state": false,
            "lat": 42.1022,
            "long": -75.9117,
            "name": "Binghamton, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Bronx",
            "id": 1208,
            "is_region": null,
            "is_state": false,
            "lat": 40.8372,
            "long": -73.8861,
            "name": "Bronx, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Brooklyn",
            "id": 1209,
            "is_region": null,
            "is_state": false,
            "lat": 40.6928,
            "long": -73.9903,
            "name": "Brooklyn, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Buffalo",
            "id": 1210,
            "is_region": null,
            "is_state": false,
            "lat": 42.9047,
            "long": -78.8494,
            "name": "Buffalo, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Chautauqua",
            "id": 1211,
            "is_region": null,
            "is_state": false,
            "lat": 42.2261,
            "long": -79.4839,
            "name": "Chautauqua, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Cheektowaga",
            "id": 1212,
            "is_region": null,
            "is_state": false,
            "lat": 42.9039,
            "long": -78.7439,
            "name": "Cheektowaga, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Clinton",
            "id": 1213,
            "is_region": null,
            "is_state": false,
            "lat": 43.0489,
            "long": -75.3803,
            "name": "Clinton, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Cohoes",
            "id": 1214,
            "is_region": null,
            "is_state": false,
            "lat": 42.7792,
            "long": -73.7128,
            "name": "Cohoes, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Coney Island",
            "id": 1215,
            "is_region": null,
            "is_state": false,
            "lat": 40.5744,
            "long": -73.9786,
            "name": "Coney Island, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Cooperstown",
            "id": 1216,
            "is_region": null,
            "is_state": false,
            "lat": 42.6972,
            "long": -74.9269,
            "name": "Cooperstown, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Corning",
            "id": 1217,
            "is_region": null,
            "is_state": false,
            "lat": 42.1481,
            "long": -77.0569,
            "name": "Corning, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Cortland",
            "id": 1218,
            "is_region": null,
            "is_state": false,
            "lat": 42.6006,
            "long": -76.1814,
            "name": "Cortland, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Crown Point",
            "id": 1219,
            "is_region": null,
            "is_state": false,
            "lat": 43.9503,
            "long": -73.4836,
            "name": "Crown Point, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Dunkirk",
            "id": 1220,
            "is_region": null,
            "is_state": false,
            "lat": 42.4794,
            "long": -79.3339,
            "name": "Dunkirk, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "East Aurora",
            "id": 1221,
            "is_region": null,
            "is_state": false,
            "lat": 42.7669,
            "long": -78.6172,
            "name": "East Aurora, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "East Hampton",
            "id": 1222,
            "is_region": null,
            "is_state": false,
            "lat": 40.9569,
            "long": -72.1989,
            "name": "East Hampton, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Eastchester",
            "id": 1223,
            "is_region": null,
            "is_state": false,
            "lat": 40.9536,
            "long": -73.8133,
            "name": "Eastchester, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Elmira",
            "id": 1224,
            "is_region": null,
            "is_state": false,
            "lat": 42.0853,
            "long": -76.8092,
            "name": "Elmira, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Flushing",
            "id": 1225,
            "is_region": null,
            "is_state": false,
            "lat": 40.7481,
            "long": -73.8164,
            "name": "Flushing, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Forest Hills",
            "id": 1226,
            "is_region": null,
            "is_state": false,
            "lat": 40.7161,
            "long": -73.85,
            "name": "Forest Hills, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Fredonia",
            "id": 1227,
            "is_region": null,
            "is_state": false,
            "lat": 42.4408,
            "long": -79.3339,
            "name": "Fredonia, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Garden City",
            "id": 1228,
            "is_region": null,
            "is_state": false,
            "lat": 40.7269,
            "long": -73.6497,
            "name": "Garden City, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Geneva",
            "id": 1229,
            "is_region": null,
            "is_state": false,
            "lat": 42.8789,
            "long": -76.9931,
            "name": "Geneva, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Glens Falls",
            "id": 1230,
            "is_region": null,
            "is_state": false,
            "lat": 43.3122,
            "long": -73.6483,
            "name": "Glens Falls, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Gloversville",
            "id": 1231,
            "is_region": null,
            "is_state": false,
            "lat": 43.05,
            "long": -74.35,
            "name": "Gloversville, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Great Neck",
            "id": 1232,
            "is_region": null,
            "is_state": false,
            "lat": 40.7872,
            "long": -73.7272,
            "name": "Great Neck, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Hammondsport",
            "id": 1233,
            "is_region": null,
            "is_state": false,
            "lat": 42.4089,
            "long": -77.2228,
            "name": "Hammondsport, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Harlem",
            "id": 1234,
            "is_region": null,
            "is_state": false,
            "lat": 40.8092,
            "long": -73.9483,
            "name": "Harlem, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Hempstead",
            "id": 1235,
            "is_region": null,
            "is_state": false,
            "lat": 40.7047,
            "long": -73.6172,
            "name": "Hempstead, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Herkimer",
            "id": 1236,
            "is_region": null,
            "is_state": false,
            "lat": 43.0261,
            "long": -74.9903,
            "name": "Herkimer, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Hudson",
            "id": 1237,
            "is_region": null,
            "is_state": false,
            "lat": 42.25,
            "long": -73.7897,
            "name": "Hudson, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Huntington",
            "id": 1238,
            "is_region": null,
            "is_state": false,
            "lat": 40.86,
            "long": -73.3522,
            "name": "Huntington, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Hyde Park",
            "id": 1239,
            "is_region": null,
            "is_state": false,
            "lat": 41.783,
            "long": -73.9,
            "name": "Hyde Park, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Ilion",
            "id": 1240,
            "is_region": null,
            "is_state": false,
            "lat": 43.017,
            "long": -75.05,
            "name": "Ilion, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Ithaca",
            "id": 1241,
            "is_region": null,
            "is_state": false,
            "lat": 42.4433,
            "long": -76.5,
            "name": "Ithaca, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Jamestown",
            "id": 1242,
            "is_region": null,
            "is_state": false,
            "lat": 42.0956,
            "long": -79.2386,
            "name": "Jamestown, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Johnstown",
            "id": 1243,
            "is_region": null,
            "is_state": false,
            "lat": 43.0072,
            "long": -74.3722,
            "name": "Johnstown, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Kingston",
            "id": 1244,
            "is_region": null,
            "is_state": false,
            "lat": 41.925,
            "long": -74.0,
            "name": "Kingston, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Lackawanna",
            "id": 1245,
            "is_region": null,
            "is_state": false,
            "lat": 42.8194,
            "long": -78.8256,
            "name": "Lackawanna, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Lake Placid",
            "id": 1246,
            "is_region": null,
            "is_state": false,
            "lat": 44.2856,
            "long": -73.9853,
            "name": "Lake Placid, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Levittown",
            "id": 1247,
            "is_region": null,
            "is_state": false,
            "lat": 40.7244,
            "long": -73.5111,
            "name": "Levittown, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Lockport",
            "id": 1248,
            "is_region": null,
            "is_state": false,
            "lat": 43.1697,
            "long": -78.6911,
            "name": "Lockport, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Mamaroneck",
            "id": 1249,
            "is_region": null,
            "is_state": false,
            "lat": 40.9492,
            "long": -73.7336,
            "name": "Mamaroneck, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Manhattan",
            "id": 1250,
            "is_region": null,
            "is_state": false,
            "lat": 40.7903,
            "long": -73.9597,
            "name": "Manhattan, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Massena",
            "id": 1251,
            "is_region": null,
            "is_state": false,
            "lat": 44.9303,
            "long": -74.8925,
            "name": "Massena, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Middletown",
            "id": 1252,
            "is_region": null,
            "is_state": false,
            "lat": 41.4458,
            "long": -74.4221,
            "name": "Middletown, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Mineola",
            "id": 1253,
            "is_region": null,
            "is_state": false,
            "lat": 40.7472,
            "long": -73.6381,
            "name": "Mineola, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Mount Vernon",
            "id": 1254,
            "is_region": null,
            "is_state": false,
            "lat": 40.9142,
            "long": -73.8306,
            "name": "Mount Vernon, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "New Paltz",
            "id": 1255,
            "is_region": null,
            "is_state": false,
            "lat": 41.7481,
            "long": -74.085,
            "name": "New Paltz, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "New Rochelle",
            "id": 1256,
            "is_region": null,
            "is_state": false,
            "lat": 40.9114,
            "long": -73.7822,
            "name": "New Rochelle, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "New Windsor",
            "id": 1257,
            "is_region": null,
            "is_state": false,
            "lat": 41.4717,
            "long": -74.0758,
            "name": "New Windsor, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "New York City",
            "id": 1258,
            "is_region": null,
            "is_state": false,
            "lat": 40.7127,
            "long": -74.0059,
            "name": "New York City, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Newburgh",
            "id": 1259,
            "is_region": null,
            "is_state": false,
            "lat": 41.5197,
            "long": -74.0214,
            "name": "Newburgh, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Niagara Falls",
            "id": 1260,
            "is_region": null,
            "is_state": false,
            "lat": 43.1,
            "long": -79.017,
            "name": "Niagara Falls, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "North Hempstead",
            "id": 1261,
            "is_region": null,
            "is_state": false,
            "lat": 40.7589,
            "long": -73.5881,
            "name": "North Hempstead, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Nyack",
            "id": 1262,
            "is_region": null,
            "is_state": false,
            "lat": 41.0925,
            "long": -73.9225,
            "name": "Nyack, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Ogdensburg",
            "id": 1263,
            "is_region": null,
            "is_state": false,
            "lat": 44.7,
            "long": -75.483,
            "name": "Ogdensburg, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Olean",
            "id": 1264,
            "is_region": null,
            "is_state": false,
            "lat": 42.0825,
            "long": -78.4308,
            "name": "Olean, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Oneida",
            "id": 1265,
            "is_region": null,
            "is_state": false,
            "lat": 43.085,
            "long": -75.6533,
            "name": "Oneida, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Oneonta",
            "id": 1266,
            "is_region": null,
            "is_state": false,
            "lat": 42.4558,
            "long": -75.0622,
            "name": "Oneonta, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Ossining",
            "id": 1267,
            "is_region": null,
            "is_state": false,
            "lat": 41.1653,
            "long": -73.8567,
            "name": "Ossining, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Oswego",
            "id": 1268,
            "is_region": null,
            "is_state": false,
            "lat": 43.4547,
            "long": -76.5067,
            "name": "Oswego, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Oyster Bay",
            "id": 1269,
            "is_region": null,
            "is_state": false,
            "lat": 40.7594,
            "long": -73.5028,
            "name": "Oyster Bay, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Palmyra",
            "id": 1270,
            "is_region": null,
            "is_state": false,
            "lat": 43.0636,
            "long": -77.2333,
            "name": "Palmyra, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Peekskill",
            "id": 1271,
            "is_region": null,
            "is_state": false,
            "lat": 41.283,
            "long": -73.917,
            "name": "Peekskill, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Plattsburgh",
            "id": 1272,
            "is_region": null,
            "is_state": false,
            "lat": 44.6953,
            "long": -73.4583,
            "name": "Plattsburgh, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Port Washington",
            "id": 1273,
            "is_region": null,
            "is_state": false,
            "lat": 40.8289,
            "long": -73.6867,
            "name": "Port Washington, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Potsdam",
            "id": 1274,
            "is_region": null,
            "is_state": false,
            "lat": 44.6708,
            "long": -74.9842,
            "name": "Potsdam, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Poughkeepsie",
            "id": 1275,
            "is_region": null,
            "is_state": false,
            "lat": 41.7,
            "long": -73.93,
            "name": "Poughkeepsie, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Queens",
            "id": 1276,
            "is_region": null,
            "is_state": false,
            "lat": 40.75,
            "long": -73.867,
            "name": "Queens, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Rensselaer",
            "id": 1277,
            "is_region": null,
            "is_state": false,
            "lat": 42.6467,
            "long": -73.7336,
            "name": "Rensselaer, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Rochester",
            "id": 1278,
            "is_region": null,
            "is_state": false,
            "lat": 43.1656,
            "long": -77.6114,
            "name": "Rochester, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Rome",
            "id": 1279,
            "is_region": null,
            "is_state": false,
            "lat": 43.2194,
            "long": -75.4633,
            "name": "Rome, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Rotterdam",
            "id": 1280,
            "is_region": null,
            "is_state": false,
            "lat": 42.7867,
            "long": -73.9708,
            "name": "Rotterdam, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Rye",
            "id": 1281,
            "is_region": null,
            "is_state": false,
            "lat": 40.9811,
            "long": -73.6839,
            "name": "Rye, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Sag Harbor",
            "id": 1282,
            "is_region": null,
            "is_state": false,
            "lat": 41.0,
            "long": -72.3,
            "name": "Sag Harbor, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Saranac Lake",
            "id": 1283,
            "is_region": null,
            "is_state": false,
            "lat": 44.3261,
            "long": -74.1308,
            "name": "Saranac Lake, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Saratoga Springs",
            "id": 1284,
            "is_region": null,
            "is_state": false,
            "lat": 43.0831,
            "long": -73.7844,
            "name": "Saratoga Springs, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Scarsdale",
            "id": 1285,
            "is_region": null,
            "is_state": false,
            "lat": 40.9922,
            "long": -73.7869,
            "name": "Scarsdale, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Schenectady",
            "id": 1286,
            "is_region": null,
            "is_state": false,
            "lat": 42.8142,
            "long": -73.9372,
            "name": "Schenectady, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Seneca Falls",
            "id": 1287,
            "is_region": null,
            "is_state": false,
            "lat": 42.9086,
            "long": -76.7981,
            "name": "Seneca Falls, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Southampton",
            "id": 1288,
            "is_region": null,
            "is_state": false,
            "lat": 40.8853,
            "long": -72.3953,
            "name": "Southampton, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Staten Island",
            "id": 1289,
            "is_region": null,
            "is_state": false,
            "lat": 40.5719,
            "long": -74.1469,
            "name": "Staten Island, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Stony Brook",
            "id": 1290,
            "is_region": null,
            "is_state": false,
            "lat": 40.9064,
            "long": -73.1283,
            "name": "Stony Brook, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Stony Point",
            "id": 1291,
            "is_region": null,
            "is_state": false,
            "lat": 41.2372,
            "long": -74.0011,
            "name": "Stony Point, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Syracuse",
            "id": 1292,
            "is_region": null,
            "is_state": false,
            "lat": 43.0469,
            "long": -76.1444,
            "name": "Syracuse, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Tarrytown",
            "id": 1293,
            "is_region": null,
            "is_state": false,
            "lat": 41.0692,
            "long": -73.8597,
            "name": "Tarrytown, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Ticonderoga",
            "id": 1294,
            "is_region": null,
            "is_state": false,
            "lat": 43.8583,
            "long": -73.4542,
            "name": "Ticonderoga, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Tonawanda",
            "id": 1295,
            "is_region": null,
            "is_state": false,
            "lat": 43.0111,
            "long": -78.8775,
            "name": "Tonawanda, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Troy",
            "id": 1296,
            "is_region": null,
            "is_state": false,
            "lat": 42.7317,
            "long": -73.6925,
            "name": "Troy, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Utica",
            "id": 1297,
            "is_region": null,
            "is_state": false,
            "lat": 43.0947,
            "long": -75.2758,
            "name": "Utica, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Watertown",
            "id": 1298,
            "is_region": null,
            "is_state": false,
            "lat": 43.9756,
            "long": -75.9064,
            "name": "Watertown, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Watervliet",
            "id": 1299,
            "is_region": null,
            "is_state": false,
            "lat": 42.7247,
            "long": -73.7061,
            "name": "Watervliet, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Watkins Glen",
            "id": 1300,
            "is_region": null,
            "is_state": false,
            "lat": 42.3811,
            "long": -76.8711,
            "name": "Watkins Glen, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "West Seneca",
            "id": 1301,
            "is_region": null,
            "is_state": false,
            "lat": 42.8392,
            "long": -78.7608,
            "name": "West Seneca, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "White Plains",
            "id": 1302,
            "is_region": null,
            "is_state": false,
            "lat": 41.04,
            "long": -73.7786,
            "name": "White Plains, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Woodstock",
            "id": 1303,
            "is_region": null,
            "is_state": false,
            "lat": 42.0406,
            "long": -74.1289,
            "name": "Woodstock, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NY",
            "city": "Yonkers",
            "id": 1304,
            "is_region": null,
            "is_state": false,
            "lat": 40.9414,
            "long": -73.8644,
            "name": "Yonkers, NY",
            "region_id": null,
            "state": "New York"
        },
        {
            "abbr": "NC",
            "city": "Asheboro",
            "id": 1305,
            "is_region": null,
            "is_state": false,
            "lat": 35.7153,
            "long": -79.8131,
            "name": "Asheboro, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Asheville",
            "id": 1306,
            "is_region": null,
            "is_state": false,
            "lat": 35.58,
            "long": -82.5558,
            "name": "Asheville, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Bath",
            "id": 1307,
            "is_region": null,
            "is_state": false,
            "lat": 35.4744,
            "long": -76.8089,
            "name": "Bath, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Beaufort",
            "id": 1308,
            "is_region": null,
            "is_state": false,
            "lat": 34.717,
            "long": -76.65,
            "name": "Beaufort, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Boone",
            "id": 1309,
            "is_region": null,
            "is_state": false,
            "lat": 36.2114,
            "long": -81.6686,
            "name": "Boone, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Burlington",
            "id": 1310,
            "is_region": null,
            "is_state": false,
            "lat": 36.0897,
            "long": -79.4456,
            "name": "Burlington, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Chapel Hill",
            "id": 1311,
            "is_region": null,
            "is_state": false,
            "lat": 35.9131,
            "long": -79.0558,
            "name": "Chapel Hill, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Charlotte",
            "id": 1312,
            "is_region": null,
            "is_state": false,
            "lat": 35.2269,
            "long": -80.8433,
            "name": "Charlotte, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Concord",
            "id": 1313,
            "is_region": null,
            "is_state": false,
            "lat": 35.4044,
            "long": -80.6006,
            "name": "Concord, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Durham",
            "id": 1314,
            "is_region": null,
            "is_state": false,
            "lat": 35.9886,
            "long": -78.9072,
            "name": "Durham, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Edenton",
            "id": 1315,
            "is_region": null,
            "is_state": false,
            "lat": 36.0619,
            "long": -76.6058,
            "name": "Edenton, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Elizabeth City",
            "id": 1316,
            "is_region": null,
            "is_state": false,
            "lat": 36.2956,
            "long": -76.225,
            "name": "Elizabeth City, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Fayetteville",
            "id": 1317,
            "is_region": null,
            "is_state": false,
            "lat": 35.0525,
            "long": -78.8781,
            "name": "Fayetteville, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Gastonia",
            "id": 1318,
            "is_region": null,
            "is_state": false,
            "lat": 35.2553,
            "long": -81.1803,
            "name": "Gastonia, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Goldsboro",
            "id": 1319,
            "is_region": null,
            "is_state": false,
            "lat": 35.3819,
            "long": -77.9781,
            "name": "Goldsboro, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Greensboro",
            "id": 1320,
            "is_region": null,
            "is_state": false,
            "lat": 36.08,
            "long": -79.8194,
            "name": "Greensboro, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Greenville",
            "id": 1321,
            "is_region": null,
            "is_state": false,
            "lat": 35.6017,
            "long": -77.3725,
            "name": "Greenville, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Halifax",
            "id": 1322,
            "is_region": null,
            "is_state": false,
            "lat": 36.3283,
            "long": -77.5908,
            "name": "Halifax, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Henderson",
            "id": 1323,
            "is_region": null,
            "is_state": false,
            "lat": 36.3247,
            "long": -78.4086,
            "name": "Henderson, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Hickory",
            "id": 1324,
            "is_region": null,
            "is_state": false,
            "lat": 35.7378,
            "long": -81.3283,
            "name": "Hickory, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "High Point",
            "id": 1325,
            "is_region": null,
            "is_state": false,
            "lat": 35.9706,
            "long": -79.9975,
            "name": "High Point, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Hillsborough",
            "id": 1326,
            "is_region": null,
            "is_state": false,
            "lat": 36.0706,
            "long": -79.1042,
            "name": "Hillsborough, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Jacksonville",
            "id": 1327,
            "is_region": null,
            "is_state": false,
            "lat": 34.7597,
            "long": -77.4097,
            "name": "Jacksonville, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Kinston",
            "id": 1328,
            "is_region": null,
            "is_state": false,
            "lat": 35.2706,
            "long": -77.585,
            "name": "Kinston, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Kitty Hawk",
            "id": 1329,
            "is_region": null,
            "is_state": false,
            "lat": 36.0769,
            "long": -75.7047,
            "name": "Kitty Hawk, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Lumberton",
            "id": 1330,
            "is_region": null,
            "is_state": false,
            "lat": 34.6272,
            "long": -79.0119,
            "name": "Lumberton, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Morehead City",
            "id": 1331,
            "is_region": null,
            "is_state": false,
            "lat": 34.7278,
            "long": -76.7467,
            "name": "Morehead City, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Morganton",
            "id": 1332,
            "is_region": null,
            "is_state": false,
            "lat": 35.7425,
            "long": -81.6922,
            "name": "Morganton, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Nags Head",
            "id": 1333,
            "is_region": null,
            "is_state": false,
            "lat": 35.9319,
            "long": -75.615,
            "name": "Nags Head, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "New Bern",
            "id": 1334,
            "is_region": null,
            "is_state": false,
            "lat": 35.1092,
            "long": -77.0692,
            "name": "New Bern, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Pinehurst",
            "id": 1335,
            "is_region": null,
            "is_state": false,
            "lat": 35.1954,
            "long": -79.4687,
            "name": "Pinehurst, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Raleigh",
            "id": 1336,
            "is_region": null,
            "is_state": false,
            "lat": 35.767,
            "long": -78.633,
            "name": "Raleigh, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Rocky Mount",
            "id": 1337,
            "is_region": null,
            "is_state": false,
            "lat": 35.9383,
            "long": -77.7906,
            "name": "Rocky Mount, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Salisbury",
            "id": 1338,
            "is_region": null,
            "is_state": false,
            "lat": 35.6683,
            "long": -80.4786,
            "name": "Salisbury, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Shelby",
            "id": 1339,
            "is_region": null,
            "is_state": false,
            "lat": 35.2883,
            "long": -81.5378,
            "name": "Shelby, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Washington",
            "id": 1340,
            "is_region": null,
            "is_state": false,
            "lat": 35.5536,
            "long": -77.0519,
            "name": "Washington, NC",
            "region_id": 2535,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Wilmington",
            "id": 1341,
            "is_region": null,
            "is_state": false,
            "lat": 34.2233,
            "long": -77.9122,
            "name": "Wilmington, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Wilson",
            "id": 1342,
            "is_region": null,
            "is_state": false,
            "lat": 35.7311,
            "long": -77.9236,
            "name": "Wilson, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "NC",
            "city": "Winston-Salem",
            "id": 1343,
            "is_region": null,
            "is_state": false,
            "lat": 36.1028,
            "long": -80.2605,
            "name": "Winston-Salem, NC",
            "region_id": null,
            "state": "North Carolina"
        },
        {
            "abbr": "ND",
            "city": "Bismarck",
            "id": 1344,
            "is_region": null,
            "is_state": false,
            "lat": 46.8133,
            "long": -100.779,
            "name": "Bismarck, ND",
            "region_id": null,
            "state": "North Dakota"
        },
        {
            "abbr": "ND",
            "city": "Devils Lake",
            "id": 1345,
            "is_region": null,
            "is_state": false,
            "lat": 48.117,
            "long": -98.867,
            "name": "Devils Lake, ND",
            "region_id": null,
            "state": "North Dakota"
        },
        {
            "abbr": "ND",
            "city": "Dickinson",
            "id": 1346,
            "is_region": null,
            "is_state": false,
            "lat": 46.8836,
            "long": -102.789,
            "name": "Dickinson, ND",
            "region_id": null,
            "state": "North Dakota"
        },
        {
            "abbr": "ND",
            "city": "Fargo",
            "id": 1347,
            "is_region": null,
            "is_state": false,
            "lat": 46.8772,
            "long": -96.7894,
            "name": "Fargo, ND",
            "region_id": null,
            "state": "North Dakota"
        },
        {
            "abbr": "ND",
            "city": "Grand Forks",
            "id": 1348,
            "is_region": null,
            "is_state": false,
            "lat": 47.9253,
            "long": -97.0325,
            "name": "Grand Forks, ND",
            "region_id": null,
            "state": "North Dakota"
        },
        {
            "abbr": "ND",
            "city": "Jamestown",
            "id": 1349,
            "is_region": null,
            "is_state": false,
            "lat": 46.9056,
            "long": -98.7031,
            "name": "Jamestown, ND",
            "region_id": null,
            "state": "North Dakota"
        },
        {
            "abbr": "ND",
            "city": "Mandan",
            "id": 1350,
            "is_region": null,
            "is_state": false,
            "lat": 46.8289,
            "long": -100.891,
            "name": "Mandan, ND",
            "region_id": null,
            "state": "North Dakota"
        },
        {
            "abbr": "ND",
            "city": "Minot",
            "id": 1351,
            "is_region": null,
            "is_state": false,
            "lat": 48.2331,
            "long": -101.292,
            "name": "Minot, ND",
            "region_id": null,
            "state": "North Dakota"
        },
        {
            "abbr": "ND",
            "city": "Rugby",
            "id": 1352,
            "is_region": null,
            "is_state": false,
            "lat": 48.3672,
            "long": -99.9961,
            "name": "Rugby, ND",
            "region_id": null,
            "state": "North Dakota"
        },
        {
            "abbr": "ND",
            "city": "Valley City",
            "id": 1353,
            "is_region": null,
            "is_state": false,
            "lat": 46.9247,
            "long": -98.0056,
            "name": "Valley City, ND",
            "region_id": null,
            "state": "North Dakota"
        },
        {
            "abbr": "ND",
            "city": "Wahpeton",
            "id": 1354,
            "is_region": null,
            "is_state": false,
            "lat": 46.27,
            "long": -96.6106,
            "name": "Wahpeton, ND",
            "region_id": null,
            "state": "North Dakota"
        },
        {
            "abbr": "ND",
            "city": "Williston",
            "id": 1355,
            "is_region": null,
            "is_state": false,
            "lat": 48.1564,
            "long": -103.628,
            "name": "Williston, ND",
            "region_id": null,
            "state": "North Dakota"
        },
        {
            "abbr": "OH",
            "city": "Akron",
            "id": 1356,
            "is_region": null,
            "is_state": false,
            "lat": 41.0731,
            "long": -81.5178,
            "name": "Akron, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Alliance",
            "id": 1357,
            "is_region": null,
            "is_state": false,
            "lat": 40.9133,
            "long": -81.1081,
            "name": "Alliance, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Ashtabula",
            "id": 1358,
            "is_region": null,
            "is_state": false,
            "lat": 41.8772,
            "long": -80.7969,
            "name": "Ashtabula, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Athens",
            "id": 1359,
            "is_region": null,
            "is_state": false,
            "lat": 39.3292,
            "long": -82.0961,
            "name": "Athens, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Barberton",
            "id": 1360,
            "is_region": null,
            "is_state": false,
            "lat": 41.0158,
            "long": -81.6058,
            "name": "Barberton, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Bedford",
            "id": 1361,
            "is_region": null,
            "is_state": false,
            "lat": 41.3925,
            "long": -81.5344,
            "name": "Bedford, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Bellefontaine",
            "id": 1362,
            "is_region": null,
            "is_state": false,
            "lat": 40.3608,
            "long": -83.7581,
            "name": "Bellefontaine, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Bowling Green",
            "id": 1363,
            "is_region": null,
            "is_state": false,
            "lat": 41.3739,
            "long": -83.6508,
            "name": "Bowling Green, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Canton",
            "id": 1364,
            "is_region": null,
            "is_state": false,
            "lat": 40.805,
            "long": -81.3758,
            "name": "Canton, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Chillicothe",
            "id": 1365,
            "is_region": null,
            "is_state": false,
            "lat": 39.3364,
            "long": -82.9839,
            "name": "Chillicothe, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Cincinnati",
            "id": 1366,
            "is_region": null,
            "is_state": false,
            "lat": 39.1,
            "long": -84.517,
            "name": "Cincinnati, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Cleveland",
            "id": 1367,
            "is_region": null,
            "is_state": false,
            "lat": 41.4822,
            "long": -81.6697,
            "name": "Cleveland, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Cleveland Heights",
            "id": 1368,
            "is_region": null,
            "is_state": false,
            "lat": 41.5097,
            "long": -81.5633,
            "name": "Cleveland Heights, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Columbus",
            "id": 1369,
            "is_region": null,
            "is_state": false,
            "lat": 39.983,
            "long": -82.983,
            "name": "Columbus, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Conneaut",
            "id": 1370,
            "is_region": null,
            "is_state": false,
            "lat": 41.9472,
            "long": -80.5556,
            "name": "Conneaut, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Cuyahoga Falls",
            "id": 1371,
            "is_region": null,
            "is_state": false,
            "lat": 41.1456,
            "long": -81.4967,
            "name": "Cuyahoga Falls, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Dayton",
            "id": 1372,
            "is_region": null,
            "is_state": false,
            "lat": 39.7594,
            "long": -84.1917,
            "name": "Dayton, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Defiance",
            "id": 1373,
            "is_region": null,
            "is_state": false,
            "lat": 41.2819,
            "long": -84.3628,
            "name": "Defiance, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Delaware",
            "id": 1374,
            "is_region": null,
            "is_state": false,
            "lat": 40.2989,
            "long": -83.0719,
            "name": "Delaware, OH",
            "region_id": 2536,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "East Cleveland",
            "id": 1375,
            "is_region": null,
            "is_state": false,
            "lat": 41.5317,
            "long": -81.5819,
            "name": "East Cleveland, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "East Liverpool",
            "id": 1376,
            "is_region": null,
            "is_state": false,
            "lat": 40.6286,
            "long": -80.5692,
            "name": "East Liverpool, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Elyria",
            "id": 1377,
            "is_region": null,
            "is_state": false,
            "lat": 41.3733,
            "long": -82.1017,
            "name": "Elyria, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Euclid",
            "id": 1378,
            "is_region": null,
            "is_state": false,
            "lat": 41.5956,
            "long": -81.5192,
            "name": "Euclid, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Findlay",
            "id": 1379,
            "is_region": null,
            "is_state": false,
            "lat": 41.0428,
            "long": -83.6422,
            "name": "Findlay, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Gallipolis",
            "id": 1380,
            "is_region": null,
            "is_state": false,
            "lat": 38.8153,
            "long": -82.1975,
            "name": "Gallipolis, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Greenville",
            "id": 1381,
            "is_region": null,
            "is_state": false,
            "lat": 40.1025,
            "long": -84.6281,
            "name": "Greenville, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Hamilton",
            "id": 1382,
            "is_region": null,
            "is_state": false,
            "lat": 39.3994,
            "long": -84.5614,
            "name": "Hamilton, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Kent",
            "id": 1383,
            "is_region": null,
            "is_state": false,
            "lat": 41.15,
            "long": -81.36,
            "name": "Kent, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Kettering",
            "id": 1384,
            "is_region": null,
            "is_state": false,
            "lat": 39.6972,
            "long": -84.1522,
            "name": "Kettering, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Lakewood",
            "id": 1385,
            "is_region": null,
            "is_state": false,
            "lat": 41.4808,
            "long": -81.8003,
            "name": "Lakewood, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Lancaster",
            "id": 1386,
            "is_region": null,
            "is_state": false,
            "lat": 39.717,
            "long": -82.6,
            "name": "Lancaster, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Lima",
            "id": 1387,
            "is_region": null,
            "is_state": false,
            "lat": 40.7408,
            "long": -84.115,
            "name": "Lima, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Lorain",
            "id": 1388,
            "is_region": null,
            "is_state": false,
            "lat": 41.4483,
            "long": -82.1689,
            "name": "Lorain, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Mansfield",
            "id": 1389,
            "is_region": null,
            "is_state": false,
            "lat": 40.75,
            "long": -82.517,
            "name": "Mansfield, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Marietta",
            "id": 1390,
            "is_region": null,
            "is_state": false,
            "lat": 39.417,
            "long": -81.45,
            "name": "Marietta, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Marion",
            "id": 1391,
            "is_region": null,
            "is_state": false,
            "lat": 40.5867,
            "long": -83.1264,
            "name": "Marion, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Martins Ferry",
            "id": 1392,
            "is_region": null,
            "is_state": false,
            "lat": 40.0992,
            "long": -80.7253,
            "name": "Martins Ferry, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Massillon",
            "id": 1393,
            "is_region": null,
            "is_state": false,
            "lat": 40.7967,
            "long": -81.5214,
            "name": "Massillon, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Mentor",
            "id": 1394,
            "is_region": null,
            "is_state": false,
            "lat": 41.6911,
            "long": -81.3419,
            "name": "Mentor, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Middletown",
            "id": 1395,
            "is_region": null,
            "is_state": false,
            "lat": 39.5,
            "long": -84.383,
            "name": "Middletown, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Milan",
            "id": 1396,
            "is_region": null,
            "is_state": false,
            "lat": 41.2933,
            "long": -82.6014,
            "name": "Milan, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Mount Vernon",
            "id": 1397,
            "is_region": null,
            "is_state": false,
            "lat": 40.3928,
            "long": -82.4811,
            "name": "Mount Vernon, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "New Philadelphia",
            "id": 1398,
            "is_region": null,
            "is_state": false,
            "lat": 40.4894,
            "long": -81.4472,
            "name": "New Philadelphia, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Newark",
            "id": 1399,
            "is_region": null,
            "is_state": false,
            "lat": 40.0631,
            "long": -82.4167,
            "name": "Newark, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Niles",
            "id": 1400,
            "is_region": null,
            "is_state": false,
            "lat": 41.1853,
            "long": -80.7572,
            "name": "Niles, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "North College Hill",
            "id": 1401,
            "is_region": null,
            "is_state": false,
            "lat": 39.2172,
            "long": -84.5525,
            "name": "North College Hill, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Norwalk",
            "id": 1402,
            "is_region": null,
            "is_state": false,
            "lat": 41.2431,
            "long": -82.6114,
            "name": "Norwalk, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Oberlin",
            "id": 1403,
            "is_region": null,
            "is_state": false,
            "lat": 41.2883,
            "long": -82.2167,
            "name": "Oberlin, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Painesville",
            "id": 1404,
            "is_region": null,
            "is_state": false,
            "lat": 41.7228,
            "long": -81.2497,
            "name": "Painesville, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Parma",
            "id": 1405,
            "is_region": null,
            "is_state": false,
            "lat": 41.3919,
            "long": -81.7286,
            "name": "Parma, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Piqua",
            "id": 1406,
            "is_region": null,
            "is_state": false,
            "lat": 40.1475,
            "long": -84.2481,
            "name": "Piqua, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Portsmouth",
            "id": 1407,
            "is_region": null,
            "is_state": false,
            "lat": 38.7431,
            "long": -82.9656,
            "name": "Portsmouth, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Put-in-Bay",
            "id": 1408,
            "is_region": null,
            "is_state": false,
            "lat": 41.6531,
            "long": -82.8175,
            "name": "Put-in-Bay, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Salem",
            "id": 1409,
            "is_region": null,
            "is_state": false,
            "lat": 40.9008,
            "long": -80.8528,
            "name": "Salem, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Sandusky",
            "id": 1410,
            "is_region": null,
            "is_state": false,
            "lat": 41.4467,
            "long": -82.7092,
            "name": "Sandusky, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Shaker Heights",
            "id": 1411,
            "is_region": null,
            "is_state": false,
            "lat": 41.4764,
            "long": -81.5517,
            "name": "Shaker Heights, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Springfield",
            "id": 1412,
            "is_region": null,
            "is_state": false,
            "lat": 39.9269,
            "long": -83.8042,
            "name": "Springfield, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Steubenville",
            "id": 1413,
            "is_region": null,
            "is_state": false,
            "lat": 40.3583,
            "long": -80.6167,
            "name": "Steubenville, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Tiffin",
            "id": 1414,
            "is_region": null,
            "is_state": false,
            "lat": 41.1169,
            "long": -83.1789,
            "name": "Tiffin, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Toledo",
            "id": 1415,
            "is_region": null,
            "is_state": false,
            "lat": 41.6656,
            "long": -83.5753,
            "name": "Toledo, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Urbana",
            "id": 1416,
            "is_region": null,
            "is_state": false,
            "lat": 40.1108,
            "long": -83.7514,
            "name": "Urbana, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Warren",
            "id": 1417,
            "is_region": null,
            "is_state": false,
            "lat": 41.2383,
            "long": -80.8144,
            "name": "Warren, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Wooster",
            "id": 1418,
            "is_region": null,
            "is_state": false,
            "lat": 40.8092,
            "long": -81.9372,
            "name": "Wooster, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Worthington",
            "id": 1419,
            "is_region": null,
            "is_state": false,
            "lat": 40.0914,
            "long": -83.0208,
            "name": "Worthington, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Xenia",
            "id": 1420,
            "is_region": null,
            "is_state": false,
            "lat": 39.6847,
            "long": -83.9297,
            "name": "Xenia, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Yellow Springs",
            "id": 1421,
            "is_region": null,
            "is_state": false,
            "lat": 39.8,
            "long": -83.9,
            "name": "Yellow Springs, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Youngstown",
            "id": 1422,
            "is_region": null,
            "is_state": false,
            "lat": 41.1,
            "long": -80.65,
            "name": "Youngstown, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OH",
            "city": "Zanesville",
            "id": 1423,
            "is_region": null,
            "is_state": false,
            "lat": 39.9461,
            "long": -82.0122,
            "name": "Zanesville, OH",
            "region_id": null,
            "state": "Ohio"
        },
        {
            "abbr": "OK",
            "city": "Ada",
            "id": 1424,
            "is_region": null,
            "is_state": false,
            "lat": 34.7636,
            "long": -96.6683,
            "name": "Ada, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Altus",
            "id": 1425,
            "is_region": null,
            "is_state": false,
            "lat": 34.6439,
            "long": -99.3267,
            "name": "Altus, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Alva",
            "id": 1426,
            "is_region": null,
            "is_state": false,
            "lat": 36.8058,
            "long": -98.6678,
            "name": "Alva, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Anadarko",
            "id": 1427,
            "is_region": null,
            "is_state": false,
            "lat": 35.0692,
            "long": -98.2461,
            "name": "Anadarko, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Ardmore",
            "id": 1428,
            "is_region": null,
            "is_state": false,
            "lat": 34.1811,
            "long": -97.1294,
            "name": "Ardmore, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Bartlesville",
            "id": 1429,
            "is_region": null,
            "is_state": false,
            "lat": 36.7472,
            "long": -95.9594,
            "name": "Bartlesville, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Bethany",
            "id": 1430,
            "is_region": null,
            "is_state": false,
            "lat": 35.5047,
            "long": -97.6389,
            "name": "Bethany, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Chickasha",
            "id": 1431,
            "is_region": null,
            "is_state": false,
            "lat": 35.0383,
            "long": -97.9461,
            "name": "Chickasha, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Claremore",
            "id": 1432,
            "is_region": null,
            "is_state": false,
            "lat": 36.3153,
            "long": -95.6128,
            "name": "Claremore, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Clinton",
            "id": 1433,
            "is_region": null,
            "is_state": false,
            "lat": 35.5094,
            "long": -98.9742,
            "name": "Clinton, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Cushing",
            "id": 1434,
            "is_region": null,
            "is_state": false,
            "lat": 35.9825,
            "long": -96.7642,
            "name": "Cushing, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Duncan",
            "id": 1435,
            "is_region": null,
            "is_state": false,
            "lat": 34.5028,
            "long": -97.9583,
            "name": "Duncan, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Durant",
            "id": 1436,
            "is_region": null,
            "is_state": false,
            "lat": 33.9997,
            "long": -96.3847,
            "name": "Durant, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Edmond",
            "id": 1437,
            "is_region": null,
            "is_state": false,
            "lat": 35.65,
            "long": -97.467,
            "name": "Edmond, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "El Reno",
            "id": 1438,
            "is_region": null,
            "is_state": false,
            "lat": 35.5303,
            "long": -97.9575,
            "name": "El Reno, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Elk City",
            "id": 1439,
            "is_region": null,
            "is_state": false,
            "lat": 35.4028,
            "long": -99.4239,
            "name": "Elk City, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Enid",
            "id": 1440,
            "is_region": null,
            "is_state": false,
            "lat": 36.4006,
            "long": -97.8808,
            "name": "Enid, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Eufaula",
            "id": 1441,
            "is_region": null,
            "is_state": false,
            "lat": 35.2919,
            "long": -95.5867,
            "name": "Eufaula, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Frederick",
            "id": 1442,
            "is_region": null,
            "is_state": false,
            "lat": 34.3903,
            "long": -99.0161,
            "name": "Frederick, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Guthrie",
            "id": 1443,
            "is_region": null,
            "is_state": false,
            "lat": 35.8564,
            "long": -97.4358,
            "name": "Guthrie, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Guymon",
            "id": 1444,
            "is_region": null,
            "is_state": false,
            "lat": 36.6828,
            "long": -101.482,
            "name": "Guymon, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Hobart",
            "id": 1445,
            "is_region": null,
            "is_state": false,
            "lat": 35.0264,
            "long": -99.0908,
            "name": "Hobart, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Holdenville",
            "id": 1446,
            "is_region": null,
            "is_state": false,
            "lat": 35.0842,
            "long": -96.4003,
            "name": "Holdenville, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Hugo",
            "id": 1447,
            "is_region": null,
            "is_state": false,
            "lat": 34.0094,
            "long": -95.5147,
            "name": "Hugo, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Lawton",
            "id": 1448,
            "is_region": null,
            "is_state": false,
            "lat": 34.6042,
            "long": -98.3956,
            "name": "Lawton, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "McAlester",
            "id": 1449,
            "is_region": null,
            "is_state": false,
            "lat": 34.9331,
            "long": -95.7664,
            "name": "McAlester, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Miami",
            "id": 1450,
            "is_region": null,
            "is_state": false,
            "lat": 36.8836,
            "long": -94.8761,
            "name": "Miami, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Midwest City",
            "id": 1451,
            "is_region": null,
            "is_state": false,
            "lat": 35.4622,
            "long": -97.3842,
            "name": "Midwest City, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Moore",
            "id": 1452,
            "is_region": null,
            "is_state": false,
            "lat": 35.3389,
            "long": -97.4875,
            "name": "Moore, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Muskogee",
            "id": 1453,
            "is_region": null,
            "is_state": false,
            "lat": 35.7466,
            "long": -95.368,
            "name": "Muskogee, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Norman",
            "id": 1454,
            "is_region": null,
            "is_state": false,
            "lat": 35.22,
            "long": -97.44,
            "name": "Norman, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Oklahoma City",
            "id": 1455,
            "is_region": null,
            "is_state": false,
            "lat": 35.4822,
            "long": -97.535,
            "name": "Oklahoma City, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Okmulgee",
            "id": 1456,
            "is_region": null,
            "is_state": false,
            "lat": 35.6244,
            "long": -95.9633,
            "name": "Okmulgee, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Pauls Valley",
            "id": 1457,
            "is_region": null,
            "is_state": false,
            "lat": 34.7414,
            "long": -97.2206,
            "name": "Pauls Valley, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Pawhuska",
            "id": 1458,
            "is_region": null,
            "is_state": false,
            "lat": 36.6692,
            "long": -96.3331,
            "name": "Pawhuska, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Perry",
            "id": 1459,
            "is_region": null,
            "is_state": false,
            "lat": 36.2914,
            "long": -97.2911,
            "name": "Perry, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Ponca City",
            "id": 1460,
            "is_region": null,
            "is_state": false,
            "lat": 36.7125,
            "long": -97.0725,
            "name": "Ponca City, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Pryor",
            "id": 1461,
            "is_region": null,
            "is_state": false,
            "lat": 36.3083,
            "long": -95.3169,
            "name": "Pryor, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Sallisaw",
            "id": 1462,
            "is_region": null,
            "is_state": false,
            "lat": 35.4581,
            "long": -94.7944,
            "name": "Sallisaw, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Sand Springs",
            "id": 1463,
            "is_region": null,
            "is_state": false,
            "lat": 36.1397,
            "long": -96.1089,
            "name": "Sand Springs, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Sapulpa",
            "id": 1464,
            "is_region": null,
            "is_state": false,
            "lat": 36.0036,
            "long": -96.1047,
            "name": "Sapulpa, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Seminole",
            "id": 1465,
            "is_region": null,
            "is_state": false,
            "lat": 35.2411,
            "long": -96.6683,
            "name": "Seminole, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Shawnee",
            "id": 1466,
            "is_region": null,
            "is_state": false,
            "lat": 35.3425,
            "long": -96.9339,
            "name": "Shawnee, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Stillwater",
            "id": 1467,
            "is_region": null,
            "is_state": false,
            "lat": 36.116,
            "long": -97.059,
            "name": "Stillwater, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Tahlequah",
            "id": 1468,
            "is_region": null,
            "is_state": false,
            "lat": 35.9128,
            "long": -94.9714,
            "name": "Tahlequah, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "The Village",
            "id": 1469,
            "is_region": null,
            "is_state": false,
            "lat": 35.5686,
            "long": -97.5567,
            "name": "The Village, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Tulsa",
            "id": 1470,
            "is_region": null,
            "is_state": false,
            "lat": 36.1314,
            "long": -95.9372,
            "name": "Tulsa, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Vinita",
            "id": 1471,
            "is_region": null,
            "is_state": false,
            "lat": 36.6411,
            "long": -95.1567,
            "name": "Vinita, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Wewoka",
            "id": 1472,
            "is_region": null,
            "is_state": false,
            "lat": 35.1494,
            "long": -96.4944,
            "name": "Wewoka, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OK",
            "city": "Woodward",
            "id": 1473,
            "is_region": null,
            "is_state": false,
            "lat": 36.4331,
            "long": -99.3978,
            "name": "Woodward, OK",
            "region_id": null,
            "state": "Oklahoma"
        },
        {
            "abbr": "OR",
            "city": "Albany",
            "id": 1474,
            "is_region": null,
            "is_state": false,
            "lat": 44.6303,
            "long": -123.096,
            "name": "Albany, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Ashland",
            "id": 1475,
            "is_region": null,
            "is_state": false,
            "lat": 42.1914,
            "long": -122.701,
            "name": "Ashland, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Astoria",
            "id": 1476,
            "is_region": null,
            "is_state": false,
            "lat": 46.1889,
            "long": -123.821,
            "name": "Astoria, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Baker City",
            "id": 1477,
            "is_region": null,
            "is_state": false,
            "lat": 44.775,
            "long": -117.834,
            "name": "Baker City, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Beaverton",
            "id": 1478,
            "is_region": null,
            "is_state": false,
            "lat": 45.4869,
            "long": -122.804,
            "name": "Beaverton, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Bend",
            "id": 1479,
            "is_region": null,
            "is_state": false,
            "lat": 44.05,
            "long": -121.3,
            "name": "Bend, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Brookings",
            "id": 1480,
            "is_region": null,
            "is_state": false,
            "lat": 42.0575,
            "long": -124.286,
            "name": "Brookings, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Burns",
            "id": 1481,
            "is_region": null,
            "is_state": false,
            "lat": 43.5869,
            "long": -119.06,
            "name": "Burns, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Coos Bay",
            "id": 1482,
            "is_region": null,
            "is_state": false,
            "lat": 43.3764,
            "long": -124.237,
            "name": "Coos Bay, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Corvallis",
            "id": 1483,
            "is_region": null,
            "is_state": false,
            "lat": 44.567,
            "long": -123.283,
            "name": "Corvallis, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Eugene",
            "id": 1484,
            "is_region": null,
            "is_state": false,
            "lat": 44.0519,
            "long": -123.087,
            "name": "Eugene, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Grants Pass",
            "id": 1485,
            "is_region": null,
            "is_state": false,
            "lat": 42.4389,
            "long": -123.328,
            "name": "Grants Pass, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Hillsboro",
            "id": 1486,
            "is_region": null,
            "is_state": false,
            "lat": 45.517,
            "long": -122.983,
            "name": "Hillsboro, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Hood River",
            "id": 1487,
            "is_region": null,
            "is_state": false,
            "lat": 45.7067,
            "long": -121.522,
            "name": "Hood River, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Jacksonville",
            "id": 1488,
            "is_region": null,
            "is_state": false,
            "lat": 42.3144,
            "long": -122.967,
            "name": "Jacksonville, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "John Day",
            "id": 1489,
            "is_region": null,
            "is_state": false,
            "lat": 44.4181,
            "long": -118.955,
            "name": "John Day, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Klamath Falls",
            "id": 1490,
            "is_region": null,
            "is_state": false,
            "lat": 42.225,
            "long": -121.782,
            "name": "Klamath Falls, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "La Grande",
            "id": 1491,
            "is_region": null,
            "is_state": false,
            "lat": 45.3272,
            "long": -118.093,
            "name": "La Grande, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Lake Oswego",
            "id": 1492,
            "is_region": null,
            "is_state": false,
            "lat": 45.4196,
            "long": -122.668,
            "name": "Lake Oswego, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Lakeview",
            "id": 1493,
            "is_region": null,
            "is_state": false,
            "lat": 42.1889,
            "long": -120.346,
            "name": "Lakeview, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "McMinnville",
            "id": 1494,
            "is_region": null,
            "is_state": false,
            "lat": 45.2117,
            "long": -123.197,
            "name": "McMinnville, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Medford",
            "id": 1495,
            "is_region": null,
            "is_state": false,
            "lat": 42.3319,
            "long": -122.862,
            "name": "Medford, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Newberg",
            "id": 1496,
            "is_region": null,
            "is_state": false,
            "lat": 45.305,
            "long": -122.967,
            "name": "Newberg, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Newport",
            "id": 1497,
            "is_region": null,
            "is_state": false,
            "lat": 44.6,
            "long": -124.05,
            "name": "Newport, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Ontario",
            "id": 1498,
            "is_region": null,
            "is_state": false,
            "lat": 44.0269,
            "long": -116.969,
            "name": "Ontario, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Oregon City",
            "id": 1499,
            "is_region": null,
            "is_state": false,
            "lat": 45.3572,
            "long": -122.607,
            "name": "Oregon City, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Pendleton",
            "id": 1500,
            "is_region": null,
            "is_state": false,
            "lat": 45.6697,
            "long": -118.791,
            "name": "Pendleton, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Port Orford",
            "id": 1501,
            "is_region": null,
            "is_state": false,
            "lat": 42.7497,
            "long": -124.498,
            "name": "Port Orford, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Portland",
            "id": 1502,
            "is_region": null,
            "is_state": false,
            "lat": 45.52,
            "long": -122.682,
            "name": "Portland, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Prineville",
            "id": 1503,
            "is_region": null,
            "is_state": false,
            "lat": 44.3039,
            "long": -120.846,
            "name": "Prineville, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Redmond",
            "id": 1504,
            "is_region": null,
            "is_state": false,
            "lat": 44.2689,
            "long": -121.184,
            "name": "Redmond, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Reedsport",
            "id": 1505,
            "is_region": null,
            "is_state": false,
            "lat": 43.6989,
            "long": -124.112,
            "name": "Reedsport, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Roseburg",
            "id": 1506,
            "is_region": null,
            "is_state": false,
            "lat": 43.2181,
            "long": -123.356,
            "name": "Roseburg, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Salem",
            "id": 1507,
            "is_region": null,
            "is_state": false,
            "lat": 44.9308,
            "long": -123.029,
            "name": "Salem, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Seaside",
            "id": 1508,
            "is_region": null,
            "is_state": false,
            "lat": 45.9928,
            "long": -123.922,
            "name": "Seaside, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Springfield",
            "id": 1509,
            "is_region": null,
            "is_state": false,
            "lat": 44.0531,
            "long": -122.991,
            "name": "Springfield, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "The Dalles",
            "id": 1510,
            "is_region": null,
            "is_state": false,
            "lat": 45.6011,
            "long": -121.183,
            "name": "The Dalles, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "OR",
            "city": "Tillamook",
            "id": 1511,
            "is_region": null,
            "is_state": false,
            "lat": 45.4553,
            "long": -123.842,
            "name": "Tillamook, OR",
            "region_id": null,
            "state": "Oregon"
        },
        {
            "abbr": "PA",
            "city": "Abington",
            "id": 1512,
            "is_region": null,
            "is_state": false,
            "lat": 40.1,
            "long": -75.0997,
            "name": "Abington, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Aliquippa",
            "id": 1513,
            "is_region": null,
            "is_state": false,
            "lat": 40.615,
            "long": -80.2631,
            "name": "Aliquippa, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Allentown",
            "id": 1514,
            "is_region": null,
            "is_state": false,
            "lat": 40.6017,
            "long": -75.4772,
            "name": "Allentown, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Altoona",
            "id": 1515,
            "is_region": null,
            "is_state": false,
            "lat": 40.51,
            "long": -78.4,
            "name": "Altoona, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Ambridge",
            "id": 1516,
            "is_region": null,
            "is_state": false,
            "lat": 40.5931,
            "long": -80.2253,
            "name": "Ambridge, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Bedford",
            "id": 1517,
            "is_region": null,
            "is_state": false,
            "lat": 40.0164,
            "long": -78.5042,
            "name": "Bedford, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Bethlehem",
            "id": 1518,
            "is_region": null,
            "is_state": false,
            "lat": 40.6261,
            "long": -75.3756,
            "name": "Bethlehem, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Bloomsburg",
            "id": 1519,
            "is_region": null,
            "is_state": false,
            "lat": 41.004,
            "long": -76.455,
            "name": "Bloomsburg, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Bradford",
            "id": 1520,
            "is_region": null,
            "is_state": false,
            "lat": 41.9592,
            "long": -78.6447,
            "name": "Bradford, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Bristol",
            "id": 1521,
            "is_region": null,
            "is_state": false,
            "lat": 40.1033,
            "long": -74.8514,
            "name": "Bristol, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Carbondale",
            "id": 1522,
            "is_region": null,
            "is_state": false,
            "lat": 41.567,
            "long": -75.5,
            "name": "Carbondale, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Carlisle",
            "id": 1523,
            "is_region": null,
            "is_state": false,
            "lat": 40.2025,
            "long": -77.195,
            "name": "Carlisle, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Chambersburg",
            "id": 1524,
            "is_region": null,
            "is_state": false,
            "lat": 39.9375,
            "long": -77.6611,
            "name": "Chambersburg, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Chester",
            "id": 1525,
            "is_region": null,
            "is_state": false,
            "lat": 39.8472,
            "long": -75.3728,
            "name": "Chester, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Columbia",
            "id": 1526,
            "is_region": null,
            "is_state": false,
            "lat": 40.0331,
            "long": -76.4967,
            "name": "Columbia, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Easton",
            "id": 1527,
            "is_region": null,
            "is_state": false,
            "lat": 40.6883,
            "long": -75.2164,
            "name": "Easton, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Erie",
            "id": 1528,
            "is_region": null,
            "is_state": false,
            "lat": 42.1294,
            "long": -80.085,
            "name": "Erie, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Franklin",
            "id": 1529,
            "is_region": null,
            "is_state": false,
            "lat": 41.3978,
            "long": -79.8314,
            "name": "Franklin, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Germantown",
            "id": 1530,
            "is_region": null,
            "is_state": false,
            "lat": 40.043,
            "long": -75.181,
            "name": "Germantown, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Gettysburg",
            "id": 1531,
            "is_region": null,
            "is_state": false,
            "lat": 39.8283,
            "long": -77.2322,
            "name": "Gettysburg, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Greensburg",
            "id": 1532,
            "is_region": null,
            "is_state": false,
            "lat": 40.2978,
            "long": -79.5422,
            "name": "Greensburg, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Hanover",
            "id": 1533,
            "is_region": null,
            "is_state": false,
            "lat": 39.8072,
            "long": -76.9847,
            "name": "Hanover, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Harmony",
            "id": 1534,
            "is_region": null,
            "is_state": false,
            "lat": 40.8028,
            "long": -80.1278,
            "name": "Harmony, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Harrisburg",
            "id": 1535,
            "is_region": null,
            "is_state": false,
            "lat": 40.2697,
            "long": -76.8756,
            "name": "Harrisburg, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Hazleton",
            "id": 1536,
            "is_region": null,
            "is_state": false,
            "lat": 40.9589,
            "long": -75.9744,
            "name": "Hazleton, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Hershey",
            "id": 1537,
            "is_region": null,
            "is_state": false,
            "lat": 40.2783,
            "long": -76.6511,
            "name": "Hershey, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Homestead",
            "id": 1538,
            "is_region": null,
            "is_state": false,
            "lat": 40.4051,
            "long": -79.9078,
            "name": "Homestead, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Honesdale",
            "id": 1539,
            "is_region": null,
            "is_state": false,
            "lat": 41.5742,
            "long": -75.2558,
            "name": "Honesdale, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Indiana",
            "id": 1540,
            "is_region": null,
            "is_state": false,
            "lat": 40.617,
            "long": -79.15,
            "name": "Indiana, PA",
            "region_id": 2539,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Jeannette",
            "id": 1541,
            "is_region": null,
            "is_state": false,
            "lat": 40.3289,
            "long": -79.6139,
            "name": "Jeannette, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Jim Thorpe",
            "id": 1542,
            "is_region": null,
            "is_state": false,
            "lat": 40.8731,
            "long": -75.7364,
            "name": "Jim Thorpe, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Johnstown",
            "id": 1543,
            "is_region": null,
            "is_state": false,
            "lat": 40.3228,
            "long": -78.9208,
            "name": "Johnstown, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Lancaster",
            "id": 1544,
            "is_region": null,
            "is_state": false,
            "lat": 40.0397,
            "long": -76.3044,
            "name": "Lancaster, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Lebanon",
            "id": 1545,
            "is_region": null,
            "is_state": false,
            "lat": 40.3417,
            "long": -76.4208,
            "name": "Lebanon, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Levittown",
            "id": 1546,
            "is_region": null,
            "is_state": false,
            "lat": 40.1542,
            "long": -74.8497,
            "name": "Levittown, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Lewistown",
            "id": 1547,
            "is_region": null,
            "is_state": false,
            "lat": 40.5975,
            "long": -77.5733,
            "name": "Lewistown, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Lock Haven",
            "id": 1548,
            "is_region": null,
            "is_state": false,
            "lat": 41.1378,
            "long": -77.4508,
            "name": "Lock Haven, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Lower Southampton",
            "id": 1549,
            "is_region": null,
            "is_state": false,
            "lat": 40.1539,
            "long": -74.9847,
            "name": "Lower Southampton, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "McKeesport",
            "id": 1550,
            "is_region": null,
            "is_state": false,
            "lat": 40.3439,
            "long": -79.8489,
            "name": "McKeesport, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Meadville",
            "id": 1551,
            "is_region": null,
            "is_state": false,
            "lat": 41.65,
            "long": -80.15,
            "name": "Meadville, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Middletown",
            "id": 1552,
            "is_region": null,
            "is_state": false,
            "lat": 40.1986,
            "long": -76.7294,
            "name": "Middletown, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Monroeville",
            "id": 1553,
            "is_region": null,
            "is_state": false,
            "lat": 40.4311,
            "long": -79.7653,
            "name": "Monroeville, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Nanticoke",
            "id": 1554,
            "is_region": null,
            "is_state": false,
            "lat": 41.1994,
            "long": -75.9992,
            "name": "Nanticoke, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "New Castle",
            "id": 1555,
            "is_region": null,
            "is_state": false,
            "lat": 40.9972,
            "long": -80.3444,
            "name": "New Castle, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "New Hope",
            "id": 1556,
            "is_region": null,
            "is_state": false,
            "lat": 40.3642,
            "long": -74.9514,
            "name": "New Hope, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "New Kensington",
            "id": 1557,
            "is_region": null,
            "is_state": false,
            "lat": 40.5683,
            "long": -79.7583,
            "name": "New Kensington, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Norristown",
            "id": 1558,
            "is_region": null,
            "is_state": false,
            "lat": 40.12,
            "long": -75.3417,
            "name": "Norristown, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Oil City",
            "id": 1559,
            "is_region": null,
            "is_state": false,
            "lat": 41.4283,
            "long": -79.7072,
            "name": "Oil City, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Philadelphia",
            "id": 1560,
            "is_region": null,
            "is_state": false,
            "lat": 40.0094,
            "long": -75.1333,
            "name": "Philadelphia, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Phoenixville",
            "id": 1561,
            "is_region": null,
            "is_state": false,
            "lat": 40.1308,
            "long": -75.5192,
            "name": "Phoenixville, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Pittsburgh",
            "id": 1562,
            "is_region": null,
            "is_state": false,
            "lat": 40.4397,
            "long": -79.9764,
            "name": "Pittsburgh, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Pottstown",
            "id": 1563,
            "is_region": null,
            "is_state": false,
            "lat": 40.2497,
            "long": -75.6403,
            "name": "Pottstown, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Pottsville",
            "id": 1564,
            "is_region": null,
            "is_state": false,
            "lat": 40.685,
            "long": -76.2028,
            "name": "Pottsville, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Reading",
            "id": 1565,
            "is_region": null,
            "is_state": false,
            "lat": 40.3417,
            "long": -75.9264,
            "name": "Reading, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Scranton",
            "id": 1566,
            "is_region": null,
            "is_state": false,
            "lat": 41.4106,
            "long": -75.6675,
            "name": "Scranton, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Shamokin",
            "id": 1567,
            "is_region": null,
            "is_state": false,
            "lat": 40.7892,
            "long": -76.5547,
            "name": "Shamokin, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Sharon",
            "id": 1568,
            "is_region": null,
            "is_state": false,
            "lat": 41.23,
            "long": -80.4989,
            "name": "Sharon, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "State College",
            "id": 1569,
            "is_region": null,
            "is_state": false,
            "lat": 40.7914,
            "long": -77.8586,
            "name": "State College, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Stroudsburg",
            "id": 1570,
            "is_region": null,
            "is_state": false,
            "lat": 40.9858,
            "long": -75.1953,
            "name": "Stroudsburg, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Sunbury",
            "id": 1571,
            "is_region": null,
            "is_state": false,
            "lat": 40.8639,
            "long": -76.7892,
            "name": "Sunbury, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Swarthmore",
            "id": 1572,
            "is_region": null,
            "is_state": false,
            "lat": 39.9017,
            "long": -75.3469,
            "name": "Swarthmore, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Tamaqua",
            "id": 1573,
            "is_region": null,
            "is_state": false,
            "lat": 40.7986,
            "long": -75.9664,
            "name": "Tamaqua, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Titusville",
            "id": 1574,
            "is_region": null,
            "is_state": false,
            "lat": 41.633,
            "long": -79.667,
            "name": "Titusville, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Uniontown",
            "id": 1575,
            "is_region": null,
            "is_state": false,
            "lat": 39.9,
            "long": -79.7244,
            "name": "Uniontown, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Warren",
            "id": 1576,
            "is_region": null,
            "is_state": false,
            "lat": 41.8442,
            "long": -79.1425,
            "name": "Warren, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Washington",
            "id": 1577,
            "is_region": null,
            "is_state": false,
            "lat": 40.175,
            "long": -80.2506,
            "name": "Washington, PA",
            "region_id": 2535,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "West Chester",
            "id": 1578,
            "is_region": null,
            "is_state": false,
            "lat": 39.9586,
            "long": -75.605,
            "name": "West Chester, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Wilkes-Barre",
            "id": 1579,
            "is_region": null,
            "is_state": false,
            "lat": 41.2444,
            "long": -75.8781,
            "name": "Wilkes-Barre, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "Williamsport",
            "id": 1580,
            "is_region": null,
            "is_state": false,
            "lat": 41.2444,
            "long": -77.0186,
            "name": "Williamsport, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "PA",
            "city": "York",
            "id": 1581,
            "is_region": null,
            "is_state": false,
            "lat": 39.9628,
            "long": -76.7281,
            "name": "York, PA",
            "region_id": null,
            "state": "Pennsylvania"
        },
        {
            "abbr": "RI",
            "city": "Barrington",
            "id": 1582,
            "is_region": null,
            "is_state": false,
            "lat": 41.7453,
            "long": -71.3181,
            "name": "Barrington, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Bristol",
            "id": 1583,
            "is_region": null,
            "is_state": false,
            "lat": 41.6842,
            "long": -71.2686,
            "name": "Bristol, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Central Falls",
            "id": 1584,
            "is_region": null,
            "is_state": false,
            "lat": 41.8917,
            "long": -71.3911,
            "name": "Central Falls, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Cranston",
            "id": 1585,
            "is_region": null,
            "is_state": false,
            "lat": 41.767,
            "long": -71.45,
            "name": "Cranston, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "East Greenwich",
            "id": 1586,
            "is_region": null,
            "is_state": false,
            "lat": 41.65,
            "long": -71.483,
            "name": "East Greenwich, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "East Providence",
            "id": 1587,
            "is_region": null,
            "is_state": false,
            "lat": 41.8136,
            "long": -71.37,
            "name": "East Providence, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Kingston",
            "id": 1588,
            "is_region": null,
            "is_state": false,
            "lat": 41.483,
            "long": -71.533,
            "name": "Kingston, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Middletown",
            "id": 1589,
            "is_region": null,
            "is_state": false,
            "lat": 41.5117,
            "long": -71.2867,
            "name": "Middletown, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Narragansett",
            "id": 1590,
            "is_region": null,
            "is_state": false,
            "lat": 41.4344,
            "long": -71.4625,
            "name": "Narragansett, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Newport",
            "id": 1591,
            "is_region": null,
            "is_state": false,
            "lat": 41.4881,
            "long": -71.3125,
            "name": "Newport, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "North Kingstown",
            "id": 1592,
            "is_region": null,
            "is_state": false,
            "lat": 41.5806,
            "long": -71.4539,
            "name": "North Kingstown, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Pawtucket",
            "id": 1593,
            "is_region": null,
            "is_state": false,
            "lat": 41.8758,
            "long": -71.3769,
            "name": "Pawtucket, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Portsmouth",
            "id": 1594,
            "is_region": null,
            "is_state": false,
            "lat": 41.6,
            "long": -71.25,
            "name": "Portsmouth, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Providence",
            "id": 1595,
            "is_region": null,
            "is_state": false,
            "lat": 41.8236,
            "long": -71.4222,
            "name": "Providence, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "South Kingstown",
            "id": 1596,
            "is_region": null,
            "is_state": false,
            "lat": 41.4475,
            "long": -71.5272,
            "name": "South Kingstown, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Tiverton",
            "id": 1597,
            "is_region": null,
            "is_state": false,
            "lat": 41.6264,
            "long": -71.2111,
            "name": "Tiverton, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Warren",
            "id": 1598,
            "is_region": null,
            "is_state": false,
            "lat": 41.7261,
            "long": -71.2706,
            "name": "Warren, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Warwick",
            "id": 1599,
            "is_region": null,
            "is_state": false,
            "lat": 41.717,
            "long": -71.417,
            "name": "Warwick, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Westerly",
            "id": 1600,
            "is_region": null,
            "is_state": false,
            "lat": 41.3553,
            "long": -71.8019,
            "name": "Westerly, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Wickford",
            "id": 1601,
            "is_region": null,
            "is_state": false,
            "lat": 41.5739,
            "long": -71.4614,
            "name": "Wickford, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "RI",
            "city": "Woonsocket",
            "id": 1602,
            "is_region": null,
            "is_state": false,
            "lat": 42.0083,
            "long": -71.5161,
            "name": "Woonsocket, RI",
            "region_id": null,
            "state": "Rhode Island"
        },
        {
            "abbr": "SC",
            "city": "Abbeville",
            "id": 1603,
            "is_region": null,
            "is_state": false,
            "lat": 34.1785,
            "long": -82.3777,
            "name": "Abbeville, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Aiken",
            "id": 1604,
            "is_region": null,
            "is_state": false,
            "lat": 33.5494,
            "long": -81.7206,
            "name": "Aiken, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Anderson",
            "id": 1605,
            "is_region": null,
            "is_state": false,
            "lat": 34.5144,
            "long": -82.6489,
            "name": "Anderson, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Beaufort",
            "id": 1606,
            "is_region": null,
            "is_state": false,
            "lat": 32.433,
            "long": -80.683,
            "name": "Beaufort, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Camden",
            "id": 1607,
            "is_region": null,
            "is_state": false,
            "lat": 34.2592,
            "long": -80.6092,
            "name": "Camden, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Charleston",
            "id": 1608,
            "is_region": null,
            "is_state": false,
            "lat": 32.7833,
            "long": -79.9333,
            "name": "Charleston, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Columbia",
            "id": 1609,
            "is_region": null,
            "is_state": false,
            "lat": 34.0006,
            "long": -81.0347,
            "name": "Columbia, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Darlington",
            "id": 1610,
            "is_region": null,
            "is_state": false,
            "lat": 34.3014,
            "long": -79.8686,
            "name": "Darlington, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Florence",
            "id": 1611,
            "is_region": null,
            "is_state": false,
            "lat": 34.1839,
            "long": -79.7742,
            "name": "Florence, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Gaffney",
            "id": 1612,
            "is_region": null,
            "is_state": false,
            "lat": 35.0719,
            "long": -81.6531,
            "name": "Gaffney, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Georgetown",
            "id": 1613,
            "is_region": null,
            "is_state": false,
            "lat": 33.3675,
            "long": -79.2939,
            "name": "Georgetown, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Greenville",
            "id": 1614,
            "is_region": null,
            "is_state": false,
            "lat": 34.8444,
            "long": -82.3856,
            "name": "Greenville, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Greenwood",
            "id": 1615,
            "is_region": null,
            "is_state": false,
            "lat": 34.1953,
            "long": -82.1617,
            "name": "Greenwood, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Hartsville",
            "id": 1616,
            "is_region": null,
            "is_state": false,
            "lat": 34.3694,
            "long": -80.0808,
            "name": "Hartsville, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Lancaster",
            "id": 1617,
            "is_region": null,
            "is_state": false,
            "lat": 34.7211,
            "long": -80.7733,
            "name": "Lancaster, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Mount Pleasant",
            "id": 1618,
            "is_region": null,
            "is_state": false,
            "lat": 32.7869,
            "long": -79.8764,
            "name": "Mount Pleasant, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Myrtle Beach",
            "id": 1619,
            "is_region": null,
            "is_state": false,
            "lat": 33.7441,
            "long": -78.8695,
            "name": "Myrtle Beach, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Orangeburg",
            "id": 1620,
            "is_region": null,
            "is_state": false,
            "lat": 33.4969,
            "long": -80.8622,
            "name": "Orangeburg, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Rock Hill",
            "id": 1621,
            "is_region": null,
            "is_state": false,
            "lat": 34.9381,
            "long": -81.0261,
            "name": "Rock Hill, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Spartanburg",
            "id": 1622,
            "is_region": null,
            "is_state": false,
            "lat": 34.9467,
            "long": -81.9275,
            "name": "Spartanburg, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Sumter",
            "id": 1623,
            "is_region": null,
            "is_state": false,
            "lat": 33.9269,
            "long": -80.3636,
            "name": "Sumter, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SC",
            "city": "Union",
            "id": 1624,
            "is_region": null,
            "is_state": false,
            "lat": 34.7172,
            "long": -81.625,
            "name": "Union, SC",
            "region_id": null,
            "state": "South Carolina"
        },
        {
            "abbr": "SD",
            "city": "Aberdeen",
            "id": 1625,
            "is_region": null,
            "is_state": false,
            "lat": 45.4647,
            "long": -98.4864,
            "name": "Aberdeen, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Belle Fourche",
            "id": 1626,
            "is_region": null,
            "is_state": false,
            "lat": 44.6675,
            "long": -103.85,
            "name": "Belle Fourche, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Brookings",
            "id": 1627,
            "is_region": null,
            "is_state": false,
            "lat": 44.3064,
            "long": -96.7881,
            "name": "Brookings, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Canton",
            "id": 1628,
            "is_region": null,
            "is_state": false,
            "lat": 43.3022,
            "long": -96.5908,
            "name": "Canton, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Custer",
            "id": 1629,
            "is_region": null,
            "is_state": false,
            "lat": 43.7683,
            "long": -103.598,
            "name": "Custer, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "De Smet",
            "id": 1630,
            "is_region": null,
            "is_state": false,
            "lat": 44.3858,
            "long": -97.5517,
            "name": "De Smet, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Deadwood",
            "id": 1631,
            "is_region": null,
            "is_state": false,
            "lat": 44.3767,
            "long": -103.729,
            "name": "Deadwood, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Hot Springs",
            "id": 1632,
            "is_region": null,
            "is_state": false,
            "lat": 43.4317,
            "long": -103.474,
            "name": "Hot Springs, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Huron",
            "id": 1633,
            "is_region": null,
            "is_state": false,
            "lat": 44.3592,
            "long": -98.2181,
            "name": "Huron, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Lead",
            "id": 1634,
            "is_region": null,
            "is_state": false,
            "lat": 44.3508,
            "long": -103.766,
            "name": "Lead, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Madison",
            "id": 1635,
            "is_region": null,
            "is_state": false,
            "lat": 44.0078,
            "long": -97.1147,
            "name": "Madison, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Milbank",
            "id": 1636,
            "is_region": null,
            "is_state": false,
            "lat": 45.2186,
            "long": -96.6336,
            "name": "Milbank, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Mitchell",
            "id": 1637,
            "is_region": null,
            "is_state": false,
            "lat": 43.7139,
            "long": -98.0264,
            "name": "Mitchell, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Mobridge",
            "id": 1638,
            "is_region": null,
            "is_state": false,
            "lat": 45.5397,
            "long": -100.435,
            "name": "Mobridge, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Pierre",
            "id": 1639,
            "is_region": null,
            "is_state": false,
            "lat": 44.3681,
            "long": -100.336,
            "name": "Pierre, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Rapid City",
            "id": 1640,
            "is_region": null,
            "is_state": false,
            "lat": 44.076,
            "long": -103.228,
            "name": "Rapid City, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Sioux Falls",
            "id": 1641,
            "is_region": null,
            "is_state": false,
            "lat": 43.5364,
            "long": -96.7317,
            "name": "Sioux Falls, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Spearfish",
            "id": 1642,
            "is_region": null,
            "is_state": false,
            "lat": 44.4897,
            "long": -103.853,
            "name": "Spearfish, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Sturgis",
            "id": 1643,
            "is_region": null,
            "is_state": false,
            "lat": 44.4103,
            "long": -103.519,
            "name": "Sturgis, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Vermillion",
            "id": 1644,
            "is_region": null,
            "is_state": false,
            "lat": 42.7811,
            "long": -96.9269,
            "name": "Vermillion, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Watertown",
            "id": 1645,
            "is_region": null,
            "is_state": false,
            "lat": 44.9033,
            "long": -97.1206,
            "name": "Watertown, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "SD",
            "city": "Yankton",
            "id": 1646,
            "is_region": null,
            "is_state": false,
            "lat": 42.8817,
            "long": -97.3925,
            "name": "Yankton, SD",
            "region_id": null,
            "state": "South Dakota"
        },
        {
            "abbr": "TN",
            "city": "Alcoa",
            "id": 1647,
            "is_region": null,
            "is_state": false,
            "lat": 35.8039,
            "long": -83.9775,
            "name": "Alcoa, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Athens",
            "id": 1648,
            "is_region": null,
            "is_state": false,
            "lat": 35.4481,
            "long": -84.6019,
            "name": "Athens, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Chattanooga",
            "id": 1649,
            "is_region": null,
            "is_state": false,
            "lat": 35.0456,
            "long": -85.2672,
            "name": "Chattanooga, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Clarksville",
            "id": 1650,
            "is_region": null,
            "is_state": false,
            "lat": 36.5297,
            "long": -87.3594,
            "name": "Clarksville, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Cleveland",
            "id": 1651,
            "is_region": null,
            "is_state": false,
            "lat": 35.1714,
            "long": -84.8711,
            "name": "Cleveland, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Columbia",
            "id": 1652,
            "is_region": null,
            "is_state": false,
            "lat": 35.615,
            "long": -87.0444,
            "name": "Columbia, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Cookeville",
            "id": 1653,
            "is_region": null,
            "is_state": false,
            "lat": 36.1642,
            "long": -85.5042,
            "name": "Cookeville, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Dayton",
            "id": 1654,
            "is_region": null,
            "is_state": false,
            "lat": 35.5,
            "long": -85.017,
            "name": "Dayton, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Elizabethton",
            "id": 1655,
            "is_region": null,
            "is_state": false,
            "lat": 36.3364,
            "long": -82.2392,
            "name": "Elizabethton, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Franklin",
            "id": 1656,
            "is_region": null,
            "is_state": false,
            "lat": 35.9292,
            "long": -86.8575,
            "name": "Franklin, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Gallatin",
            "id": 1657,
            "is_region": null,
            "is_state": false,
            "lat": 36.3814,
            "long": -86.4514,
            "name": "Gallatin, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Gatlinburg",
            "id": 1658,
            "is_region": null,
            "is_state": false,
            "lat": 35.7142,
            "long": -83.5103,
            "name": "Gatlinburg, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Greeneville",
            "id": 1659,
            "is_region": null,
            "is_state": false,
            "lat": 36.1683,
            "long": -82.8225,
            "name": "Greeneville, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Jackson",
            "id": 1660,
            "is_region": null,
            "is_state": false,
            "lat": 35.6144,
            "long": -88.8139,
            "name": "Jackson, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Johnson City",
            "id": 1661,
            "is_region": null,
            "is_state": false,
            "lat": 36.333,
            "long": -82.367,
            "name": "Johnson City, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Jonesborough",
            "id": 1662,
            "is_region": null,
            "is_state": false,
            "lat": 36.2942,
            "long": -82.4725,
            "name": "Jonesborough, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Kingsport",
            "id": 1663,
            "is_region": null,
            "is_state": false,
            "lat": 36.533,
            "long": -82.55,
            "name": "Kingsport, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Knoxville",
            "id": 1664,
            "is_region": null,
            "is_state": false,
            "lat": 35.9728,
            "long": -83.9422,
            "name": "Knoxville, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Lebanon",
            "id": 1665,
            "is_region": null,
            "is_state": false,
            "lat": 36.2081,
            "long": -86.3264,
            "name": "Lebanon, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Maryville",
            "id": 1666,
            "is_region": null,
            "is_state": false,
            "lat": 35.7497,
            "long": -83.9758,
            "name": "Maryville, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Memphis",
            "id": 1667,
            "is_region": null,
            "is_state": false,
            "lat": 35.1175,
            "long": -89.9711,
            "name": "Memphis, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Morristown",
            "id": 1668,
            "is_region": null,
            "is_state": false,
            "lat": 36.2106,
            "long": -83.2961,
            "name": "Morristown, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Murfreesboro",
            "id": 1669,
            "is_region": null,
            "is_state": false,
            "lat": 35.8461,
            "long": -86.3919,
            "name": "Murfreesboro, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Nashville",
            "id": 1670,
            "is_region": null,
            "is_state": false,
            "lat": 36.1667,
            "long": -86.7833,
            "name": "Nashville, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Norris",
            "id": 1671,
            "is_region": null,
            "is_state": false,
            "lat": 36.1994,
            "long": -84.0692,
            "name": "Norris, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Oak Ridge",
            "id": 1672,
            "is_region": null,
            "is_state": false,
            "lat": 36.0103,
            "long": -84.2697,
            "name": "Oak Ridge, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Shelbyville",
            "id": 1673,
            "is_region": null,
            "is_state": false,
            "lat": 35.4889,
            "long": -86.4522,
            "name": "Shelbyville, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TN",
            "city": "Tullahoma",
            "id": 1674,
            "is_region": null,
            "is_state": false,
            "lat": 35.3686,
            "long": -86.2133,
            "name": "Tullahoma, TN",
            "region_id": null,
            "state": "Tennessee"
        },
        {
            "abbr": "TX",
            "city": "Abilene",
            "id": 1675,
            "is_region": null,
            "is_state": false,
            "lat": 32.45,
            "long": -99.75,
            "name": "Abilene, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Alpine",
            "id": 1676,
            "is_region": null,
            "is_state": false,
            "lat": 30.3608,
            "long": -103.666,
            "name": "Alpine, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Amarillo",
            "id": 1677,
            "is_region": null,
            "is_state": false,
            "lat": 35.1992,
            "long": -101.845,
            "name": "Amarillo, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Arlington",
            "id": 1678,
            "is_region": null,
            "is_state": false,
            "lat": 32.705,
            "long": -97.1228,
            "name": "Arlington, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Austin",
            "id": 1679,
            "is_region": null,
            "is_state": false,
            "lat": 30.267,
            "long": -97.733,
            "name": "Austin, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Baytown",
            "id": 1680,
            "is_region": null,
            "is_state": false,
            "lat": 29.7439,
            "long": -94.9658,
            "name": "Baytown, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Beaumont",
            "id": 1681,
            "is_region": null,
            "is_state": false,
            "lat": 30.08,
            "long": -94.1267,
            "name": "Beaumont, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Big Spring",
            "id": 1682,
            "is_region": null,
            "is_state": false,
            "lat": 32.2433,
            "long": -101.475,
            "name": "Big Spring, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Borger",
            "id": 1683,
            "is_region": null,
            "is_state": false,
            "lat": 35.6628,
            "long": -101.402,
            "name": "Borger, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Brownsville",
            "id": 1684,
            "is_region": null,
            "is_state": false,
            "lat": 25.9303,
            "long": -97.4844,
            "name": "Brownsville, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Bryan",
            "id": 1685,
            "is_region": null,
            "is_state": false,
            "lat": 30.6656,
            "long": -96.3667,
            "name": "Bryan, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Canyon",
            "id": 1686,
            "is_region": null,
            "is_state": false,
            "lat": 34.9794,
            "long": -101.926,
            "name": "Canyon, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Cleburne",
            "id": 1687,
            "is_region": null,
            "is_state": false,
            "lat": 32.3517,
            "long": -97.3925,
            "name": "Cleburne, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "College Station",
            "id": 1688,
            "is_region": null,
            "is_state": false,
            "lat": 30.6014,
            "long": -96.3144,
            "name": "College Station, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Corpus Christi",
            "id": 1689,
            "is_region": null,
            "is_state": false,
            "lat": 27.7428,
            "long": -97.4019,
            "name": "Corpus Christi, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Crystal City",
            "id": 1690,
            "is_region": null,
            "is_state": false,
            "lat": 28.6844,
            "long": -99.8278,
            "name": "Crystal City, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Dallas",
            "id": 1691,
            "is_region": null,
            "is_state": false,
            "lat": 32.783,
            "long": -96.8,
            "name": "Dallas, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Del Rio",
            "id": 1692,
            "is_region": null,
            "is_state": false,
            "lat": 29.364,
            "long": -100.9,
            "name": "Del Rio, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Denison",
            "id": 1693,
            "is_region": null,
            "is_state": false,
            "lat": 33.7497,
            "long": -96.5575,
            "name": "Denison, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Denton",
            "id": 1694,
            "is_region": null,
            "is_state": false,
            "lat": 33.2164,
            "long": -97.1292,
            "name": "Denton, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Eagle Pass",
            "id": 1695,
            "is_region": null,
            "is_state": false,
            "lat": 28.7106,
            "long": -100.489,
            "name": "Eagle Pass, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Edinburg",
            "id": 1696,
            "is_region": null,
            "is_state": false,
            "lat": 26.3042,
            "long": -98.1639,
            "name": "Edinburg, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "El Paso",
            "id": 1697,
            "is_region": null,
            "is_state": false,
            "lat": 31.7592,
            "long": -106.49,
            "name": "El Paso, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Fort Worth",
            "id": 1698,
            "is_region": null,
            "is_state": false,
            "lat": 32.75,
            "long": -97.333,
            "name": "Fort Worth, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Freeport",
            "id": 1699,
            "is_region": null,
            "is_state": false,
            "lat": 28.9594,
            "long": -95.3569,
            "name": "Freeport, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Galveston",
            "id": 1700,
            "is_region": null,
            "is_state": false,
            "lat": 29.2811,
            "long": -94.8258,
            "name": "Galveston, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Garland",
            "id": 1701,
            "is_region": null,
            "is_state": false,
            "lat": 32.9072,
            "long": -96.6353,
            "name": "Garland, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Goliad",
            "id": 1702,
            "is_region": null,
            "is_state": false,
            "lat": 28.667,
            "long": -97.4,
            "name": "Goliad, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Greenville",
            "id": 1703,
            "is_region": null,
            "is_state": false,
            "lat": 33.1261,
            "long": -96.1097,
            "name": "Greenville, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Harlingen",
            "id": 1704,
            "is_region": null,
            "is_state": false,
            "lat": 26.2,
            "long": -97.7,
            "name": "Harlingen, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Houston",
            "id": 1705,
            "is_region": null,
            "is_state": false,
            "lat": 29.7628,
            "long": -95.3831,
            "name": "Houston, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Huntsville",
            "id": 1706,
            "is_region": null,
            "is_state": false,
            "lat": 30.7222,
            "long": -95.5533,
            "name": "Huntsville, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Irving",
            "id": 1707,
            "is_region": null,
            "is_state": false,
            "lat": 32.817,
            "long": -96.95,
            "name": "Irving, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Johnson City",
            "id": 1708,
            "is_region": null,
            "is_state": false,
            "lat": 30.2764,
            "long": -98.4081,
            "name": "Johnson City, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Kilgore",
            "id": 1709,
            "is_region": null,
            "is_state": false,
            "lat": 32.3856,
            "long": -94.8686,
            "name": "Kilgore, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Killeen",
            "id": 1710,
            "is_region": null,
            "is_state": false,
            "lat": 31.1056,
            "long": -97.7267,
            "name": "Killeen, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Kingsville",
            "id": 1711,
            "is_region": null,
            "is_state": false,
            "lat": 27.515,
            "long": -97.8656,
            "name": "Kingsville, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Laredo",
            "id": 1712,
            "is_region": null,
            "is_state": false,
            "lat": 27.5244,
            "long": -99.4906,
            "name": "Laredo, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Longview",
            "id": 1713,
            "is_region": null,
            "is_state": false,
            "lat": 32.5092,
            "long": -94.7539,
            "name": "Longview, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Lubbock",
            "id": 1714,
            "is_region": null,
            "is_state": false,
            "lat": 33.5778,
            "long": -101.89,
            "name": "Lubbock, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Lufkin",
            "id": 1715,
            "is_region": null,
            "is_state": false,
            "lat": 31.3383,
            "long": -94.7292,
            "name": "Lufkin, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Marshall",
            "id": 1716,
            "is_region": null,
            "is_state": false,
            "lat": 32.55,
            "long": -94.367,
            "name": "Marshall, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "McAllen",
            "id": 1717,
            "is_region": null,
            "is_state": false,
            "lat": 26.2164,
            "long": -98.2364,
            "name": "McAllen, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "McKinney",
            "id": 1718,
            "is_region": null,
            "is_state": false,
            "lat": 33.1972,
            "long": -96.6397,
            "name": "McKinney, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Mesquite",
            "id": 1719,
            "is_region": null,
            "is_state": false,
            "lat": 32.7828,
            "long": -96.61,
            "name": "Mesquite, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Midland",
            "id": 1720,
            "is_region": null,
            "is_state": false,
            "lat": 32.0,
            "long": -102.1,
            "name": "Midland, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Mission",
            "id": 1721,
            "is_region": null,
            "is_state": false,
            "lat": 26.2114,
            "long": -98.3214,
            "name": "Mission, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Nacogdoches",
            "id": 1722,
            "is_region": null,
            "is_state": false,
            "lat": 31.6089,
            "long": -94.6508,
            "name": "Nacogdoches, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "New Braunfels",
            "id": 1723,
            "is_region": null,
            "is_state": false,
            "lat": 29.7,
            "long": -98.117,
            "name": "New Braunfels, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Odessa",
            "id": 1724,
            "is_region": null,
            "is_state": false,
            "lat": 31.8633,
            "long": -102.366,
            "name": "Odessa, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Orange",
            "id": 1725,
            "is_region": null,
            "is_state": false,
            "lat": 30.1092,
            "long": -93.7592,
            "name": "Orange, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Pampa",
            "id": 1726,
            "is_region": null,
            "is_state": false,
            "lat": 35.5431,
            "long": -100.965,
            "name": "Pampa, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Paris",
            "id": 1727,
            "is_region": null,
            "is_state": false,
            "lat": 33.6625,
            "long": -95.5478,
            "name": "Paris, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Pasadena",
            "id": 1728,
            "is_region": null,
            "is_state": false,
            "lat": 29.6761,
            "long": -95.1739,
            "name": "Pasadena, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Pecos",
            "id": 1729,
            "is_region": null,
            "is_state": false,
            "lat": 31.4156,
            "long": -103.5,
            "name": "Pecos, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Pharr",
            "id": 1730,
            "is_region": null,
            "is_state": false,
            "lat": 26.2064,
            "long": -98.1853,
            "name": "Pharr, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Plainview",
            "id": 1731,
            "is_region": null,
            "is_state": false,
            "lat": 34.1911,
            "long": -101.719,
            "name": "Plainview, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Plano",
            "id": 1732,
            "is_region": null,
            "is_state": false,
            "lat": 33.017,
            "long": -96.683,
            "name": "Plano, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Port Arthur",
            "id": 1733,
            "is_region": null,
            "is_state": false,
            "lat": 29.885,
            "long": -93.94,
            "name": "Port Arthur, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Port Lavaca",
            "id": 1734,
            "is_region": null,
            "is_state": false,
            "lat": 28.6156,
            "long": -96.6297,
            "name": "Port Lavaca, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Richardson",
            "id": 1735,
            "is_region": null,
            "is_state": false,
            "lat": 32.9656,
            "long": -96.7158,
            "name": "Richardson, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "San Angelo",
            "id": 1736,
            "is_region": null,
            "is_state": false,
            "lat": 31.4428,
            "long": -100.45,
            "name": "San Angelo, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "San Antonio",
            "id": 1737,
            "is_region": null,
            "is_state": false,
            "lat": 29.417,
            "long": -98.5,
            "name": "San Antonio, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "San Felipe",
            "id": 1738,
            "is_region": null,
            "is_state": false,
            "lat": 29.7944,
            "long": -96.1047,
            "name": "San Felipe, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "San Marcos",
            "id": 1739,
            "is_region": null,
            "is_state": false,
            "lat": 29.8794,
            "long": -97.9389,
            "name": "San Marcos, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Sherman",
            "id": 1740,
            "is_region": null,
            "is_state": false,
            "lat": 33.6411,
            "long": -96.61,
            "name": "Sherman, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Sweetwater",
            "id": 1741,
            "is_region": null,
            "is_state": false,
            "lat": 32.4681,
            "long": -100.407,
            "name": "Sweetwater, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Temple",
            "id": 1742,
            "is_region": null,
            "is_state": false,
            "lat": 31.1083,
            "long": -97.3892,
            "name": "Temple, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Texarkana",
            "id": 1743,
            "is_region": null,
            "is_state": false,
            "lat": 33.4372,
            "long": -94.0675,
            "name": "Texarkana, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Texas City",
            "id": 1744,
            "is_region": null,
            "is_state": false,
            "lat": 29.4,
            "long": -94.9339,
            "name": "Texas City, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Tyler",
            "id": 1745,
            "is_region": null,
            "is_state": false,
            "lat": 32.35,
            "long": -95.3,
            "name": "Tyler, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Uvalde",
            "id": 1746,
            "is_region": null,
            "is_state": false,
            "lat": 29.2144,
            "long": -99.7897,
            "name": "Uvalde, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Victoria",
            "id": 1747,
            "is_region": null,
            "is_state": false,
            "lat": 28.8169,
            "long": -96.9933,
            "name": "Victoria, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Waco",
            "id": 1748,
            "is_region": null,
            "is_state": false,
            "lat": 31.5514,
            "long": -97.1558,
            "name": "Waco, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Weatherford",
            "id": 1749,
            "is_region": null,
            "is_state": false,
            "lat": 32.7592,
            "long": -97.785,
            "name": "Weatherford, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Wichita Falls",
            "id": 1750,
            "is_region": null,
            "is_state": false,
            "lat": 33.8969,
            "long": -98.515,
            "name": "Wichita Falls, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "TX",
            "city": "Ysleta",
            "id": 1751,
            "is_region": null,
            "is_state": false,
            "lat": 31.5847,
            "long": -106.273,
            "name": "Ysleta, TX",
            "region_id": null,
            "state": "Texas"
        },
        {
            "abbr": "UT",
            "city": "Alta",
            "id": 1752,
            "is_region": null,
            "is_state": false,
            "lat": 40.5808,
            "long": -111.637,
            "name": "Alta, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "American Fork",
            "id": 1753,
            "is_region": null,
            "is_state": false,
            "lat": 40.3842,
            "long": -111.792,
            "name": "American Fork, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Bountiful",
            "id": 1754,
            "is_region": null,
            "is_state": false,
            "lat": 40.8797,
            "long": -111.872,
            "name": "Bountiful, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Brigham City",
            "id": 1755,
            "is_region": null,
            "is_state": false,
            "lat": 41.5103,
            "long": -112.015,
            "name": "Brigham City, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Cedar City",
            "id": 1756,
            "is_region": null,
            "is_state": false,
            "lat": 37.6775,
            "long": -113.062,
            "name": "Cedar City, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Clearfield",
            "id": 1757,
            "is_region": null,
            "is_state": false,
            "lat": 41.1064,
            "long": -112.024,
            "name": "Clearfield, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Delta",
            "id": 1758,
            "is_region": null,
            "is_state": false,
            "lat": 39.3531,
            "long": -112.574,
            "name": "Delta, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Fillmore",
            "id": 1759,
            "is_region": null,
            "is_state": false,
            "lat": 38.9678,
            "long": -112.331,
            "name": "Fillmore, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Green River",
            "id": 1760,
            "is_region": null,
            "is_state": false,
            "lat": 38.9933,
            "long": -110.15,
            "name": "Green River, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Heber City",
            "id": 1761,
            "is_region": null,
            "is_state": false,
            "lat": 40.5067,
            "long": -111.412,
            "name": "Heber City, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Kanab",
            "id": 1762,
            "is_region": null,
            "is_state": false,
            "lat": 37.0356,
            "long": -112.531,
            "name": "Kanab, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Layton",
            "id": 1763,
            "is_region": null,
            "is_state": false,
            "lat": 41.0781,
            "long": -111.955,
            "name": "Layton, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Lehi",
            "id": 1764,
            "is_region": null,
            "is_state": false,
            "lat": 40.3878,
            "long": -111.849,
            "name": "Lehi, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Logan",
            "id": 1765,
            "is_region": null,
            "is_state": false,
            "lat": 41.7378,
            "long": -111.831,
            "name": "Logan, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Manti",
            "id": 1766,
            "is_region": null,
            "is_state": false,
            "lat": 39.2647,
            "long": -111.639,
            "name": "Manti, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Moab",
            "id": 1767,
            "is_region": null,
            "is_state": false,
            "lat": 38.5725,
            "long": -109.55,
            "name": "Moab, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Monticello",
            "id": 1768,
            "is_region": null,
            "is_state": false,
            "lat": 37.8692,
            "long": -109.342,
            "name": "Monticello, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Murray",
            "id": 1769,
            "is_region": null,
            "is_state": false,
            "lat": 40.6525,
            "long": -111.893,
            "name": "Murray, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Nephi",
            "id": 1770,
            "is_region": null,
            "is_state": false,
            "lat": 39.7092,
            "long": -111.831,
            "name": "Nephi, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Ogden",
            "id": 1771,
            "is_region": null,
            "is_state": false,
            "lat": 41.2278,
            "long": -111.961,
            "name": "Ogden, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Orderville",
            "id": 1772,
            "is_region": null,
            "is_state": false,
            "lat": 37.2622,
            "long": -112.653,
            "name": "Orderville, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Orem",
            "id": 1773,
            "is_region": null,
            "is_state": false,
            "lat": 40.2989,
            "long": -111.696,
            "name": "Orem, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Panguitch",
            "id": 1774,
            "is_region": null,
            "is_state": false,
            "lat": 37.8222,
            "long": -112.435,
            "name": "Panguitch, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Park City",
            "id": 1775,
            "is_region": null,
            "is_state": false,
            "lat": 40.6594,
            "long": -111.5,
            "name": "Park City, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Payson",
            "id": 1776,
            "is_region": null,
            "is_state": false,
            "lat": 40.0389,
            "long": -111.733,
            "name": "Payson, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Price",
            "id": 1777,
            "is_region": null,
            "is_state": false,
            "lat": 39.6,
            "long": -110.807,
            "name": "Price, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Provo",
            "id": 1778,
            "is_region": null,
            "is_state": false,
            "lat": 40.2444,
            "long": -111.661,
            "name": "Provo, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Saint George",
            "id": 1779,
            "is_region": null,
            "is_state": false,
            "lat": 37.0953,
            "long": -113.578,
            "name": "Saint George, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Salt Lake City",
            "id": 1780,
            "is_region": null,
            "is_state": false,
            "lat": 40.75,
            "long": -111.883,
            "name": "Salt Lake City, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Spanish Fork",
            "id": 1781,
            "is_region": null,
            "is_state": false,
            "lat": 40.115,
            "long": -111.655,
            "name": "Spanish Fork, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Springville",
            "id": 1782,
            "is_region": null,
            "is_state": false,
            "lat": 40.1628,
            "long": -111.604,
            "name": "Springville, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Tooele",
            "id": 1783,
            "is_region": null,
            "is_state": false,
            "lat": 40.5364,
            "long": -112.298,
            "name": "Tooele, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "UT",
            "city": "Vernal",
            "id": 1784,
            "is_region": null,
            "is_state": false,
            "lat": 40.4547,
            "long": -109.536,
            "name": "Vernal, UT",
            "region_id": null,
            "state": "Utah"
        },
        {
            "abbr": "VT",
            "city": "Barre",
            "id": 1785,
            "is_region": null,
            "is_state": false,
            "lat": 44.1946,
            "long": -72.5065,
            "name": "Barre, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Bellows Falls",
            "id": 1786,
            "is_region": null,
            "is_state": false,
            "lat": 43.133,
            "long": -72.45,
            "name": "Bellows Falls, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Bennington",
            "id": 1787,
            "is_region": null,
            "is_state": false,
            "lat": 42.8911,
            "long": -73.2081,
            "name": "Bennington, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Brattleboro",
            "id": 1788,
            "is_region": null,
            "is_state": false,
            "lat": 42.85,
            "long": -72.5822,
            "name": "Brattleboro, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Burlington",
            "id": 1789,
            "is_region": null,
            "is_state": false,
            "lat": 44.4758,
            "long": -73.2119,
            "name": "Burlington, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Essex",
            "id": 1790,
            "is_region": null,
            "is_state": false,
            "lat": 44.5019,
            "long": -73.0939,
            "name": "Essex, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Manchester",
            "id": 1791,
            "is_region": null,
            "is_state": false,
            "lat": 43.1408,
            "long": -73.08,
            "name": "Manchester, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Middlebury",
            "id": 1792,
            "is_region": null,
            "is_state": false,
            "lat": 44.0019,
            "long": -73.1456,
            "name": "Middlebury, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Montpelier",
            "id": 1793,
            "is_region": null,
            "is_state": false,
            "lat": 44.26,
            "long": -72.5753,
            "name": "Montpelier, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Newport",
            "id": 1794,
            "is_region": null,
            "is_state": false,
            "lat": 44.9442,
            "long": -72.2044,
            "name": "Newport, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Plymouth",
            "id": 1795,
            "is_region": null,
            "is_state": false,
            "lat": 43.5317,
            "long": -72.7217,
            "name": "Plymouth, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Rutland",
            "id": 1796,
            "is_region": null,
            "is_state": false,
            "lat": 43.6089,
            "long": -72.9797,
            "name": "Rutland, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Saint Albans",
            "id": 1797,
            "is_region": null,
            "is_state": false,
            "lat": 44.8103,
            "long": -73.1522,
            "name": "Saint Albans, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Saint Johnsbury",
            "id": 1798,
            "is_region": null,
            "is_state": false,
            "lat": 44.4336,
            "long": -72.015,
            "name": "Saint Johnsbury, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Sharon",
            "id": 1799,
            "is_region": null,
            "is_state": false,
            "lat": 43.7736,
            "long": -72.4439,
            "name": "Sharon, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VT",
            "city": "Winooski",
            "id": 1800,
            "is_region": null,
            "is_state": false,
            "lat": 44.495,
            "long": -73.1825,
            "name": "Winooski, VT",
            "region_id": null,
            "state": "Vermont"
        },
        {
            "abbr": "VA",
            "city": "Abingdon",
            "id": 1801,
            "is_region": null,
            "is_state": false,
            "lat": 36.7097,
            "long": -81.9756,
            "name": "Abingdon, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Alexandria",
            "id": 1802,
            "is_region": null,
            "is_state": false,
            "lat": 38.8047,
            "long": -77.0472,
            "name": "Alexandria, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Bristol",
            "id": 1803,
            "is_region": null,
            "is_state": false,
            "lat": 36.6,
            "long": -82.183,
            "name": "Bristol, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Charlottesville",
            "id": 1804,
            "is_region": null,
            "is_state": false,
            "lat": 38.03,
            "long": -78.4789,
            "name": "Charlottesville, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Chesapeake",
            "id": 1805,
            "is_region": null,
            "is_state": false,
            "lat": 36.7142,
            "long": -76.2383,
            "name": "Chesapeake, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Danville",
            "id": 1806,
            "is_region": null,
            "is_state": false,
            "lat": 36.5872,
            "long": -79.4044,
            "name": "Danville, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Fairfax",
            "id": 1807,
            "is_region": null,
            "is_state": false,
            "lat": 38.8525,
            "long": -77.3042,
            "name": "Fairfax, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Falls Church",
            "id": 1808,
            "is_region": null,
            "is_state": false,
            "lat": 38.8858,
            "long": -77.1722,
            "name": "Falls Church, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Fredericksburg",
            "id": 1809,
            "is_region": null,
            "is_state": false,
            "lat": 38.3018,
            "long": -77.4708,
            "name": "Fredericksburg, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Hampton",
            "id": 1810,
            "is_region": null,
            "is_state": false,
            "lat": 37.0347,
            "long": -76.36,
            "name": "Hampton, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Hanover",
            "id": 1811,
            "is_region": null,
            "is_state": false,
            "lat": 37.7661,
            "long": -77.37,
            "name": "Hanover, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Hopewell",
            "id": 1812,
            "is_region": null,
            "is_state": false,
            "lat": 37.2903,
            "long": -77.305,
            "name": "Hopewell, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Lexington",
            "id": 1813,
            "is_region": null,
            "is_state": false,
            "lat": 37.7839,
            "long": -79.4428,
            "name": "Lexington, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Lynchburg",
            "id": 1814,
            "is_region": null,
            "is_state": false,
            "lat": 37.4036,
            "long": -79.17,
            "name": "Lynchburg, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Manassas",
            "id": 1815,
            "is_region": null,
            "is_state": false,
            "lat": 38.7514,
            "long": -77.4764,
            "name": "Manassas, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Martinsville",
            "id": 1816,
            "is_region": null,
            "is_state": false,
            "lat": 36.6861,
            "long": -79.8692,
            "name": "Martinsville, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "New Market",
            "id": 1817,
            "is_region": null,
            "is_state": false,
            "lat": 38.6444,
            "long": -78.6733,
            "name": "New Market, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Newport News",
            "id": 1818,
            "is_region": null,
            "is_state": false,
            "lat": 37.0708,
            "long": -76.4844,
            "name": "Newport News, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Norfolk",
            "id": 1819,
            "is_region": null,
            "is_state": false,
            "lat": 36.917,
            "long": -76.2,
            "name": "Norfolk, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Petersburg",
            "id": 1820,
            "is_region": null,
            "is_state": false,
            "lat": 37.2128,
            "long": -77.4003,
            "name": "Petersburg, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Portsmouth",
            "id": 1821,
            "is_region": null,
            "is_state": false,
            "lat": 36.8344,
            "long": -76.3417,
            "name": "Portsmouth, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Reston",
            "id": 1822,
            "is_region": null,
            "is_state": false,
            "lat": 38.9544,
            "long": -77.3464,
            "name": "Reston, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Richmond",
            "id": 1823,
            "is_region": null,
            "is_state": false,
            "lat": 37.533,
            "long": -77.467,
            "name": "Richmond, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Roanoke",
            "id": 1824,
            "is_region": null,
            "is_state": false,
            "lat": 37.2708,
            "long": -79.9417,
            "name": "Roanoke, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Staunton",
            "id": 1825,
            "is_region": null,
            "is_state": false,
            "lat": 38.1581,
            "long": -79.0764,
            "name": "Staunton, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Suffolk",
            "id": 1826,
            "is_region": null,
            "is_state": false,
            "lat": 36.7411,
            "long": -76.6097,
            "name": "Suffolk, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Virginia Beach",
            "id": 1827,
            "is_region": null,
            "is_state": false,
            "lat": 36.8506,
            "long": -75.9779,
            "name": "Virginia Beach, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Waynesboro",
            "id": 1828,
            "is_region": null,
            "is_state": false,
            "lat": 38.07,
            "long": -78.8944,
            "name": "Waynesboro, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Williamsburg",
            "id": 1829,
            "is_region": null,
            "is_state": false,
            "lat": 37.2708,
            "long": -76.7069,
            "name": "Williamsburg, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "VA",
            "city": "Winchester",
            "id": 1830,
            "is_region": null,
            "is_state": false,
            "lat": 39.183,
            "long": -78.167,
            "name": "Winchester, VA",
            "region_id": null,
            "state": "Virginia"
        },
        {
            "abbr": "WA",
            "city": "Aberdeen",
            "id": 1831,
            "is_region": null,
            "is_state": false,
            "lat": 46.9758,
            "long": -123.819,
            "name": "Aberdeen, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Anacortes",
            "id": 1832,
            "is_region": null,
            "is_state": false,
            "lat": 48.5019,
            "long": -122.624,
            "name": "Anacortes, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Auburn",
            "id": 1833,
            "is_region": null,
            "is_state": false,
            "lat": 47.3022,
            "long": -122.215,
            "name": "Auburn, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Bellevue",
            "id": 1834,
            "is_region": null,
            "is_state": false,
            "lat": 47.6,
            "long": -122.167,
            "name": "Bellevue, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Bellingham",
            "id": 1835,
            "is_region": null,
            "is_state": false,
            "lat": 48.7503,
            "long": -122.475,
            "name": "Bellingham, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Bremerton",
            "id": 1836,
            "is_region": null,
            "is_state": false,
            "lat": 47.57,
            "long": -122.652,
            "name": "Bremerton, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Centralia",
            "id": 1837,
            "is_region": null,
            "is_state": false,
            "lat": 46.7206,
            "long": -122.961,
            "name": "Centralia, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Coulee Dam",
            "id": 1838,
            "is_region": null,
            "is_state": false,
            "lat": 47.9683,
            "long": -118.978,
            "name": "Coulee Dam, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Coupeville",
            "id": 1839,
            "is_region": null,
            "is_state": false,
            "lat": 48.2183,
            "long": -122.684,
            "name": "Coupeville, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Ellensburg",
            "id": 1840,
            "is_region": null,
            "is_state": false,
            "lat": 46.9969,
            "long": -120.545,
            "name": "Ellensburg, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Ephrata",
            "id": 1841,
            "is_region": null,
            "is_state": false,
            "lat": 47.3169,
            "long": -119.548,
            "name": "Ephrata, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Everett",
            "id": 1842,
            "is_region": null,
            "is_state": false,
            "lat": 47.9633,
            "long": -122.201,
            "name": "Everett, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Hoquiam",
            "id": 1843,
            "is_region": null,
            "is_state": false,
            "lat": 46.9803,
            "long": -123.886,
            "name": "Hoquiam, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Kelso",
            "id": 1844,
            "is_region": null,
            "is_state": false,
            "lat": 46.1419,
            "long": -122.906,
            "name": "Kelso, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Kennewick",
            "id": 1845,
            "is_region": null,
            "is_state": false,
            "lat": 46.2036,
            "long": -119.159,
            "name": "Kennewick, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Longview",
            "id": 1846,
            "is_region": null,
            "is_state": false,
            "lat": 46.1428,
            "long": -122.956,
            "name": "Longview, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Moses Lake",
            "id": 1847,
            "is_region": null,
            "is_state": false,
            "lat": 47.1211,
            "long": -119.288,
            "name": "Moses Lake, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Oak Harbor",
            "id": 1848,
            "is_region": null,
            "is_state": false,
            "lat": 48.295,
            "long": -122.659,
            "name": "Oak Harbor, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Olympia",
            "id": 1849,
            "is_region": null,
            "is_state": false,
            "lat": 47.0425,
            "long": -122.893,
            "name": "Olympia, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Pasco",
            "id": 1850,
            "is_region": null,
            "is_state": false,
            "lat": 46.2386,
            "long": -119.109,
            "name": "Pasco, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Point Roberts",
            "id": 1851,
            "is_region": null,
            "is_state": false,
            "lat": 48.9847,
            "long": -123.068,
            "name": "Point Roberts, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Port Angeles",
            "id": 1852,
            "is_region": null,
            "is_state": false,
            "lat": 48.1131,
            "long": -123.441,
            "name": "Port Angeles, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Pullman",
            "id": 1853,
            "is_region": null,
            "is_state": false,
            "lat": 46.733,
            "long": -117.167,
            "name": "Pullman, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Puyallup",
            "id": 1854,
            "is_region": null,
            "is_state": false,
            "lat": 47.1758,
            "long": -122.294,
            "name": "Puyallup, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Redmond",
            "id": 1855,
            "is_region": null,
            "is_state": false,
            "lat": 47.6694,
            "long": -122.124,
            "name": "Redmond, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Renton",
            "id": 1856,
            "is_region": null,
            "is_state": false,
            "lat": 47.4867,
            "long": -122.195,
            "name": "Renton, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Richland",
            "id": 1857,
            "is_region": null,
            "is_state": false,
            "lat": 46.2797,
            "long": -119.281,
            "name": "Richland, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Seattle",
            "id": 1858,
            "is_region": null,
            "is_state": false,
            "lat": 47.6097,
            "long": -122.333,
            "name": "Seattle, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Spokane",
            "id": 1859,
            "is_region": null,
            "is_state": false,
            "lat": 47.6589,
            "long": -117.425,
            "name": "Spokane, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Tacoma",
            "id": 1860,
            "is_region": null,
            "is_state": false,
            "lat": 47.2414,
            "long": -122.459,
            "name": "Tacoma, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Vancouver",
            "id": 1861,
            "is_region": null,
            "is_state": false,
            "lat": 45.633,
            "long": -122.6,
            "name": "Vancouver, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Walla Walla",
            "id": 1862,
            "is_region": null,
            "is_state": false,
            "lat": 46.065,
            "long": -118.33,
            "name": "Walla Walla, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Wenatchee",
            "id": 1863,
            "is_region": null,
            "is_state": false,
            "lat": 47.4233,
            "long": -120.325,
            "name": "Wenatchee, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WA",
            "city": "Yakima",
            "id": 1864,
            "is_region": null,
            "is_state": false,
            "lat": 46.6,
            "long": -120.5,
            "name": "Yakima, WA",
            "region_id": null,
            "state": "Washington"
        },
        {
            "abbr": "WV",
            "city": "Bath",
            "id": 1865,
            "is_region": null,
            "is_state": false,
            "lat": 39.6256,
            "long": -78.2269,
            "name": "Bath, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Beckley",
            "id": 1866,
            "is_region": null,
            "is_state": false,
            "lat": 37.7797,
            "long": -81.1831,
            "name": "Beckley, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Bluefield",
            "id": 1867,
            "is_region": null,
            "is_state": false,
            "lat": 37.2622,
            "long": -81.2186,
            "name": "Bluefield, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Buckhannon",
            "id": 1868,
            "is_region": null,
            "is_state": false,
            "lat": 38.9892,
            "long": -80.2242,
            "name": "Buckhannon, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Charles Town",
            "id": 1869,
            "is_region": null,
            "is_state": false,
            "lat": 39.2842,
            "long": -77.8561,
            "name": "Charles Town, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Charleston",
            "id": 1870,
            "is_region": null,
            "is_state": false,
            "lat": 38.3472,
            "long": -81.6333,
            "name": "Charleston, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Clarksburg",
            "id": 1871,
            "is_region": null,
            "is_state": false,
            "lat": 39.283,
            "long": -80.35,
            "name": "Clarksburg, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Elkins",
            "id": 1872,
            "is_region": null,
            "is_state": false,
            "lat": 38.9214,
            "long": -79.8508,
            "name": "Elkins, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Fairmont",
            "id": 1873,
            "is_region": null,
            "is_state": false,
            "lat": 39.4814,
            "long": -80.1433,
            "name": "Fairmont, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Grafton",
            "id": 1874,
            "is_region": null,
            "is_state": false,
            "lat": 39.3417,
            "long": -80.0197,
            "name": "Grafton, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Harpers Ferry",
            "id": 1875,
            "is_region": null,
            "is_state": false,
            "lat": 39.3242,
            "long": -77.7339,
            "name": "Harpers Ferry, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Hillsboro",
            "id": 1876,
            "is_region": null,
            "is_state": false,
            "lat": 38.1381,
            "long": -80.2125,
            "name": "Hillsboro, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Hinton",
            "id": 1877,
            "is_region": null,
            "is_state": false,
            "lat": 37.6736,
            "long": -80.8889,
            "name": "Hinton, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Huntington",
            "id": 1878,
            "is_region": null,
            "is_state": false,
            "lat": 38.4208,
            "long": -82.4236,
            "name": "Huntington, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Keyser",
            "id": 1879,
            "is_region": null,
            "is_state": false,
            "lat": 39.4389,
            "long": -78.9828,
            "name": "Keyser, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Lewisburg",
            "id": 1880,
            "is_region": null,
            "is_state": false,
            "lat": 37.8042,
            "long": -80.4403,
            "name": "Lewisburg, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Logan",
            "id": 1881,
            "is_region": null,
            "is_state": false,
            "lat": 37.8483,
            "long": -81.9878,
            "name": "Logan, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Martinsburg",
            "id": 1882,
            "is_region": null,
            "is_state": false,
            "lat": 39.4592,
            "long": -77.9678,
            "name": "Martinsburg, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Morgantown",
            "id": 1883,
            "is_region": null,
            "is_state": false,
            "lat": 39.6336,
            "long": -79.9506,
            "name": "Morgantown, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Moundsville",
            "id": 1884,
            "is_region": null,
            "is_state": false,
            "lat": 39.9214,
            "long": -80.7394,
            "name": "Moundsville, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "New Martinsville",
            "id": 1885,
            "is_region": null,
            "is_state": false,
            "lat": 39.6575,
            "long": -80.8594,
            "name": "New Martinsville, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Parkersburg",
            "id": 1886,
            "is_region": null,
            "is_state": false,
            "lat": 39.2661,
            "long": -81.5422,
            "name": "Parkersburg, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Philippi",
            "id": 1887,
            "is_region": null,
            "is_state": false,
            "lat": 39.1517,
            "long": -80.0433,
            "name": "Philippi, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Point Pleasant",
            "id": 1888,
            "is_region": null,
            "is_state": false,
            "lat": 38.8575,
            "long": -82.1286,
            "name": "Point Pleasant, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Princeton",
            "id": 1889,
            "is_region": null,
            "is_state": false,
            "lat": 37.3681,
            "long": -81.0958,
            "name": "Princeton, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Romney",
            "id": 1890,
            "is_region": null,
            "is_state": false,
            "lat": 39.345,
            "long": -78.7569,
            "name": "Romney, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Shepherdstown",
            "id": 1891,
            "is_region": null,
            "is_state": false,
            "lat": 39.4319,
            "long": -77.8061,
            "name": "Shepherdstown, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "South Charleston",
            "id": 1892,
            "is_region": null,
            "is_state": false,
            "lat": 38.3525,
            "long": -81.7119,
            "name": "South Charleston, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Summersville",
            "id": 1893,
            "is_region": null,
            "is_state": false,
            "lat": 38.2833,
            "long": -80.8442,
            "name": "Summersville, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Weirton",
            "id": 1894,
            "is_region": null,
            "is_state": false,
            "lat": 40.417,
            "long": -80.583,
            "name": "Weirton, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Welch",
            "id": 1895,
            "is_region": null,
            "is_state": false,
            "lat": 37.4372,
            "long": -81.5789,
            "name": "Welch, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Wellsburg",
            "id": 1896,
            "is_region": null,
            "is_state": false,
            "lat": 40.2775,
            "long": -80.6094,
            "name": "Wellsburg, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Weston",
            "id": 1897,
            "is_region": null,
            "is_state": false,
            "lat": 39.0419,
            "long": -80.47,
            "name": "Weston, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Wheeling",
            "id": 1898,
            "is_region": null,
            "is_state": false,
            "lat": 40.0703,
            "long": -80.6986,
            "name": "Wheeling, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "White Sulphur Springs",
            "id": 1899,
            "is_region": null,
            "is_state": false,
            "lat": 37.7939,
            "long": -80.3036,
            "name": "White Sulphur Springs, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WV",
            "city": "Williamson",
            "id": 1900,
            "is_region": null,
            "is_state": false,
            "lat": 37.6739,
            "long": -82.2797,
            "name": "Williamson, WV",
            "region_id": null,
            "state": "West Virginia"
        },
        {
            "abbr": "WI",
            "city": "Appleton",
            "id": 1901,
            "is_region": null,
            "is_state": false,
            "lat": 44.267,
            "long": -88.4,
            "name": "Appleton, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Ashland",
            "id": 1902,
            "is_region": null,
            "is_state": false,
            "lat": 46.59,
            "long": -90.88,
            "name": "Ashland, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Baraboo",
            "id": 1903,
            "is_region": null,
            "is_state": false,
            "lat": 43.4681,
            "long": -89.7417,
            "name": "Baraboo, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Belmont",
            "id": 1904,
            "is_region": null,
            "is_state": false,
            "lat": 42.7581,
            "long": -90.365,
            "name": "Belmont, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Beloit",
            "id": 1905,
            "is_region": null,
            "is_state": false,
            "lat": 42.5083,
            "long": -89.0317,
            "name": "Beloit, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Eau Claire",
            "id": 1906,
            "is_region": null,
            "is_state": false,
            "lat": 44.817,
            "long": -91.5,
            "name": "Eau Claire, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Fond du Lac",
            "id": 1907,
            "is_region": null,
            "is_state": false,
            "lat": 43.767,
            "long": -88.45,
            "name": "Fond du Lac, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Green Bay",
            "id": 1908,
            "is_region": null,
            "is_state": false,
            "lat": 44.5133,
            "long": -88.0158,
            "name": "Green Bay, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Hayward",
            "id": 1909,
            "is_region": null,
            "is_state": false,
            "lat": 46.01,
            "long": -91.4806,
            "name": "Hayward, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Janesville",
            "id": 1910,
            "is_region": null,
            "is_state": false,
            "lat": 42.6839,
            "long": -89.0164,
            "name": "Janesville, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Kenosha",
            "id": 1911,
            "is_region": null,
            "is_state": false,
            "lat": 42.5822,
            "long": -87.8456,
            "name": "Kenosha, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "La Crosse",
            "id": 1912,
            "is_region": null,
            "is_state": false,
            "lat": 43.8133,
            "long": -91.2331,
            "name": "La Crosse, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Lake Geneva",
            "id": 1913,
            "is_region": null,
            "is_state": false,
            "lat": 42.5925,
            "long": -88.4344,
            "name": "Lake Geneva, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Madison",
            "id": 1914,
            "is_region": null,
            "is_state": false,
            "lat": 43.067,
            "long": -89.4,
            "name": "Madison, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Manitowoc",
            "id": 1915,
            "is_region": null,
            "is_state": false,
            "lat": 44.0964,
            "long": -87.675,
            "name": "Manitowoc, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Marinette",
            "id": 1916,
            "is_region": null,
            "is_state": false,
            "lat": 45.1,
            "long": -87.6306,
            "name": "Marinette, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Menasha",
            "id": 1917,
            "is_region": null,
            "is_state": false,
            "lat": 44.217,
            "long": -88.433,
            "name": "Menasha, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Milwaukee",
            "id": 1918,
            "is_region": null,
            "is_state": false,
            "lat": 43.0522,
            "long": -87.9558,
            "name": "Milwaukee, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Neenah",
            "id": 1919,
            "is_region": null,
            "is_state": false,
            "lat": 44.1742,
            "long": -88.4686,
            "name": "Neenah, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "New Glarus",
            "id": 1920,
            "is_region": null,
            "is_state": false,
            "lat": 42.8138,
            "long": -89.6354,
            "name": "New Glarus, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Oconto",
            "id": 1921,
            "is_region": null,
            "is_state": false,
            "lat": 44.883,
            "long": -87.867,
            "name": "Oconto, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Oshkosh",
            "id": 1922,
            "is_region": null,
            "is_state": false,
            "lat": 44.0247,
            "long": -88.5511,
            "name": "Oshkosh, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Peshtigo",
            "id": 1923,
            "is_region": null,
            "is_state": false,
            "lat": 45.0539,
            "long": -87.7461,
            "name": "Peshtigo, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Portage",
            "id": 1924,
            "is_region": null,
            "is_state": false,
            "lat": 43.55,
            "long": -89.467,
            "name": "Portage, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Prairie du Chien",
            "id": 1925,
            "is_region": null,
            "is_state": false,
            "lat": 43.0517,
            "long": -91.1414,
            "name": "Prairie du Chien, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Racine",
            "id": 1926,
            "is_region": null,
            "is_state": false,
            "lat": 42.7261,
            "long": -87.8058,
            "name": "Racine, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Rhinelander",
            "id": 1927,
            "is_region": null,
            "is_state": false,
            "lat": 45.6394,
            "long": -89.4122,
            "name": "Rhinelander, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Ripon",
            "id": 1928,
            "is_region": null,
            "is_state": false,
            "lat": 43.845,
            "long": -88.8397,
            "name": "Ripon, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Sheboygan",
            "id": 1929,
            "is_region": null,
            "is_state": false,
            "lat": 43.75,
            "long": -87.725,
            "name": "Sheboygan, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Spring Green",
            "id": 1930,
            "is_region": null,
            "is_state": false,
            "lat": 43.1839,
            "long": -90.1033,
            "name": "Spring Green, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Stevens Point",
            "id": 1931,
            "is_region": null,
            "is_state": false,
            "lat": 44.5231,
            "long": -89.5603,
            "name": "Stevens Point, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Sturgeon Bay",
            "id": 1932,
            "is_region": null,
            "is_state": false,
            "lat": 44.8323,
            "long": -87.3721,
            "name": "Sturgeon Bay, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Superior",
            "id": 1933,
            "is_region": null,
            "is_state": false,
            "lat": 46.7069,
            "long": -92.0853,
            "name": "Superior, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Waukesha",
            "id": 1934,
            "is_region": null,
            "is_state": false,
            "lat": 43.0117,
            "long": -88.2317,
            "name": "Waukesha, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Wausau",
            "id": 1935,
            "is_region": null,
            "is_state": false,
            "lat": 44.95,
            "long": -89.633,
            "name": "Wausau, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Wauwatosa",
            "id": 1936,
            "is_region": null,
            "is_state": false,
            "lat": 43.067,
            "long": -88.033,
            "name": "Wauwatosa, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "West Allis",
            "id": 1937,
            "is_region": null,
            "is_state": false,
            "lat": 43.0081,
            "long": -88.0183,
            "name": "West Allis, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "West Bend",
            "id": 1938,
            "is_region": null,
            "is_state": false,
            "lat": 43.42,
            "long": -88.18,
            "name": "West Bend, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WI",
            "city": "Wisconsin Dells",
            "id": 1939,
            "is_region": null,
            "is_state": false,
            "lat": 43.6374,
            "long": -89.7788,
            "name": "Wisconsin Dells, WI",
            "region_id": null,
            "state": "Wisconsin"
        },
        {
            "abbr": "WY",
            "city": "Buffalo",
            "id": 1940,
            "is_region": null,
            "is_state": false,
            "lat": 44.3475,
            "long": -106.701,
            "name": "Buffalo, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Casper",
            "id": 1941,
            "is_region": null,
            "is_state": false,
            "lat": 42.85,
            "long": -106.325,
            "name": "Casper, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Cheyenne",
            "id": 1942,
            "is_region": null,
            "is_state": false,
            "lat": 41.1456,
            "long": -104.802,
            "name": "Cheyenne, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Cody",
            "id": 1943,
            "is_region": null,
            "is_state": false,
            "lat": 44.5233,
            "long": -109.057,
            "name": "Cody, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Douglas",
            "id": 1944,
            "is_region": null,
            "is_state": false,
            "lat": 42.7561,
            "long": -105.384,
            "name": "Douglas, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Evanston",
            "id": 1945,
            "is_region": null,
            "is_state": false,
            "lat": 41.2633,
            "long": -110.965,
            "name": "Evanston, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Gillette",
            "id": 1946,
            "is_region": null,
            "is_state": false,
            "lat": 44.2828,
            "long": -105.505,
            "name": "Gillette, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Green River",
            "id": 1947,
            "is_region": null,
            "is_state": false,
            "lat": 41.5142,
            "long": -109.465,
            "name": "Green River, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Jackson",
            "id": 1948,
            "is_region": null,
            "is_state": false,
            "lat": 43.4753,
            "long": -110.769,
            "name": "Jackson, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Lander",
            "id": 1949,
            "is_region": null,
            "is_state": false,
            "lat": 42.8331,
            "long": -108.732,
            "name": "Lander, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Laramie",
            "id": 1950,
            "is_region": null,
            "is_state": false,
            "lat": 41.317,
            "long": -105.583,
            "name": "Laramie, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Newcastle",
            "id": 1951,
            "is_region": null,
            "is_state": false,
            "lat": 43.8531,
            "long": -104.209,
            "name": "Newcastle, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Powell",
            "id": 1952,
            "is_region": null,
            "is_state": false,
            "lat": 44.7589,
            "long": -108.758,
            "name": "Powell, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Rawlins",
            "id": 1953,
            "is_region": null,
            "is_state": false,
            "lat": 41.7903,
            "long": -107.234,
            "name": "Rawlins, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Riverton",
            "id": 1954,
            "is_region": null,
            "is_state": false,
            "lat": 43.0278,
            "long": -108.395,
            "name": "Riverton, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Rock Springs",
            "id": 1955,
            "is_region": null,
            "is_state": false,
            "lat": 41.5908,
            "long": -109.223,
            "name": "Rock Springs, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Sheridan",
            "id": 1956,
            "is_region": null,
            "is_state": false,
            "lat": 44.7967,
            "long": -106.959,
            "name": "Sheridan, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Ten Sleep",
            "id": 1957,
            "is_region": null,
            "is_state": false,
            "lat": 44.0347,
            "long": -107.448,
            "name": "Ten Sleep, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Thermopolis",
            "id": 1958,
            "is_region": null,
            "is_state": false,
            "lat": 43.6456,
            "long": -108.215,
            "name": "Thermopolis, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Torrington",
            "id": 1959,
            "is_region": null,
            "is_state": false,
            "lat": 42.0667,
            "long": -104.183,
            "name": "Torrington, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "WY",
            "city": "Worland",
            "id": 1960,
            "is_region": null,
            "is_state": false,
            "lat": 44.0167,
            "long": -107.958,
            "name": "Worland, WY",
            "region_id": null,
            "state": "Wyoming"
        },
        {
            "abbr": "AL",
            "city": "Alabama",
            "id": 2485,
            "is_region": null,
            "is_state": true,
            "lat": 32.799,
            "long": -86.8073,
            "name": "Alabama",
            "region_id": 2537,
            "state": "Alabama"
        },
        {
            "abbr": "AK",
            "city": "Alaska",
            "id": 2486,
            "is_region": null,
            "is_state": true,
            "lat": 61.385,
            "long": -152.268,
            "name": "Alaska",
            "region_id": 2535,
            "state": "Alaska"
        },
        {
            "abbr": "AZ",
            "city": "Arizona",
            "id": 2487,
            "is_region": null,
            "is_state": true,
            "lat": 33.7712,
            "long": -111.388,
            "name": "Arizona",
            "region_id": 2538,
            "state": "Arizona"
        },
        {
            "abbr": "AR",
            "city": "Arkansas",
            "id": 2488,
            "is_region": null,
            "is_state": true,
            "lat": 34.9513,
            "long": -92.3809,
            "name": "Arkansas",
            "region_id": 2537,
            "state": "Arkansas"
        },
        {
            "abbr": "CA",
            "city": "California",
            "id": 2489,
            "is_region": null,
            "is_state": true,
            "lat": 36.17,
            "long": -119.746,
            "name": "California",
            "region_id": 2535,
            "state": "California"
        },
        {
            "abbr": "CO",
            "city": "Colorado",
            "id": 2490,
            "is_region": null,
            "is_state": true,
            "lat": 39.0646,
            "long": -105.327,
            "name": "Colorado",
            "region_id": 2535,
            "state": "Colorado"
        },
        {
            "abbr": "CT",
            "city": "Connecticut",
            "id": 2491,
            "is_region": null,
            "is_state": true,
            "lat": 41.5834,
            "long": -72.7622,
            "name": "Connecticut",
            "region_id": 2536,
            "state": "Connecticut"
        },
        {
            "abbr": "DE",
            "city": "Delaware",
            "id": 2492,
            "is_region": null,
            "is_state": true,
            "lat": 39.3498,
            "long": -75.5148,
            "name": "Delaware",
            "region_id": 2536,
            "state": "Delaware"
        },
        {
            "abbr": "FL",
            "city": "Florida",
            "id": 2493,
            "is_region": null,
            "is_state": true,
            "lat": 27.8333,
            "long": -81.717,
            "name": "Florida",
            "region_id": 2537,
            "state": "Florida"
        },
        {
            "abbr": "GA",
            "city": "Georgia",
            "id": 2494,
            "is_region": null,
            "is_state": true,
            "lat": 32.9866,
            "long": -83.6487,
            "name": "Georgia",
            "region_id": 2537,
            "state": "Georgia"
        },
        {
            "abbr": "HI",
            "city": "Hawaii",
            "id": 2495,
            "is_region": null,
            "is_state": true,
            "lat": 21.1098,
            "long": -157.531,
            "name": "Hawaii",
            "region_id": 2535,
            "state": "Hawaii"
        },
        {
            "abbr": "ID",
            "city": "Idaho",
            "id": 2496,
            "is_region": null,
            "is_state": true,
            "lat": 44.2394,
            "long": -114.51,
            "name": "Idaho",
            "region_id": 2535,
            "state": "Idaho"
        },
        {
            "abbr": "IL",
            "city": "Illinois",
            "id": 2497,
            "is_region": null,
            "is_state": true,
            "lat": 40.3363,
            "long": -89.0022,
            "name": "Illinois",
            "region_id": 2539,
            "state": "Illinois"
        },
        {
            "abbr": "IN",
            "city": "Indiana",
            "id": 2498,
            "is_region": null,
            "is_state": true,
            "lat": 39.8647,
            "long": -86.2604,
            "name": "Indiana",
            "region_id": 2539,
            "state": "Indiana"
        },
        {
            "abbr": "IA",
            "city": "Iowa",
            "id": 2499,
            "is_region": null,
            "is_state": true,
            "lat": 42.0046,
            "long": -93.214,
            "name": "Iowa",
            "region_id": 2539,
            "state": "Iowa"
        },
        {
            "abbr": "KS",
            "city": "Kansas",
            "id": 2500,
            "is_region": null,
            "is_state": true,
            "lat": 38.5111,
            "long": -96.8005,
            "name": "Kansas",
            "region_id": 2539,
            "state": "Kansas"
        },
        {
            "abbr": "KY",
            "city": "Kentucky",
            "id": 2501,
            "is_region": null,
            "is_state": true,
            "lat": 37.669,
            "long": -84.6514,
            "name": "Kentucky",
            "region_id": 2537,
            "state": "Kentucky"
        },
        {
            "abbr": "LA",
            "city": "Louisiana",
            "id": 2502,
            "is_region": null,
            "is_state": true,
            "lat": 31.1801,
            "long": -91.8749,
            "name": "Louisiana",
            "region_id": 2537,
            "state": "Louisiana"
        },
        {
            "abbr": "ME",
            "city": "Maine",
            "id": 2503,
            "is_region": null,
            "is_state": true,
            "lat": 44.6074,
            "long": -69.3977,
            "name": "Maine",
            "region_id": 2536,
            "state": "Maine"
        },
        {
            "abbr": "MD",
            "city": "Maryland",
            "id": 2504,
            "is_region": null,
            "is_state": true,
            "lat": 39.0724,
            "long": -76.7902,
            "name": "Maryland",
            "region_id": 2536,
            "state": "Maryland"
        },
        {
            "abbr": "MA",
            "city": "Massachusetts",
            "id": 2505,
            "is_region": null,
            "is_state": true,
            "lat": 42.2373,
            "long": -71.5314,
            "name": "Massachusetts",
            "region_id": 2536,
            "state": "Massachusetts"
        },
        {
            "abbr": "MI",
            "city": "Michigan",
            "id": 2506,
            "is_region": null,
            "is_state": true,
            "lat": 43.3504,
            "long": -84.5603,
            "name": "Michigan",
            "region_id": 2539,
            "state": "Michigan"
        },
        {
            "abbr": "MN",
            "city": "Minnesota",
            "id": 2507,
            "is_region": null,
            "is_state": true,
            "lat": 45.7326,
            "long": -93.9196,
            "name": "Minnesota",
            "region_id": 2539,
            "state": "Minnesota"
        },
        {
            "abbr": "MS",
            "city": "Mississippi",
            "id": 2508,
            "is_region": null,
            "is_state": true,
            "lat": 32.7673,
            "long": -89.6812,
            "name": "Mississippi",
            "region_id": 2537,
            "state": "Mississippi"
        },
        {
            "abbr": "MO",
            "city": "Missouri",
            "id": 2509,
            "is_region": null,
            "is_state": true,
            "lat": 38.4623,
            "long": -92.302,
            "name": "Missouri",
            "region_id": 2539,
            "state": "Missouri"
        },
        {
            "abbr": "MT",
            "city": "Montana",
            "id": 2510,
            "is_region": null,
            "is_state": true,
            "lat": 46.9048,
            "long": -110.326,
            "name": "Montana",
            "region_id": 2535,
            "state": "Montana"
        },
        {
            "abbr": "NE",
            "city": "Nebraska",
            "id": 2511,
            "is_region": null,
            "is_state": true,
            "lat": 41.1289,
            "long": -98.2883,
            "name": "Nebraska",
            "region_id": 2539,
            "state": "Nebraska"
        },
        {
            "abbr": "NV",
            "city": "Nevada",
            "id": 2512,
            "is_region": null,
            "is_state": true,
            "lat": 38.4199,
            "long": -117.122,
            "name": "Nevada",
            "region_id": 2535,
            "state": "Nevada"
        },
        {
            "abbr": "NH",
            "city": "New Hampshire",
            "id": 2513,
            "is_region": null,
            "is_state": true,
            "lat": 43.4108,
            "long": -71.5653,
            "name": "New Hampshire",
            "region_id": 2536,
            "state": "New Hampshire"
        },
        {
            "abbr": "NJ",
            "city": "New Jersey",
            "id": 2514,
            "is_region": null,
            "is_state": true,
            "lat": 40.314,
            "long": -74.5089,
            "name": "New Jersey",
            "region_id": 2536,
            "state": "New Jersey"
        },
        {
            "abbr": "NM",
            "city": "New Mexico",
            "id": 2515,
            "is_region": null,
            "is_state": true,
            "lat": 34.8375,
            "long": -106.237,
            "name": "New Mexico",
            "region_id": 2538,
            "state": "New Mexico"
        },
        {
            "abbr": "NY",
            "city": "New York",
            "id": 2516,
            "is_region": null,
            "is_state": true,
            "lat": 42.1497,
            "long": -74.9384,
            "name": "New York",
            "region_id": 2536,
            "state": "New York"
        },
        {
            "abbr": "NC",
            "city": "North Carolina",
            "id": 2517,
            "is_region": null,
            "is_state": true,
            "lat": 35.6411,
            "long": -79.8431,
            "name": "North Carolina",
            "region_id": 2537,
            "state": "North Carolina"
        },
        {
            "abbr": "ND",
            "city": "North Dakota",
            "id": 2518,
            "is_region": null,
            "is_state": true,
            "lat": 47.5362,
            "long": -99.793,
            "name": "North Dakota",
            "region_id": 2539,
            "state": "North Dakota"
        },
        {
            "abbr": "OH",
            "city": "Ohio",
            "id": 2519,
            "is_region": null,
            "is_state": true,
            "lat": 40.3736,
            "long": -82.7755,
            "name": "Ohio",
            "region_id": 2539,
            "state": "Ohio"
        },
        {
            "abbr": "OK",
            "city": "Oklahoma",
            "id": 2520,
            "is_region": null,
            "is_state": true,
            "lat": 35.5376,
            "long": -96.9247,
            "name": "Oklahoma",
            "region_id": 2538,
            "state": "Oklahoma"
        },
        {
            "abbr": "OR",
            "city": "Oregon",
            "id": 2521,
            "is_region": null,
            "is_state": true,
            "lat": 44.5672,
            "long": -122.127,
            "name": "Oregon",
            "region_id": 2535,
            "state": "Oregon"
        },
        {
            "abbr": "PA",
            "city": "Pennsylvania",
            "id": 2522,
            "is_region": null,
            "is_state": true,
            "lat": 40.5773,
            "long": -77.264,
            "name": "Pennsylvania",
            "region_id": 2536,
            "state": "Pennsylvania"
        },
        {
            "abbr": "RI",
            "city": "Rhode Island",
            "id": 2523,
            "is_region": null,
            "is_state": true,
            "lat": 41.6772,
            "long": -71.5101,
            "name": "Rhode Island",
            "region_id": 2536,
            "state": "Rhode Island"
        },
        {
            "abbr": "SC",
            "city": "South Carolina",
            "id": 2524,
            "is_region": null,
            "is_state": true,
            "lat": 33.8191,
            "long": -80.9066,
            "name": "South Carolina",
            "region_id": 2537,
            "state": "South Carolina"
        },
        {
            "abbr": "SD",
            "city": "South Dakota",
            "id": 2525,
            "is_region": null,
            "is_state": true,
            "lat": 44.2853,
            "long": -99.4632,
            "name": "South Dakota",
            "region_id": 2539,
            "state": "South Dakota"
        },
        {
            "abbr": "TN",
            "city": "Tennessee",
            "id": 2526,
            "is_region": null,
            "is_state": true,
            "lat": 35.7449,
            "long": -86.7489,
            "name": "Tennessee",
            "region_id": 2537,
            "state": "Tennessee"
        },
        {
            "abbr": "TX",
            "city": "Texas",
            "id": 2527,
            "is_region": null,
            "is_state": true,
            "lat": 31.106,
            "long": -97.6475,
            "name": "Texas",
            "region_id": 2538,
            "state": "Texas"
        },
        {
            "abbr": "UT",
            "city": "Utah",
            "id": 2528,
            "is_region": null,
            "is_state": true,
            "lat": 40.1135,
            "long": -111.854,
            "name": "Utah",
            "region_id": 2535,
            "state": "Utah"
        },
        {
            "abbr": "VT",
            "city": "Vermont",
            "id": 2529,
            "is_region": null,
            "is_state": true,
            "lat": 44.0407,
            "long": -72.7093,
            "name": "Vermont",
            "region_id": 2536,
            "state": "Vermont"
        },
        {
            "abbr": "VA",
            "city": "Virginia",
            "id": 2530,
            "is_region": null,
            "is_state": true,
            "lat": 37.768,
            "long": -78.2057,
            "name": "Virginia",
            "region_id": 2537,
            "state": "Virginia"
        },
        {
            "abbr": "WA",
            "city": "Washington",
            "id": 2531,
            "is_region": null,
            "is_state": true,
            "lat": 47.3917,
            "long": -121.571,
            "name": "Washington",
            "region_id": 2535,
            "state": "Washington"
        },
        {
            "abbr": "WV",
            "city": "West Virginia",
            "id": 2532,
            "is_region": null,
            "is_state": true,
            "lat": 38.468,
            "long": -80.9696,
            "name": "West Virginia",
            "region_id": 2537,
            "state": "West Virginia"
        },
        {
            "abbr": "WI",
            "city": "Wisconsin",
            "id": 2533,
            "is_region": null,
            "is_state": true,
            "lat": 44.2563,
            "long": -89.6385,
            "name": "Wisconsin",
            "region_id": 2539,
            "state": "Wisconsin"
        },
        {
            "abbr": "WY",
            "city": "Wyoming",
            "id": 2534,
            "is_region": null,
            "is_state": true,
            "lat": 42.7475,
            "long": -107.209,
            "name": "Wyoming",
            "region_id": 2535,
            "state": "Wyoming"
        },
        {
            "abbr": null,
            "city": "West",
            "id": 2535,
            "is_region": true,
            "is_state": false,
            "lat": null,
            "long": null,
            "name": "West",
            "region_id": null,
            "state": null
        },
        {
            "abbr": null,
            "city": "Northeast",
            "id": 2536,
            "is_region": true,
            "is_state": false,
            "lat": null,
            "long": null,
            "name": "Northeast",
            "region_id": null,
            "state": null
        },
        {
            "abbr": null,
            "city": "Southeast",
            "id": 2537,
            "is_region": true,
            "is_state": false,
            "lat": null,
            "long": null,
            "name": "Southeast",
            "region_id": null,
            "state": null
        },
        {
            "abbr": null,
            "city": "Southwest",
            "id": 2538,
            "is_region": true,
            "is_state": false,
            "lat": null,
            "long": null,
            "name": "Southwest",
            "region_id": null,
            "state": null
        },
        {
            "abbr": null,
            "city": "Midwest",
            "id": 2539,
            "is_region": true,
            "is_state": false,
            "lat": null,
            "long": null,
            "name": "Midwest",
            "region_id": null,
            "state": null
        }
    ],
    "count": 2015,
    "message": "success",
    "status": 201
}